
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
"use strict";
"use strict";
var $ca3e1754e676956d$exports = {};
"use strict";
var $55b335199d6e6d5d$exports = {};
"use strict";
var $55b335199d6e6d5d$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$55b335199d6e6d5d$exports = // eslint-disable-next-line es/no-global-this -- safe
$55b335199d6e6d5d$var$check(typeof globalThis == "object" && globalThis) || $55b335199d6e6d5d$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$55b335199d6e6d5d$var$check(typeof self == "object" && self) || $55b335199d6e6d5d$var$check(typeof $parcel$global == "object" && $parcel$global) || $55b335199d6e6d5d$var$check(typeof $55b335199d6e6d5d$exports == "object" && $55b335199d6e6d5d$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $6d99163b6684d050$export$2d1720544b23b823;
"use strict";
var $ef322a7f89c3ed41$exports = {};
"use strict";
var $6140c9fa18232846$exports = {};
"use strict";
$6140c9fa18232846$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$ef322a7f89c3ed41$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $881ad37dbe259e8f$exports = {};
"use strict";
var $bcbe62e89adc7d37$exports = {};
"use strict";

$bcbe62e89adc7d37$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $881ad37dbe259e8f$var$call = Function.prototype.call;
$881ad37dbe259e8f$exports = $bcbe62e89adc7d37$exports ? $881ad37dbe259e8f$var$call.bind($881ad37dbe259e8f$var$call) : function() {
    return $881ad37dbe259e8f$var$call.apply($881ad37dbe259e8f$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $1e0782be6903ea7b$export$2d1720544b23b823;
"use strict";
var $1e0782be6903ea7b$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1e0782be6903ea7b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $1e0782be6903ea7b$var$NASHORN_BUG = $1e0782be6903ea7b$var$getOwnPropertyDescriptor && !$1e0782be6903ea7b$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$1e0782be6903ea7b$export$2d1720544b23b823 = $1e0782be6903ea7b$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $1e0782be6903ea7b$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $1e0782be6903ea7b$var$$propertyIsEnumerable;


var $b66966b48674609b$exports = {};
"use strict";
$b66966b48674609b$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $4d273c9d7e1bdf46$exports = {};
"use strict";
var $8239f4c7c6082668$exports = {};
"use strict";
var $43b18aa2f1faac44$exports = {};
"use strict";

var $43b18aa2f1faac44$var$FunctionPrototype = Function.prototype;
var $43b18aa2f1faac44$var$call = $43b18aa2f1faac44$var$FunctionPrototype.call;
var $43b18aa2f1faac44$var$uncurryThisWithBind = $bcbe62e89adc7d37$exports && $43b18aa2f1faac44$var$FunctionPrototype.bind.bind($43b18aa2f1faac44$var$call, $43b18aa2f1faac44$var$call);
$43b18aa2f1faac44$exports = $bcbe62e89adc7d37$exports ? $43b18aa2f1faac44$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $43b18aa2f1faac44$var$call.apply(fn, arguments);
    };
};



var $b0ba63bfbfb16088$exports = {};
"use strict";

var $b0ba63bfbfb16088$var$toString = $43b18aa2f1faac44$exports({}.toString);
var $b0ba63bfbfb16088$var$stringSlice = $43b18aa2f1faac44$exports("".slice);
$b0ba63bfbfb16088$exports = function(it) {
    return $b0ba63bfbfb16088$var$stringSlice($b0ba63bfbfb16088$var$toString(it), 8, -1);
};


var $8239f4c7c6082668$var$$Object = Object;
var $8239f4c7c6082668$var$split = $43b18aa2f1faac44$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$8239f4c7c6082668$exports = $6140c9fa18232846$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$8239f4c7c6082668$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $b0ba63bfbfb16088$exports(it) === "String" ? $8239f4c7c6082668$var$split(it, "") : $8239f4c7c6082668$var$$Object(it);
} : $8239f4c7c6082668$var$$Object;


var $c378177673193450$exports = {};
"use strict";
var $7ce250ddf7b42d4d$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$7ce250ddf7b42d4d$exports = function(it) {
    return it === null || it === undefined;
};


var $c378177673193450$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$c378177673193450$exports = function(it) {
    if ($7ce250ddf7b42d4d$exports(it)) throw new $c378177673193450$var$$TypeError("Can't call method on " + it);
    return it;
};


$4d273c9d7e1bdf46$exports = function(it) {
    return $8239f4c7c6082668$exports($c378177673193450$exports(it));
};


var $7f19acfe53927f5c$exports = {};
"use strict";
var $8ffb6b36a733d3c0$exports = {};
"use strict";

var $6a130d390db46c8e$exports = {};
"use strict";
var $70e34a5a2021f756$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $70e34a5a2021f756$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$70e34a5a2021f756$exports = typeof $70e34a5a2021f756$var$documentAll == "undefined" && $70e34a5a2021f756$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $70e34a5a2021f756$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


$6a130d390db46c8e$exports = function(it) {
    return typeof it == "object" ? it !== null : $70e34a5a2021f756$exports(it);
};


var $0b429cc7792c7d26$exports = {};
"use strict";
var $a5217dbd1b0d33ce$exports = {};
"use strict";


var $a5217dbd1b0d33ce$var$aFunction = function(argument) {
    return $70e34a5a2021f756$exports(argument) ? argument : undefined;
};
$a5217dbd1b0d33ce$exports = function(namespace, method) {
    return arguments.length < 2 ? $a5217dbd1b0d33ce$var$aFunction($55b335199d6e6d5d$exports[namespace]) : $55b335199d6e6d5d$exports[namespace] && $55b335199d6e6d5d$exports[namespace][method];
};



var $41cc576e850a251e$exports = {};
"use strict";

$41cc576e850a251e$exports = $43b18aa2f1faac44$exports({}.isPrototypeOf);


var $47f18b427c2fbabf$exports = {};
"use strict";
var $4a39565fee8fe980$exports = {};
"use strict";
var $998d968a5e32cd49$exports = {};
"use strict";

var $492c6dc902f2bf18$exports = {};
"use strict";
$492c6dc902f2bf18$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $998d968a5e32cd49$var$process = $55b335199d6e6d5d$exports.process;
var $998d968a5e32cd49$var$Deno = $55b335199d6e6d5d$exports.Deno;
var $998d968a5e32cd49$var$versions = $998d968a5e32cd49$var$process && $998d968a5e32cd49$var$process.versions || $998d968a5e32cd49$var$Deno && $998d968a5e32cd49$var$Deno.version;
var $998d968a5e32cd49$var$v8 = $998d968a5e32cd49$var$versions && $998d968a5e32cd49$var$versions.v8;
var $998d968a5e32cd49$var$match, $998d968a5e32cd49$var$version;
if ($998d968a5e32cd49$var$v8) {
    $998d968a5e32cd49$var$match = $998d968a5e32cd49$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $998d968a5e32cd49$var$version = $998d968a5e32cd49$var$match[0] > 0 && $998d968a5e32cd49$var$match[0] < 4 ? 1 : +($998d968a5e32cd49$var$match[0] + $998d968a5e32cd49$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$998d968a5e32cd49$var$version && $492c6dc902f2bf18$exports) {
    $998d968a5e32cd49$var$match = $492c6dc902f2bf18$exports.match(/Edge\/(\d+)/);
    if (!$998d968a5e32cd49$var$match || $998d968a5e32cd49$var$match[1] >= 74) {
        $998d968a5e32cd49$var$match = $492c6dc902f2bf18$exports.match(/Chrome\/(\d+)/);
        if ($998d968a5e32cd49$var$match) $998d968a5e32cd49$var$version = +$998d968a5e32cd49$var$match[1];
    }
}
$998d968a5e32cd49$exports = $998d968a5e32cd49$var$version;




var $4a39565fee8fe980$var$$String = $55b335199d6e6d5d$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$4a39565fee8fe980$exports = !!Object.getOwnPropertySymbols && !$6140c9fa18232846$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$4a39565fee8fe980$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $998d968a5e32cd49$exports && $998d968a5e32cd49$exports < 41;
});


$47f18b427c2fbabf$exports = $4a39565fee8fe980$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $0b429cc7792c7d26$var$$Object = Object;
$0b429cc7792c7d26$exports = $47f18b427c2fbabf$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $a5217dbd1b0d33ce$exports("Symbol");
    return $70e34a5a2021f756$exports($Symbol) && $41cc576e850a251e$exports($Symbol.prototype, $0b429cc7792c7d26$var$$Object(it));
};


var $eb80dcd0b8a5698c$exports = {};
"use strict";
var $ae485921c5498156$exports = {};
"use strict";

var $8f0ebae34f61e14c$exports = {};
"use strict";
var $8f0ebae34f61e14c$var$$String = String;
$8f0ebae34f61e14c$exports = function(argument) {
    try {
        return $8f0ebae34f61e14c$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $ae485921c5498156$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$ae485921c5498156$exports = function(argument) {
    if ($70e34a5a2021f756$exports(argument)) return argument;
    throw new $ae485921c5498156$var$$TypeError($8f0ebae34f61e14c$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$eb80dcd0b8a5698c$exports = function(V, P) {
    var func = V[P];
    return $7ce250ddf7b42d4d$exports(func) ? undefined : $ae485921c5498156$exports(func);
};


var $b0f812e443807cb5$exports = {};
"use strict";



var $b0f812e443807cb5$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$b0f812e443807cb5$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if ($70e34a5a2021f756$exports(fn = input.valueOf) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if (pref !== "string" && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    throw new $b0f812e443807cb5$var$$TypeError("Can't convert object to primitive value");
};


var $842f8f0a18746212$exports = {};
"use strict";

var $1946b9b54b48e7fd$exports = {};
"use strict";
var $d00d03e557d638db$exports = {};
"use strict";
var $e0409817d4e03fc4$exports = {};
"use strict";
$e0409817d4e03fc4$exports = false;



var $4ce407c7007beb63$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $4ce407c7007beb63$var$defineProperty = Object.defineProperty;
$4ce407c7007beb63$exports = function(key, value) {
    try {
        $4ce407c7007beb63$var$defineProperty($55b335199d6e6d5d$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $55b335199d6e6d5d$exports[key] = value;
    }
    return value;
};


var $d00d03e557d638db$var$SHARED = "__core-js_shared__";
var $d00d03e557d638db$var$store = $d00d03e557d638db$exports = $55b335199d6e6d5d$exports[$d00d03e557d638db$var$SHARED] || $4ce407c7007beb63$exports($d00d03e557d638db$var$SHARED, {});
($d00d03e557d638db$var$store.versions || ($d00d03e557d638db$var$store.versions = [])).push({
    version: "3.36.1",
    mode: $e0409817d4e03fc4$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.36.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


$1946b9b54b48e7fd$exports = function(key, value) {
    return $d00d03e557d638db$exports[key] || ($d00d03e557d638db$exports[key] = value || {});
};


var $1f868a26fd901990$exports = {};
"use strict";

var $a2f3ebb5da11db12$exports = {};
"use strict";

var $a2f3ebb5da11db12$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$a2f3ebb5da11db12$exports = function(argument) {
    return $a2f3ebb5da11db12$var$$Object($c378177673193450$exports(argument));
};


var $1f868a26fd901990$var$hasOwnProperty = $43b18aa2f1faac44$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$1f868a26fd901990$exports = Object.hasOwn || function hasOwn(it, key) {
    return $1f868a26fd901990$var$hasOwnProperty($a2f3ebb5da11db12$exports(it), key);
};


var $5e0a1e292f79defc$exports = {};
"use strict";

var $5e0a1e292f79defc$var$id = 0;
var $5e0a1e292f79defc$var$postfix = Math.random();
var $5e0a1e292f79defc$var$toString = $43b18aa2f1faac44$exports(1.0.toString);
$5e0a1e292f79defc$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $5e0a1e292f79defc$var$toString(++$5e0a1e292f79defc$var$id + $5e0a1e292f79defc$var$postfix, 36);
};




var $842f8f0a18746212$var$Symbol = $55b335199d6e6d5d$exports.Symbol;
var $842f8f0a18746212$var$WellKnownSymbolsStore = $1946b9b54b48e7fd$exports("wks");
var $842f8f0a18746212$var$createWellKnownSymbol = $47f18b427c2fbabf$exports ? $842f8f0a18746212$var$Symbol["for"] || $842f8f0a18746212$var$Symbol : $842f8f0a18746212$var$Symbol && $842f8f0a18746212$var$Symbol.withoutSetter || $5e0a1e292f79defc$exports;
$842f8f0a18746212$exports = function(name) {
    if (!$1f868a26fd901990$exports($842f8f0a18746212$var$WellKnownSymbolsStore, name)) $842f8f0a18746212$var$WellKnownSymbolsStore[name] = $4a39565fee8fe980$exports && $1f868a26fd901990$exports($842f8f0a18746212$var$Symbol, name) ? $842f8f0a18746212$var$Symbol[name] : $842f8f0a18746212$var$createWellKnownSymbol("Symbol." + name);
    return $842f8f0a18746212$var$WellKnownSymbolsStore[name];
};


var $8ffb6b36a733d3c0$var$$TypeError = TypeError;
var $8ffb6b36a733d3c0$var$TO_PRIMITIVE = $842f8f0a18746212$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$8ffb6b36a733d3c0$exports = function(input, pref) {
    if (!$6a130d390db46c8e$exports(input) || $0b429cc7792c7d26$exports(input)) return input;
    var exoticToPrim = $eb80dcd0b8a5698c$exports(input, $8ffb6b36a733d3c0$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $881ad37dbe259e8f$exports(exoticToPrim, input, pref);
        if (!$6a130d390db46c8e$exports(result) || $0b429cc7792c7d26$exports(result)) return result;
        throw new $8ffb6b36a733d3c0$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $b0f812e443807cb5$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$7f19acfe53927f5c$exports = function(argument) {
    var key = $8ffb6b36a733d3c0$exports(argument, "string");
    return $0b429cc7792c7d26$exports(key) ? key : key + "";
};



var $d45526d8245cb22c$exports = {};
"use strict";


var $15c0c414b89100b1$exports = {};
"use strict";


var $15c0c414b89100b1$var$document = $55b335199d6e6d5d$exports.document;
// typeof document.createElement is 'object' in old IE
var $15c0c414b89100b1$var$EXISTS = $6a130d390db46c8e$exports($15c0c414b89100b1$var$document) && $6a130d390db46c8e$exports($15c0c414b89100b1$var$document.createElement);
$15c0c414b89100b1$exports = function(it) {
    return $15c0c414b89100b1$var$EXISTS ? $15c0c414b89100b1$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$d45526d8245cb22c$exports = !$ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($15c0c414b89100b1$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6d99163b6684d050$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$6d99163b6684d050$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $6d99163b6684d050$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $4d273c9d7e1bdf46$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    if ($d45526d8245cb22c$exports) try {
        return $6d99163b6684d050$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($1f868a26fd901990$exports(O, P)) return $b66966b48674609b$exports(!$881ad37dbe259e8f$exports($1e0782be6903ea7b$export$2d1720544b23b823, O, P), O[P]);
};


var $ca3e1754e676956d$require$getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
var $8693737507995841$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $2d0ac3aa5e39584b$export$2d1720544b23b823;
"use strict";


var $161a89d67c436ccf$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$161a89d67c436ccf$exports = $ef322a7f89c3ed41$exports && $6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $c845d421b7b0e630$exports = {};
"use strict";

var $c845d421b7b0e630$var$$String = String;
var $c845d421b7b0e630$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$c845d421b7b0e630$exports = function(argument) {
    if ($6a130d390db46c8e$exports(argument)) return argument;
    throw new $c845d421b7b0e630$var$$TypeError($c845d421b7b0e630$var$$String(argument) + " is not an object");
};



var $2d0ac3aa5e39584b$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $2d0ac3aa5e39584b$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2d0ac3aa5e39584b$var$ENUMERABLE = "enumerable";
var $2d0ac3aa5e39584b$var$CONFIGURABLE = "configurable";
var $2d0ac3aa5e39584b$var$WRITABLE = "writable";
$2d0ac3aa5e39584b$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $161a89d67c436ccf$exports ? function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $2d0ac3aa5e39584b$var$WRITABLE in Attributes && !Attributes[$2d0ac3aa5e39584b$var$WRITABLE]) {
        var current = $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$2d0ac3aa5e39584b$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $2d0ac3aa5e39584b$var$CONFIGURABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$CONFIGURABLE] : current[$2d0ac3aa5e39584b$var$CONFIGURABLE],
                enumerable: $2d0ac3aa5e39584b$var$ENUMERABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$ENUMERABLE] : current[$2d0ac3aa5e39584b$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
} : $2d0ac3aa5e39584b$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if ($d45526d8245cb22c$exports) try {
        return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $2d0ac3aa5e39584b$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$8693737507995841$exports = $ef322a7f89c3ed41$exports ? function(object, key, value) {
    return $2d0ac3aa5e39584b$export$2d1720544b23b823(object, key, $b66966b48674609b$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $40e957865125f98f$exports = {};
"use strict";


var $09c56ff2ae09b2d7$exports = {};
"use strict";





var $81c64883d194e3b4$exports = {};
"use strict";


var $81c64883d194e3b4$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $81c64883d194e3b4$var$getDescriptor = $ef322a7f89c3ed41$exports && Object.getOwnPropertyDescriptor;
var $81c64883d194e3b4$var$EXISTS = $1f868a26fd901990$exports($81c64883d194e3b4$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $81c64883d194e3b4$var$PROPER = $81c64883d194e3b4$var$EXISTS && (function something() {}).name === "something";
var $81c64883d194e3b4$var$CONFIGURABLE = $81c64883d194e3b4$var$EXISTS && (!$ef322a7f89c3ed41$exports || $ef322a7f89c3ed41$exports && $81c64883d194e3b4$var$getDescriptor($81c64883d194e3b4$var$FunctionPrototype, "name").configurable);
$81c64883d194e3b4$exports = {
    EXISTS: $81c64883d194e3b4$var$EXISTS,
    PROPER: $81c64883d194e3b4$var$PROPER,
    CONFIGURABLE: $81c64883d194e3b4$var$CONFIGURABLE
};


var $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME = $81c64883d194e3b4$exports.CONFIGURABLE;
var $9990f6f719f26a96$exports = {};
"use strict";



var $9990f6f719f26a96$var$functionToString = $43b18aa2f1faac44$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$70e34a5a2021f756$exports($d00d03e557d638db$exports.inspectSource)) $d00d03e557d638db$exports.inspectSource = function(it) {
    return $9990f6f719f26a96$var$functionToString(it);
};
$9990f6f719f26a96$exports = $d00d03e557d638db$exports.inspectSource;


var $3a8bcef306e86159$exports = {};
"use strict";
var $47d53bb84a8f3c5b$exports = {};
"use strict";


var $47d53bb84a8f3c5b$var$WeakMap = $55b335199d6e6d5d$exports.WeakMap;
$47d53bb84a8f3c5b$exports = $70e34a5a2021f756$exports($47d53bb84a8f3c5b$var$WeakMap) && /native code/.test(String($47d53bb84a8f3c5b$var$WeakMap));







var $834abcf0f8f3f871$exports = {};
"use strict";


var $834abcf0f8f3f871$var$keys = $1946b9b54b48e7fd$exports("keys");
$834abcf0f8f3f871$exports = function(key) {
    return $834abcf0f8f3f871$var$keys[key] || ($834abcf0f8f3f871$var$keys[key] = $5e0a1e292f79defc$exports(key));
};


var $9f571a3f3d135e31$exports = {};
"use strict";
$9f571a3f3d135e31$exports = {};


var $3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $3a8bcef306e86159$var$TypeError = $55b335199d6e6d5d$exports.TypeError;
var $3a8bcef306e86159$var$WeakMap = $55b335199d6e6d5d$exports.WeakMap;
var $3a8bcef306e86159$var$set, $3a8bcef306e86159$var$get, $3a8bcef306e86159$var$has;
var $3a8bcef306e86159$var$enforce = function(it) {
    return $3a8bcef306e86159$var$has(it) ? $3a8bcef306e86159$var$get(it) : $3a8bcef306e86159$var$set(it, {});
};
var $3a8bcef306e86159$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$6a130d390db46c8e$exports(it) || (state = $3a8bcef306e86159$var$get(it)).type !== TYPE) throw new $3a8bcef306e86159$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($47d53bb84a8f3c5b$exports || $d00d03e557d638db$exports.state) {
    var $3a8bcef306e86159$var$store = $d00d03e557d638db$exports.state || ($d00d03e557d638db$exports.state = new $3a8bcef306e86159$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$store.get = $3a8bcef306e86159$var$store.get;
    $3a8bcef306e86159$var$store.has = $3a8bcef306e86159$var$store.has;
    $3a8bcef306e86159$var$store.set = $3a8bcef306e86159$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($3a8bcef306e86159$var$store.has(it)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3a8bcef306e86159$var$store.set(it, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $3a8bcef306e86159$var$store.get(it) || {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $3a8bcef306e86159$var$store.has(it);
    };
} else {
    var $3a8bcef306e86159$var$STATE = $834abcf0f8f3f871$exports("state");
    $9f571a3f3d135e31$exports[$3a8bcef306e86159$var$STATE] = true;
    $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $8693737507995841$exports(it, $3a8bcef306e86159$var$STATE, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE) ? it[$3a8bcef306e86159$var$STATE] : {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE);
    };
}
$3a8bcef306e86159$exports = {
    set: $3a8bcef306e86159$var$set,
    get: $3a8bcef306e86159$var$get,
    has: $3a8bcef306e86159$var$has,
    enforce: $3a8bcef306e86159$var$enforce,
    getterFor: $3a8bcef306e86159$var$getterFor
};


var $09c56ff2ae09b2d7$var$enforceInternalState = $3a8bcef306e86159$exports.enforce;
var $09c56ff2ae09b2d7$var$getInternalState = $3a8bcef306e86159$exports.get;
var $09c56ff2ae09b2d7$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $09c56ff2ae09b2d7$var$defineProperty = Object.defineProperty;
var $09c56ff2ae09b2d7$var$stringSlice = $43b18aa2f1faac44$exports("".slice);
var $09c56ff2ae09b2d7$var$replace = $43b18aa2f1faac44$exports("".replace);
var $09c56ff2ae09b2d7$var$join = $43b18aa2f1faac44$exports([].join);
var $09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH = $ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    return $09c56ff2ae09b2d7$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $09c56ff2ae09b2d7$var$TEMPLATE = String(String).split("String");
var $09c56ff2ae09b2d7$var$makeBuiltIn = $09c56ff2ae09b2d7$exports = function(value, name, options) {
    if ($09c56ff2ae09b2d7$var$stringSlice($09c56ff2ae09b2d7$var$$String(name), 0, 7) === "Symbol(") name = "[" + $09c56ff2ae09b2d7$var$replace($09c56ff2ae09b2d7$var$$String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$1f868a26fd901990$exports(value, "name") || $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH && options && $1f868a26fd901990$exports(options, "arity") && value.length !== options.arity) $09c56ff2ae09b2d7$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $1f868a26fd901990$exports(options, "constructor") && options.constructor) {
            if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $09c56ff2ae09b2d7$var$enforceInternalState(value);
    if (!$1f868a26fd901990$exports(state, "source")) state.source = $09c56ff2ae09b2d7$var$join($09c56ff2ae09b2d7$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $09c56ff2ae09b2d7$var$makeBuiltIn(function toString() {
    return $70e34a5a2021f756$exports(this) && $09c56ff2ae09b2d7$var$getInternalState(this).source || $9990f6f719f26a96$exports(this);
}, "toString");



$40e957865125f98f$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($70e34a5a2021f756$exports(value)) $09c56ff2ae09b2d7$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $4ce407c7007beb63$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $2d0ac3aa5e39584b$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $ef14b437ba65973a$exports = {};
"use strict";

var $339f2419d379e6c2$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f6c32256739dd9b5$export$2d1720544b23b823;
"use strict";
var $c4fba4611365c4f5$exports = {};
"use strict";



var $f00609c516640f24$exports = {};
"use strict";

var $1ef9432c43157f41$exports = {};
"use strict";
var $b5bb21648546ce5b$exports = {};
"use strict";
var $5395b5a4913a5e32$exports = {};
"use strict";
var $5395b5a4913a5e32$var$ceil = Math.ceil;
var $5395b5a4913a5e32$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$5395b5a4913a5e32$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5395b5a4913a5e32$var$floor : $5395b5a4913a5e32$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$b5bb21648546ce5b$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5395b5a4913a5e32$exports(number);
};


var $1ef9432c43157f41$var$max = Math.max;
var $1ef9432c43157f41$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$1ef9432c43157f41$exports = function(index, length) {
    var integer = $b5bb21648546ce5b$exports(index);
    return integer < 0 ? $1ef9432c43157f41$var$max(integer + length, 0) : $1ef9432c43157f41$var$min(integer, length);
};


var $04c91bd3815cd64a$exports = {};
"use strict";
var $4aba983aae3daed3$exports = {};
"use strict";

var $4aba983aae3daed3$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$4aba983aae3daed3$exports = function(argument) {
    var len = $b5bb21648546ce5b$exports(argument);
    return len > 0 ? $4aba983aae3daed3$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$04c91bd3815cd64a$exports = function(obj) {
    return $4aba983aae3daed3$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $f00609c516640f24$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $4d273c9d7e1bdf46$exports($this);
        var length = $04c91bd3815cd64a$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $1ef9432c43157f41$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$f00609c516640f24$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $f00609c516640f24$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $f00609c516640f24$var$createMethod(false)
};


var $c4fba4611365c4f5$require$indexOf = $f00609c516640f24$exports.indexOf;

var $c4fba4611365c4f5$var$push = $43b18aa2f1faac44$exports([].push);
$c4fba4611365c4f5$exports = function(object, names) {
    var O = $4d273c9d7e1bdf46$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$1f868a26fd901990$exports($9f571a3f3d135e31$exports, key) && $1f868a26fd901990$exports(O, key) && $c4fba4611365c4f5$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($1f868a26fd901990$exports(O, key = names[i++])) ~$c4fba4611365c4f5$require$indexOf(result, key) || $c4fba4611365c4f5$var$push(result, key);
    return result;
};


var $e73f13f1d8a17cad$exports = {};
"use strict";
// IE8- don't enum bug keys
$e73f13f1d8a17cad$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $f6c32256739dd9b5$var$hiddenKeys = $e73f13f1d8a17cad$exports.concat("length", "prototype");
$f6c32256739dd9b5$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $c4fba4611365c4f5$exports(O, $f6c32256739dd9b5$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $0ed66cde5c449819$export$2d1720544b23b823;
"use strict";
$0ed66cde5c449819$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $339f2419d379e6c2$var$concat = $43b18aa2f1faac44$exports([].concat);
// all object keys, includes non-enumerable and symbols
$339f2419d379e6c2$exports = $a5217dbd1b0d33ce$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $f6c32256739dd9b5$export$2d1720544b23b823($c845d421b7b0e630$exports(it));
    var getOwnPropertySymbols = $0ed66cde5c449819$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $339f2419d379e6c2$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$ef14b437ba65973a$exports = function(target, source, exceptions) {
    var keys = $339f2419d379e6c2$exports(source);
    var defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$1f868a26fd901990$exports(target, key) && !(exceptions && $1f868a26fd901990$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $ca268db110e9e457$exports = {};
"use strict";


var $ca268db110e9e457$var$replacement = /#|\.prototype\./;
var $ca268db110e9e457$var$isForced = function(feature, detection) {
    var value = $ca268db110e9e457$var$data[$ca268db110e9e457$var$normalize(feature)];
    return value === $ca268db110e9e457$var$POLYFILL ? true : value === $ca268db110e9e457$var$NATIVE ? false : $70e34a5a2021f756$exports(detection) ? $6140c9fa18232846$exports(detection) : !!detection;
};
var $ca268db110e9e457$var$normalize = $ca268db110e9e457$var$isForced.normalize = function(string) {
    return String(string).replace($ca268db110e9e457$var$replacement, ".").toLowerCase();
};
var $ca268db110e9e457$var$data = $ca268db110e9e457$var$isForced.data = {};
var $ca268db110e9e457$var$NATIVE = $ca268db110e9e457$var$isForced.NATIVE = "N";
var $ca268db110e9e457$var$POLYFILL = $ca268db110e9e457$var$isForced.POLYFILL = "P";
$ca268db110e9e457$exports = $ca268db110e9e457$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $ca3e1754e676956d$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $55b335199d6e6d5d$exports;
    else if (STATIC) target = $55b335199d6e6d5d$exports[TARGET] || $4ce407c7007beb63$exports(TARGET, {});
    else target = $55b335199d6e6d5d$exports[TARGET] && $55b335199d6e6d5d$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $ca3e1754e676956d$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $ca268db110e9e457$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $ef14b437ba65973a$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $8693737507995841$exports(sourceProperty, "sham", true);
        $40e957865125f98f$exports(target, key, sourceProperty, options);
    }
};





var $a78806ef4ebb6167$exports = {};
"use strict";
var $43284f0171045916$exports = {};
"use strict";
var $4828cb1b4c7586c8$exports = {};
"use strict";


$4828cb1b4c7586c8$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($b0ba63bfbfb16088$exports(fn) === "Function") return $43b18aa2f1faac44$exports(fn);
};




var $43284f0171045916$var$bind = $4828cb1b4c7586c8$exports($4828cb1b4c7586c8$exports.bind);
// optional / simple context binding
$43284f0171045916$exports = function(fn, that) {
    $ae485921c5498156$exports(fn);
    return that === undefined ? fn : $bcbe62e89adc7d37$exports ? $43284f0171045916$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $570a6df80758b4be$exports = {};
"use strict";

var $0fe0dd04b0eb22af$exports = {};
"use strict";
$0fe0dd04b0eb22af$exports = {};


var $570a6df80758b4be$var$ITERATOR = $842f8f0a18746212$exports("iterator");
var $570a6df80758b4be$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$570a6df80758b4be$exports = function(it) {
    return it !== undefined && ($0fe0dd04b0eb22af$exports.Array === it || $570a6df80758b4be$var$ArrayPrototype[$570a6df80758b4be$var$ITERATOR] === it);
};




var $13a4c31eee540026$exports = {};
"use strict";




var $8d560b8b837672a0$exports = {};
"use strict";
var $b07c9aec2f9c74e4$exports = {};
"use strict";
var $a2c149aaa14cc75b$exports = {};
"use strict";

var $a2c149aaa14cc75b$var$TO_STRING_TAG = $842f8f0a18746212$exports("toStringTag");
var $a2c149aaa14cc75b$var$test = {};
$a2c149aaa14cc75b$var$test[$a2c149aaa14cc75b$var$TO_STRING_TAG] = "z";
$a2c149aaa14cc75b$exports = String($a2c149aaa14cc75b$var$test) === "[object z]";





var $b07c9aec2f9c74e4$var$TO_STRING_TAG = $842f8f0a18746212$exports("toStringTag");
var $b07c9aec2f9c74e4$var$$Object = Object;
// ES3 wrong here
var $b07c9aec2f9c74e4$var$CORRECT_ARGUMENTS = $b0ba63bfbfb16088$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $b07c9aec2f9c74e4$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$b07c9aec2f9c74e4$exports = $a2c149aaa14cc75b$exports ? $b0ba63bfbfb16088$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $b07c9aec2f9c74e4$var$tryGet(O = $b07c9aec2f9c74e4$var$$Object(it), $b07c9aec2f9c74e4$var$TO_STRING_TAG)) == "string" ? tag : $b07c9aec2f9c74e4$var$CORRECT_ARGUMENTS ? $b0ba63bfbfb16088$exports(O) : (result = $b0ba63bfbfb16088$exports(O)) === "Object" && $70e34a5a2021f756$exports(O.callee) ? "Arguments" : result;
};






var $8d560b8b837672a0$var$ITERATOR = $842f8f0a18746212$exports("iterator");
$8d560b8b837672a0$exports = function(it) {
    if (!$7ce250ddf7b42d4d$exports(it)) return $eb80dcd0b8a5698c$exports(it, $8d560b8b837672a0$var$ITERATOR) || $eb80dcd0b8a5698c$exports(it, "@@iterator") || $0fe0dd04b0eb22af$exports[$b07c9aec2f9c74e4$exports(it)];
};


var $13a4c31eee540026$var$$TypeError = TypeError;
$13a4c31eee540026$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $8d560b8b837672a0$exports(argument) : usingIterator;
    if ($ae485921c5498156$exports(iteratorMethod)) return $c845d421b7b0e630$exports($881ad37dbe259e8f$exports(iteratorMethod, argument));
    throw new $13a4c31eee540026$var$$TypeError($8f0ebae34f61e14c$exports(argument) + " is not iterable");
};



var $4105790cb9bf2aaa$exports = {};
"use strict";



$4105790cb9bf2aaa$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $c845d421b7b0e630$exports(iterator);
    try {
        innerResult = $eb80dcd0b8a5698c$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $881ad37dbe259e8f$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $c845d421b7b0e630$exports(innerResult);
    return value;
};


var $a78806ef4ebb6167$var$$TypeError = TypeError;
var $a78806ef4ebb6167$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $a78806ef4ebb6167$var$ResultPrototype = $a78806ef4ebb6167$var$Result.prototype;
$a78806ef4ebb6167$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $43284f0171045916$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $4105790cb9bf2aaa$exports(iterator, "normal", condition);
        return new $a78806ef4ebb6167$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $c845d421b7b0e630$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $8d560b8b837672a0$exports(iterable);
        if (!iterFn) throw new $a78806ef4ebb6167$var$$TypeError($8f0ebae34f61e14c$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($570a6df80758b4be$exports(iterFn)) {
            for(index = 0, length = $04c91bd3815cd64a$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $41cc576e850a251e$exports($a78806ef4ebb6167$var$ResultPrototype, result)) return result;
            }
            return new $a78806ef4ebb6167$var$Result(false);
        }
        iterator = $13a4c31eee540026$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $881ad37dbe259e8f$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $4105790cb9bf2aaa$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $41cc576e850a251e$exports($a78806ef4ebb6167$var$ResultPrototype, result)) return result;
    }
    return new $a78806ef4ebb6167$var$Result(false);
};


var $e055c888a6d66079$exports = {};
"use strict";

// eslint-disable-next-line es/no-map -- safe
var $e055c888a6d66079$var$MapPrototype = Map.prototype;
$e055c888a6d66079$exports = {
    // eslint-disable-next-line es/no-map -- safe
    Map: Map,
    set: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.set),
    get: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.get),
    has: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.has),
    remove: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype["delete"]),
    proto: $e055c888a6d66079$var$MapPrototype
};



var $37e12fa6c9b33441$var$Map = $e055c888a6d66079$exports.Map;
var $37e12fa6c9b33441$var$has = $e055c888a6d66079$exports.has;
var $37e12fa6c9b33441$var$get = $e055c888a6d66079$exports.get;
var $37e12fa6c9b33441$var$set = $e055c888a6d66079$exports.set;
var $37e12fa6c9b33441$var$push = $43b18aa2f1faac44$exports([].push);
// `Map.groupBy` method
// https://github.com/tc39/proposal-array-grouping
$ca3e1754e676956d$exports({
    target: "Map",
    stat: true,
    forced: $e0409817d4e03fc4$exports
}, {
    groupBy: function groupBy(items, callbackfn) {
        $c378177673193450$exports(items);
        $ae485921c5498156$exports(callbackfn);
        var map = new $37e12fa6c9b33441$var$Map();
        var k = 0;
        $a78806ef4ebb6167$exports(items, function(value) {
            var key = callbackfn(value, k++);
            if (!$37e12fa6c9b33441$var$has(map, key)) $37e12fa6c9b33441$var$set(map, key, [
                value
            ]);
            else $37e12fa6c9b33441$var$push($37e12fa6c9b33441$var$get(map, key), value);
        });
        return map;
    }
});




"use strict";

var $d59cfa12048c6a93$exports = {};
"use strict";
var $d7077b1b2482ede0$exports = {};
"use strict";

$d7077b1b2482ede0$exports = $55b335199d6e6d5d$exports;



var $f95af0e9699ed86b$export$2d1720544b23b823;
"use strict";

$f95af0e9699ed86b$export$2d1720544b23b823 = $842f8f0a18746212$exports;



var $d59cfa12048c6a93$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
$d59cfa12048c6a93$exports = function(NAME) {
    var Symbol = $d7077b1b2482ede0$exports.Symbol || ($d7077b1b2482ede0$exports.Symbol = {});
    if (!$1f868a26fd901990$exports(Symbol, NAME)) $d59cfa12048c6a93$require$defineProperty(Symbol, NAME, {
        value: $f95af0e9699ed86b$export$2d1720544b23b823(NAME)
    });
};



var $87873509811afceb$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;

var $87873509811afceb$require$getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
var $87873509811afceb$var$Symbol = $55b335199d6e6d5d$exports.Symbol;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$d59cfa12048c6a93$exports("dispose");
if ($87873509811afceb$var$Symbol) {
    var $87873509811afceb$var$descriptor = $87873509811afceb$require$getOwnPropertyDescriptor($87873509811afceb$var$Symbol, "dispose");
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($87873509811afceb$var$descriptor.enumerable && $87873509811afceb$var$descriptor.configurable && $87873509811afceb$var$descriptor.writable) $87873509811afceb$require$defineProperty($87873509811afceb$var$Symbol, "dispose", {
        value: $87873509811afceb$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}


"use strict";
"use strict";


var $a393da0e05d61ed1$exports = {};
"use strict";

var $3cdb2ef65d8e3cb5$exports = {};
"use strict";

var $3cdb2ef65d8e3cb5$var$FunctionPrototype = Function.prototype;
var $3cdb2ef65d8e3cb5$var$apply = $3cdb2ef65d8e3cb5$var$FunctionPrototype.apply;
var $3cdb2ef65d8e3cb5$var$call = $3cdb2ef65d8e3cb5$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$3cdb2ef65d8e3cb5$exports = typeof Reflect == "object" && Reflect.apply || ($bcbe62e89adc7d37$exports ? $3cdb2ef65d8e3cb5$var$call.bind($3cdb2ef65d8e3cb5$var$apply) : function() {
    return $3cdb2ef65d8e3cb5$var$call.apply($3cdb2ef65d8e3cb5$var$apply, arguments);
});






var $b8ce1ad1b6b1e7c1$exports = {};
"use strict";

$b8ce1ad1b6b1e7c1$exports = $a5217dbd1b0d33ce$exports("document", "documentElement");


var $0709cba658bb4ed6$exports = {};
"use strict";

$0709cba658bb4ed6$exports = $43b18aa2f1faac44$exports([].slice);



var $7d824954c5058f7d$exports = {};
"use strict";
var $7d824954c5058f7d$var$$TypeError = TypeError;
$7d824954c5058f7d$exports = function(passed, required) {
    if (passed < required) throw new $7d824954c5058f7d$var$$TypeError("Not enough arguments");
    return passed;
};


var $05f68a2417343639$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$05f68a2417343639$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($492c6dc902f2bf18$exports);


var $3f8bc2b5488269f3$exports = {};
"use strict";


$3f8bc2b5488269f3$exports = $b0ba63bfbfb16088$exports($55b335199d6e6d5d$exports.process) === "process";


var $a393da0e05d61ed1$var$set = $55b335199d6e6d5d$exports.setImmediate;
var $a393da0e05d61ed1$var$clear = $55b335199d6e6d5d$exports.clearImmediate;
var $a393da0e05d61ed1$var$process = $55b335199d6e6d5d$exports.process;
var $a393da0e05d61ed1$var$Dispatch = $55b335199d6e6d5d$exports.Dispatch;
var $a393da0e05d61ed1$var$Function = $55b335199d6e6d5d$exports.Function;
var $a393da0e05d61ed1$var$MessageChannel = $55b335199d6e6d5d$exports.MessageChannel;
var $a393da0e05d61ed1$var$String = $55b335199d6e6d5d$exports.String;
var $a393da0e05d61ed1$var$counter = 0;
var $a393da0e05d61ed1$var$queue = {};
var $a393da0e05d61ed1$var$ONREADYSTATECHANGE = "onreadystatechange";
var $a393da0e05d61ed1$var$$location, $a393da0e05d61ed1$var$defer, $a393da0e05d61ed1$var$channel, $a393da0e05d61ed1$var$port;
$6140c9fa18232846$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $a393da0e05d61ed1$var$$location = $55b335199d6e6d5d$exports.location;
});
var $a393da0e05d61ed1$var$run = function(id) {
    if ($1f868a26fd901990$exports($a393da0e05d61ed1$var$queue, id)) {
        var fn = $a393da0e05d61ed1$var$queue[id];
        delete $a393da0e05d61ed1$var$queue[id];
        fn();
    }
};
var $a393da0e05d61ed1$var$runner = function(id) {
    return function() {
        $a393da0e05d61ed1$var$run(id);
    };
};
var $a393da0e05d61ed1$var$eventListener = function(event) {
    $a393da0e05d61ed1$var$run(event.data);
};
var $a393da0e05d61ed1$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $55b335199d6e6d5d$exports.postMessage($a393da0e05d61ed1$var$String(id), $a393da0e05d61ed1$var$$location.protocol + "//" + $a393da0e05d61ed1$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$a393da0e05d61ed1$var$set || !$a393da0e05d61ed1$var$clear) {
    $a393da0e05d61ed1$var$set = function setImmediate(handler) {
        $7d824954c5058f7d$exports(arguments.length, 1);
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $a393da0e05d61ed1$var$Function(handler);
        var args = $0709cba658bb4ed6$exports(arguments, 1);
        $a393da0e05d61ed1$var$queue[++$a393da0e05d61ed1$var$counter] = function() {
            $3cdb2ef65d8e3cb5$exports(fn, undefined, args);
        };
        $a393da0e05d61ed1$var$defer($a393da0e05d61ed1$var$counter);
        return $a393da0e05d61ed1$var$counter;
    };
    $a393da0e05d61ed1$var$clear = function clearImmediate(id) {
        delete $a393da0e05d61ed1$var$queue[id];
    };
    // Node.js 0.8-
    if ($3f8bc2b5488269f3$exports) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$process.nextTick($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$Dispatch && $a393da0e05d61ed1$var$Dispatch.now) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$Dispatch.now($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$MessageChannel && !$05f68a2417343639$exports) {
        $a393da0e05d61ed1$var$channel = new $a393da0e05d61ed1$var$MessageChannel();
        $a393da0e05d61ed1$var$port = $a393da0e05d61ed1$var$channel.port2;
        $a393da0e05d61ed1$var$channel.port1.onmessage = $a393da0e05d61ed1$var$eventListener;
        $a393da0e05d61ed1$var$defer = $43284f0171045916$exports($a393da0e05d61ed1$var$port.postMessage, $a393da0e05d61ed1$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($55b335199d6e6d5d$exports.addEventListener && $70e34a5a2021f756$exports($55b335199d6e6d5d$exports.postMessage) && !$55b335199d6e6d5d$exports.importScripts && $a393da0e05d61ed1$var$$location && $a393da0e05d61ed1$var$$location.protocol !== "file:" && !$6140c9fa18232846$exports($a393da0e05d61ed1$var$globalPostMessageDefer)) {
        $a393da0e05d61ed1$var$defer = $a393da0e05d61ed1$var$globalPostMessageDefer;
        $55b335199d6e6d5d$exports.addEventListener("message", $a393da0e05d61ed1$var$eventListener, false);
    // IE8-
    } else if ($a393da0e05d61ed1$var$ONREADYSTATECHANGE in $15c0c414b89100b1$exports("script")) $a393da0e05d61ed1$var$defer = function(id) {
        $b8ce1ad1b6b1e7c1$exports.appendChild($15c0c414b89100b1$exports("script"))[$a393da0e05d61ed1$var$ONREADYSTATECHANGE] = function() {
            $b8ce1ad1b6b1e7c1$exports.removeChild(this);
            $a393da0e05d61ed1$var$run(id);
        };
    };
    else $a393da0e05d61ed1$var$defer = function(id) {
        setTimeout($a393da0e05d61ed1$var$runner(id), 0);
    };
}
$a393da0e05d61ed1$exports = {
    set: $a393da0e05d61ed1$var$set,
    clear: $a393da0e05d61ed1$var$clear
};


var $99b55bbd56d52729$require$clearImmediate = $a393da0e05d61ed1$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $55b335199d6e6d5d$exports.clearImmediate !== $99b55bbd56d52729$require$clearImmediate
}, {
    clearImmediate: $99b55bbd56d52729$require$clearImmediate
});


"use strict";



var $e55ac54d5aaa2e1c$require$setTask = $a393da0e05d61ed1$exports.set;
var $f112a170991e44cc$exports = {};
"use strict";



var $99637759dc933969$exports = {};
"use strict";
/* global Bun -- Bun case */ $99637759dc933969$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $f112a170991e44cc$var$Function = $55b335199d6e6d5d$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $f112a170991e44cc$var$WRAP = /MSIE .\./.test($492c6dc902f2bf18$exports) || $99637759dc933969$exports && function() {
    var version = $55b335199d6e6d5d$exports.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$f112a170991e44cc$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $f112a170991e44cc$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $7d824954c5058f7d$exports(arguments.length, 1) > firstParamIndex;
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $f112a170991e44cc$var$Function(handler);
        var params = boundArgs ? $0709cba658bb4ed6$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $3cdb2ef65d8e3cb5$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $e55ac54d5aaa2e1c$var$setImmediate = $55b335199d6e6d5d$exports.setImmediate ? $f112a170991e44cc$exports($e55ac54d5aaa2e1c$require$setTask, false) : $e55ac54d5aaa2e1c$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $55b335199d6e6d5d$exports.setImmediate !== $e55ac54d5aaa2e1c$var$setImmediate
}, {
    setImmediate: $e55ac54d5aaa2e1c$var$setImmediate
});




var $7238a34a955809b2$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7238a34a955809b2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $7238a34a955809b2$exports));
try {
    regeneratorRuntime = $7238a34a955809b2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7238a34a955809b2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7238a34a955809b2$var$runtime);
}


const $ba30e20475feac5a$export$a4ad2735b021c132 = "v1.0";
const $ba30e20475feac5a$export$f8bd50a7889a570e = 1100;
const $ba30e20475feac5a$export$923ea8233b386e99 = "https://xeno-canto.org/api/3/recordings";
const $ba30e20475feac5a$export$a9861bd62f48e142 = "662cc48f0de646f3cc704ed603ac8a77cf3300c9";
const $ba30e20475feac5a$export$ff71a71136b6152f = "https://en.wikipedia.org/w/api.php?origin=*&action=query&prop=pageimages|pageterms&piprop=original|thumbnail&pithumbsize=220&redirects&format=json&titles=";
const $ba30e20475feac5a$export$ad220dd9b2ecd9a5 = "https://en.wikipedia.org/w/api.php?origin=*&action=query&prop=imageinfo&iiprop=extmetadata&titles=File%3a";
const $ba30e20475feac5a$export$e6509278d38446ed = "https://api.ebird.org/v2/ref/hotspot/";
const $ba30e20475feac5a$export$ce0e5beb5efeb79 = {
    spring: {
        highlight: "hsl(300, 80%, 70%)",
        bird: "hsl(195, 80%, 85%)",
        background: "hsl(120, 80%, 95%)",
        title: "hsl(300, 100%, 95%)"
    },
    summer: {
        highlight: "hsl(195, 100%, 80%)",
        bird: "#FC865A",
        background: "#F9DF56",
        title: "hsl(195, 100%, 80%)"
    },
    autumn: {
        highlight: "#606c38",
        bird: "#f2a65a",
        background: "#eec170",
        title: "#bc6c25"
    },
    // autumn: {
    //   highlight: "#c18c5d",
    //   bird: "#ce796b",
    //   background: "#ecc8af",
    //   title: "#606c38",
    // },
    winter: {
        highlight: "hsl(176, 85%, 50%)",
        bird: "hsl(176, 75%, 55%)",
        background: "hsl(176, 50%, 77%)",
        title: "hsla(176, 100%, 50%, 0.25)"
    }
};
const $ba30e20475feac5a$export$dbeb5b71dd82a6da = [
    "Abyssinian",
    "African",
    "Amazonian",
    "American",
    "Andaman",
    "Andean",
    "Angola",
    "Arabian",
    "Asian",
    "Atlantic",
    "Australasian",
    "Australian",
    "Bermuda",
    "Bolivian",
    "Bornean",
    "Brazilian",
    "Burmese",
    "California",
    "Cameroon",
    "Chinese",
    "Common",
    "Congo",
    "Cuban",
    "Eastern",
    "Ecuadorian",
    "Ethiopian",
    "Eurasian",
    "European",
    "Fiji",
    "Galapagos",
    "Grey",
    "Guianan",
    "Hawaii",
    "Hawaiian",
    "Himalayan",
    "Hispaniolan",
    "Indian",
    "Indochinese",
    "Jamaican",
    "Japanese",
    "Javan",
    "Madagascar",
    "Malayan",
    "Malaysian",
    "Mascarene",
    "Mexican",
    "Micronesian",
    "Moluccan",
    "North",
    "Northern",
    "Oriental",
    "Pacific",
    "Papuan",
    "Patagonian",
    "Philippine",
    "Polynesian",
    "Puerto",
    "Reunion",
    "Rio",
    "Samoan",
    "Senegal",
    "Seychelles",
    "Siberian",
    "Somali",
    "South",
    "Southern",
    "Sri",
    "Sumatran",
    "Swamp",
    "Taiwan",
    "Tibetan",
    "Tropical",
    "Venezuelan",
    "West",
    "Western"
];
const $ba30e20475feac5a$export$36b79d2b85570e14 = [
    {
        code: "ALL",
        name: "Worldwide"
    },
    {
        code: "NA",
        name: "North America"
    },
    {
        code: "MA",
        name: "Central America"
    },
    {
        code: "SA",
        name: "South America"
    },
    {
        code: "AF",
        name: "Africa"
    },
    {
        code: "PAL",
        name: "Europe and Asia"
    },
    {
        code: "OR",
        name: "Oriental Region"
    },
    {
        code: "AU",
        name: "Australasia"
    },
    {
        code: "AN",
        name: "Antarctica"
    },
    {
        code: "AO",
        name: "Atlantic Ocean"
    },
    {
        code: "PO",
        name: "Pacific Ocean"
    },
    {
        code: "IO",
        name: "India Ocean"
    },
    {
        code: "TrO",
        name: "Troplical Ocean"
    },
    {
        code: "TO",
        name: "Temperate Ocean"
    },
    {
        code: "NA",
        name: "Northern Ocean"
    },
    {
        code: "SO",
        name: "Southern Ocean"
    }
];
const $ba30e20475feac5a$export$bc1f3e050d980d22 = [
    {
        region: "Worldwide",
        xenoRegion: ""
    },
    {
        region: "Europe and Asia",
        xenoRegion: "europe"
    },
    {
        region: "Europe",
        xenoRegion: "europe"
    },
    {
        region: "North America",
        xenoRegion: "america"
    },
    {
        region: "Northern America",
        xenoRegion: "america"
    },
    {
        region: "Central America",
        xenoRegion: "america"
    },
    {
        region: "South America",
        xenoRegion: "america"
    },
    {
        region: "Asia",
        xenoRegion: "asia"
    },
    {
        region: "Oriental Region",
        xenoRegion: "asia"
    },
    {
        region: "Australasia",
        xenoRegion: "australia"
    },
    {
        region: "Africa",
        xenoRegion: "africa"
    },
    {
        region: "Antarctica",
        xenoRegion: ""
    }
];
const $ba30e20475feac5a$export$4d78c43b7fa734a7 = [
    {
        region: "South America",
        code2: "AR",
        code3: "ARG",
        name: "Argentina"
    },
    {
        region: "Australasia",
        code2: "AU",
        code3: "AUS",
        name: "Australia"
    },
    {
        region: "Europe and Asia",
        code2: "AT",
        code3: "AUT",
        name: "Austria"
    },
    {
        region: "Europe and Asia",
        code2: "BE",
        code3: "BEL",
        name: "Belgium"
    },
    {
        region: "South America",
        code2: "BR",
        code3: "BRA",
        name: "Brazil"
    },
    {
        region: "North America",
        code2: "CA",
        code3: "CAN",
        name: "Canada"
    },
    {
        region: "Europe and Asia",
        code2: "CN",
        code3: "CHN",
        name: "China"
    },
    {
        region: "South America",
        code2: "CO",
        code3: "COL",
        name: "Colombia"
    },
    {
        region: "Europe and Asia",
        code2: "HR",
        code3: "HRV",
        name: "Croatia"
    },
    {
        region: "Europe and Asia",
        code2: "CZ",
        code3: "CZE",
        name: "Czech Republic"
    },
    {
        region: "Europe and Asia",
        code2: "DK",
        code3: "DNK",
        name: "Denmark"
    },
    {
        region: "South America",
        code2: "EC",
        code3: "ECU",
        name: "Ecuador"
    },
    {
        region: "Europe and Asia",
        code2: "EE",
        code3: "EST",
        name: "Estonia"
    },
    {
        region: "Europe and Asia",
        code2: "FI",
        code3: "FIN",
        name: "Finland"
    },
    {
        region: "Europe and Asia",
        code2: "FR",
        code3: "FRA",
        name: "France"
    },
    {
        region: "Europe and Asia",
        code2: "DE",
        code3: "DEU",
        name: "Germany"
    },
    {
        region: "Europe and Asia",
        code2: "GR",
        code3: "GRC",
        name: "Greece"
    },
    {
        region: "Europe and Asia",
        code2: "HU",
        code3: "HUN",
        name: "Hungary"
    },
    {
        region: "Europe and Asia",
        code2: "IS",
        code3: "ISL",
        name: "Iceland"
    },
    {
        region: "Oriental Region",
        code2: "IN",
        code3: "IND",
        name: "India"
    },
    {
        region: "Oriental Region",
        code2: "ID",
        code3: "IDN",
        name: "Indonesia"
    },
    {
        region: "Europe and Asia",
        code2: "IE",
        code3: "IRL",
        name: "Ireland"
    },
    {
        region: "Europe and Asia",
        code2: "IT",
        code3: "ITA",
        name: "Italy"
    },
    {
        region: "Europe and Asia",
        code2: "JP",
        code3: "JPN",
        name: "Japan"
    },
    {
        region: "Africa",
        code2: "KE",
        code3: "KEN",
        name: "Kenya"
    },
    {
        region: "Africa",
        code2: "MG",
        code3: "MDG",
        name: "Madagascar"
    },
    {
        region: "Oriental Region",
        code2: "MY",
        code3: "MYS",
        name: "Malaysia"
    },
    {
        region: "Central America",
        code2: "MX",
        code3: "MEX",
        name: "Mexico"
    },
    {
        region: "Europe and Asia",
        code2: "NL",
        code3: "NLD",
        name: "Netherlands"
    },
    {
        region: "Australasia",
        code2: "NZ",
        code3: "NZL",
        name: "New Zealand"
    },
    {
        region: "Europe and Asia",
        code2: "NO",
        code3: "NOR",
        name: "Norway"
    },
    {
        region: "Australasia",
        code2: "PG",
        code3: "PNG",
        name: "Papua New Guinea"
    },
    {
        region: "South America",
        code2: "PE",
        code3: "PER",
        name: "Peru"
    },
    {
        region: "Europe and Asia",
        code2: "PL",
        code3: "POL",
        name: "Poland"
    },
    {
        region: "Europe and Asia",
        code2: "PT",
        code3: "PRT",
        name: "Portugal"
    },
    {
        region: "Europe and Asia",
        code2: "RU",
        code3: "RUS",
        name: "Russia"
    },
    {
        region: "Australasia",
        code2: "SB",
        code3: "SLB",
        name: "Solomon Islands"
    },
    {
        region: "Africa",
        code2: "ZA",
        code3: "ZAF",
        name: "South Africa"
    },
    {
        region: "Europe and Asia",
        code2: "ES",
        code3: "ESP",
        name: "Spain"
    },
    {
        region: "Europe and Asia",
        code2: "SE",
        code3: "SWE",
        name: "Sweden"
    },
    {
        region: "Europe and Asia",
        code2: "CH",
        code3: "CHE",
        name: "Switzerland"
    },
    {
        region: "Australasia",
        code2: "TZ",
        code3: "TZA",
        name: "Tanzania"
    },
    {
        region: "Oriental Region",
        code2: "TH",
        code3: "THA",
        name: "Thailand"
    },
    {
        region: "Europe and Asia",
        code2: "TR",
        code3: "TUR",
        name: "Turkey"
    },
    {
        region: "Africa",
        code2: "UG",
        code3: "UGA",
        name: "Uganda"
    },
    {
        region: "Europe and Asia",
        code2: "UA",
        code3: "UKR",
        name: "Ukraine"
    },
    {
        region: "Europe and Asia",
        code2: "GB",
        code3: "GBR",
        name: "United Kingdom"
    },
    {
        region: "North America",
        code2: "US",
        code3: "USA",
        name: "United States"
    },
    {
        region: "Africa",
        code2: "ZM",
        code3: "ZMB",
        name: "Zambia"
    }
];


const $c72b185320e6bb41$export$7028c44a8021654a = [
    {
        name: `Canada Goose`,
        id: `canada_goose`,
        scientific: `Branta canadensis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "United States",
            "Canada",
            "New Zealand",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "NA",
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Corn Crake`,
        id: `corn_crake`,
        scientific: `Crex crex`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Snow Goose`,
        id: `snow_goose`,
        scientific: `Anser caerulescens`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Greylag Goose`,
        id: `greylag_goose`,
        scientific: `Anser anser`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Netherlands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black Swan`,
        id: `black_swan`,
        scientific: `Cygnus atratus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Mute Swan`,
        id: `mute_swan`,
        scientific: `Cygnus olor`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Poland",
            "Netherlands",
            "Finland",
            "Denmark",
            "Czech Republic",
            "United Kingdom"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Spur-winged Goose`,
        id: `spur-winged_goose`,
        scientific: `Plectropterus gambensis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Egyptian Goose`,
        id: `egyptian_goose`,
        scientific: `Alopochen aegyptiaca`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa",
            "South Africa"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Common Shelduck`,
        id: `common_shelduck`,
        scientific: `Tadorna tadorna`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "AF"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Australian Shelduck`,
        id: `australian_shelduck`,
        scientific: `Tadorna tadornoides`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Maned Duck`,
        id: `maned_duck`,
        scientific: `Chenonetta jubata`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Northern Shoveler`,
        id: `northern_shoveler`,
        scientific: `Spatula clypeata`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Eurasian Wigeon`,
        id: `eurasian_wigeon`,
        scientific: `Mareca penelope`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `American Wigeon`,
        id: `american_wigeon`,
        scientific: `Mareca americana`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Yellow-billed Duck`,
        id: `yellow-billed_duck`,
        scientific: `Anas undulata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Pacific Black Duck`,
        id: `pacific_black_duck`,
        scientific: `Anas superciliosa`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Indian Spot-billed Duck`,
        id: `indian_spot-billed_duck`,
        scientific: `Anas poecilorhyncha`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Eastern Spot-billed Duck`,
        id: `eastern_spot-billed_duck`,
        scientific: `Anas zonorhyncha`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Mallard`,
        id: `mallard`,
        scientific: `Anas platyrhynchos`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "United States",
            "Canada",
            "United Kingdom",
            "Germany",
            "New Zealand",
            "Poland",
            "Sweden",
            "Norway",
            "Netherlands",
            "Czech Republic",
            "Iceland"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `American Black Duck`,
        id: `american_black_duck`,
        scientific: `Anas rubripes`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Northern Pintail`,
        id: `northern_pintail`,
        scientific: `Anas acuta`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Eurasian Teal`,
        id: `eurasian_teal`,
        scientific: `Anas crecca`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "NA"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Yellow-billed Teal`,
        id: `yellow-billed_teal`,
        scientific: `Anas flavirostris`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Tufted Duck`,
        id: `tufted_duck`,
        scientific: `Aythya fuligula`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Netherlands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Eider`,
        id: `common_eider`,
        scientific: `Somateria mollissima`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Harlequin Duck`,
        id: `harlequin_duck`,
        scientific: `Histrionicus histrionicus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Scoter`,
        id: `common_scoter`,
        scientific: `Melanitta nigra`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Bufflehead`,
        id: `bufflehead`,
        scientific: `Bucephala albeola`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Common Goldeneye`,
        id: `common_goldeneye`,
        scientific: `Bucephala clangula`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Common Merganser`,
        id: `common_merganser`,
        scientific: `Mergus merganser`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-breasted Merganser`,
        id: `red-breasted_merganser`,
        scientific: `Mergus serrator`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Australian Brushturkey`,
        id: `australian_brushturkey`,
        scientific: `Alectura lathami`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Melanesian Megapode`,
        id: `melanesian_megapode`,
        scientific: `Megapodius eremita`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Plain Chachalaca`,
        id: `plain_chachalaca`,
        scientific: `Ortalis vetula`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Helmeted Guineafowl`,
        id: `helmeted_guineafowl`,
        scientific: `Numida meleagris`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `California Quail`,
        id: `california_quail`,
        scientific: `Callipepla californica`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Pheasant`,
        id: `common_pheasant`,
        scientific: `Phasianus colchicus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "China",
            "Ireland",
            "Poland",
            "Netherlands",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Croatia",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Green Pheasant`,
        id: `green_pheasant`,
        scientific: `Phasianus versicolor`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Indian Peafowl`,
        id: `indian_peafowl`,
        scientific: `Pavo cristatus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Chinese Bamboo Partridge`,
        id: `chinese_bamboo_partridge`,
        scientific: `Bambusicola thoracicus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red Junglefowl`,
        id: `red_junglefowl`,
        scientific: `Gallus gallus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Japanese Quail`,
        id: `japanese_quail`,
        scientific: `Coturnix japonica`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-legged Partridge`,
        id: `red-legged_partridge`,
        scientific: `Alectoris rufa`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "France"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `European Nightjar`,
        id: `european_nightjar`,
        scientific: `Caprimulgus europaeus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Large-tailed Nightjar`,
        id: `large-tailed_nightjar`,
        scientific: `Caprimulgus macrurus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Madagascar Nightjar`,
        id: `madagascar_nightjar`,
        scientific: `Caprimulgus madagascariensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Papuan Frogmouth`,
        id: `papuan_frogmouth`,
        scientific: `Podargus papuensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Tawny Frogmouth`,
        id: `tawny_frogmouth`,
        scientific: `Podargus strigoides`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Australian Owlet-nightjar`,
        id: `australian_owlet-nightjar`,
        scientific: `Aegotheles cristatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Moustached Treeswift`,
        id: `moustached_treeswift`,
        scientific: `Hemiprocne mystacea`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-collared Swift`,
        id: `white-collared_swift`,
        scientific: `Streptoprocne zonaris`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA",
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `African Palm Swift`,
        id: `african_palm_swift`,
        scientific: `Cypsiurus parvus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa",
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Asian Palm Swift`,
        id: `asian_palm_swift`,
        scientific: `Cypsiurus balasiensis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Common Swift`,
        id: `common_swift`,
        scientific: `Apus apus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Spain",
            "Ireland",
            "Greece",
            "Poland",
            "Russia",
            "France",
            "Netherlands",
            "Italy",
            "Switzerland",
            "Denmark",
            "Belgium",
            "Belgium",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `White-necked Jacobin`,
        id: `white-necked_jacobin`,
        scientific: `Florisuga mellivora`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Ruby-throated Hummingbird`,
        id: `ruby-throated_hummingbird`,
        scientific: `Archilochus colubris`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "United States"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Swallow-tailed Hummingbird`,
        id: `swallow-tailed_hummingbird`,
        scientific: `Eupetomena macroura`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Rufous-tailed Hummingbird`,
        id: `rufous-tailed_hummingbird`,
        scientific: `Amazilia tzacatl`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Great Blue Turaco`,
        id: `great_blue_turaco`,
        scientific: `Corythaeola cristata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Grey Go-away-bird`,
        id: `grey_go-away-bird`,
        scientific: `Crinifer concolor`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Eastern Plantain-eater`,
        id: `eastern_plantain-eater`,
        scientific: `Crinifer zonurus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Guira Cuckoo`,
        id: `guira_cuckoo`,
        scientific: `Guira guira`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Smooth-billed Ani`,
        id: `smooth-billed_ani`,
        scientific: `Crotophaga ani`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Groove-billed Ani`,
        id: `groove-billed_ani`,
        scientific: `Crotophaga sulcirostris`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Mexico",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Buff-headed Coucal`,
        id: `buff-headed_coucal`,
        scientific: `Centropus milo`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-browed Coucal`,
        id: `white-browed_coucal`,
        scientific: `Centropus superciliosus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Greater Coucal`,
        id: `greater_coucal`,
        scientific: `Centropus sinensis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Malagasy Coucal`,
        id: `malagasy_coucal`,
        scientific: `Centropus toulou`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Squirrel Cuckoo`,
        id: `squirrel_cuckoo`,
        scientific: `Piaya cayana`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Asian Koel`,
        id: `asian_koel`,
        scientific: `Eudynamys scolopaceus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India",
            "Malaysia"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: true
    },
    {
        name: `Pacific Koel`,
        id: `pacific_koel`,
        scientific: `Eudynamys orientalis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Channel-billed Cuckoo`,
        id: `channel-billed_cuckoo`,
        scientific: `Scythrops novaehollandiae`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-chested Cuckoo`,
        id: `red-chested_cuckoo`,
        scientific: `Cuculus solitarius`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Common Cuckoo`,
        id: `common_cuckoo`,
        scientific: `Cuculus canorus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Spain",
            "Denmark",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Rock Dove`,
        id: `rock_dove`,
        scientific: `Columba livia`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "Worldwide"
        ],
        commonCountryNames: [
            "Canada",
            "New Zealand",
            "Spain",
            "Austria",
            "Switzerland",
            "Denmark",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Speckled Pigeon`,
        id: `speckled_pigeon`,
        scientific: `Columba guinea`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa",
            "Tanzania",
            "Kenya",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Common Wood Pigeon`,
        id: `common_wood_pigeon`,
        scientific: `Columba palumbus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Spain",
            "Ireland",
            "Poland",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Yellow-legged Pigeon`,
        id: `yellow-legged_pigeon`,
        scientific: `Columba pallidiceps`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Picazuro Pigeon`,
        id: `picazuro_pigeon`,
        scientific: `Patagioenas picazuro`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Malagasy Turtle Dove`,
        id: `malagasy_turtle_dove`,
        scientific: `Nesoenas picturatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `European Turtle Dove`,
        id: `european_turtle_dove`,
        scientific: `Streptopelia turtur`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Greece",
            "Estonia",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Oriental Turtle Dove`,
        id: `oriental_turtle_dove`,
        scientific: `Streptopelia orientalis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Eurasian Collared Dove`,
        id: `eurasian_collared_dove`,
        scientific: `Streptopelia decaocto`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "Germany",
            "Spain",
            "Ireland",
            "Greece",
            "Portugal",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary"
        ],
        commonRegionCodes: [
            "PAL",
            "OR"
        ],
        commonAll: false
    },
    {
        name: `African Collared Dove`,
        id: `african_collared_dove`,
        scientific: `Streptopelia roseogrisea`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: true
    },
    {
        name: `Mourning Collared Dove`,
        id: `mourning_collared_dove`,
        scientific: `Streptopelia decipiens`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Red-eyed Dove`,
        id: `red-eyed_dove`,
        scientific: `Streptopelia semitorquata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF",
            "PAL"
        ],
        commonCountryNames: [
            "South Africa",
            "Tanzania",
            "Kenya",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Ring-necked Dove`,
        id: `ring-necked_dove`,
        scientific: `Streptopelia capicola`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Spotted Dove`,
        id: `spotted_dove`,
        scientific: `Spilopelia chinensis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India",
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [
            "OR",
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Laughing Dove`,
        id: `laughing_dove`,
        scientific: `Spilopelia senegalensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF",
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [],
        commonAll: true
    },
    {
        name: `Brown Cuckoo-Dove`,
        id: `brown_cuckoo-dove`,
        scientific: `Macropygia phasianella`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Crested Pigeon`,
        id: `crested_pigeon`,
        scientific: `Ocyphaps lophotes`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Zebra Dove`,
        id: `zebra_dove`,
        scientific: `Geopelia striata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "China",
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Inca Dove`,
        id: `inca_dove`,
        scientific: `Columbina inca`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "Mexico",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Ground Dove`,
        id: `common_ground_dove`,
        scientific: `Columbina passerina`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Ruddy Ground Dove`,
        id: `ruddy_ground_dove`,
        scientific: `Columbina talpacoti`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina"
        ],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Picui Ground Dove`,
        id: `picui_ground_dove`,
        scientific: `Columbina picui`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Argentina"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-tipped Dove`,
        id: `white-tipped_dove`,
        scientific: `Leptotila verreauxi`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Argentina",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Mourning Dove`,
        id: `mourning_dove`,
        scientific: `Zenaida macroura`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "United States",
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Eared Dove`,
        id: `eared_dove`,
        scientific: `Zenaida auriculata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-winged Dove`,
        id: `white-winged_dove`,
        scientific: `Zenaida asiatica`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "Mexico",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: true
    },
    {
        name: `Yellow-footed Green Pigeon`,
        id: `yellow-footed_green_pigeon`,
        scientific: `Treron phoenicopterus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Madagascar Green Pigeon`,
        id: `madagascar_green_pigeon`,
        scientific: `Treron australis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `African Green Pigeon`,
        id: `african_green_pigeon`,
        scientific: `Treron calvus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Orange-fronted Fruit Dove`,
        id: `orange-fronted_fruit_dove`,
        scientific: `Ptilinopus aurantiifrons`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Superb Fruit Dove`,
        id: `superb_fruit_dove`,
        scientific: `Ptilinopus superbus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Silver-capped Fruit Dove`,
        id: `silver-capped_fruit_dove`,
        scientific: `Ptilinopus richardsii`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-bellied Fruit Dove`,
        id: `red-bellied_fruit_dove`,
        scientific: `Ptilinopus greyi`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Yellow-bibbed Fruit Dove`,
        id: `yellow-bibbed_fruit_dove`,
        scientific: `Ptilinopus solomonensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Finsch's Imperial Pigeon`,
        id: `finsch's_imperial_pigeon`,
        scientific: `Ducula finschii`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Island Imperial Pigeon`,
        id: `island_imperial_pigeon`,
        scientific: `Ducula pistrinaria`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Collared Imperial Pigeon`,
        id: `collared_imperial_pigeon`,
        scientific: `Ducula mullerii`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Torresian Imperial Pigeon`,
        id: `torresian_imperial_pigeon`,
        scientific: `Ducula spilorrhoa`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `New Zealand Pigeon`,
        id: `new_zealand_pigeon`,
        scientific: `Hemiphaga novaeseelandiae`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Madagascar Forest Rail`,
        id: `madagascar_forest_rail`,
        scientific: `Mentocrex kioloides`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Grey-cowled Wood Rail`,
        id: `grey-cowled_wood_rail`,
        scientific: `Aramides cajaneus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Brazil"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Buff-banded Rail`,
        id: `buff-banded_rail`,
        scientific: `Hypotaenidia philippensis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU",
            "PO"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Roviana Rail`,
        id: `roviana_rail`,
        scientific: `Hypotaenidia rovianae`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Gallinule`,
        id: `common_gallinule`,
        scientific: `Gallinula galeata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "SA",
            "PO"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Moorhen`,
        id: `common_moorhen`,
        scientific: `Gallinula chloropus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "AF",
            "IO",
            "OR",
            "PO"
        ],
        commonCountryNames: [
            "China",
            "Poland",
            "Netherlands",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Eurasian Coot`,
        id: `eurasian_coot`,
        scientific: `Fulica atra`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Ireland",
            "Poland",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Czech Republic",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-breasted Waterhen`,
        id: `white-breasted_waterhen`,
        scientific: `Amaurornis phoenicurus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Indonesia",
            "Malaysia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Grey Crowned Crane`,
        id: `grey_crowned_crane`,
        scientific: `Balearica regulorum`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Sandhill Crane`,
        id: `sandhill_crane`,
        scientific: `Antigone canadensis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Common Crane`,
        id: `common_crane`,
        scientific: `Grus grus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Sweden",
            "Norway"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Little Grebe`,
        id: `little_grebe`,
        scientific: `Tachybaptus ruficollis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "AF",
            "OR"
        ],
        commonCountryNames: [
            "Netherlands",
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Australasian Grebe`,
        id: `australasian_grebe`,
        scientific: `Tachybaptus novaehollandiae`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR",
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Madagascar Grebe`,
        id: `madagascar_grebe`,
        scientific: `Tachybaptus pelzelnii`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Great Crested Grebe`,
        id: `great_crested_grebe`,
        scientific: `Podiceps cristatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "AF",
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Poland",
            "Czech Republic"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Greater Flamingo`,
        id: `greater_flamingo`,
        scientific: `Phoenicopterus roseus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Snowy Sheathbill`,
        id: `snowy_sheathbill`,
        scientific: `Chionis albus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AN"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Eurasian Oystercatcher`,
        id: `eurasian_oystercatcher`,
        scientific: `Haematopus ostralegus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Finland",
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `South Island Oystercatcher`,
        id: `south_island_oystercatcher`,
        scientific: `Haematopus finschi`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-winged Stilt`,
        id: `black-winged_stilt`,
        scientific: `Himantopus himantopus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "AF",
            "OR"
        ],
        commonCountryNames: [
            "Kenya"
        ],
        commonRegionCodes: [
            "AF",
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Pied Stilt`,
        id: `pied_stilt`,
        scientific: `Himantopus leucocephalus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-necked Stilt`,
        id: `black-necked_stilt`,
        scientific: `Himantopus mexicanus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA",
            "SA",
            "PO"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `American Avocet`,
        id: `american_avocet`,
        scientific: `Recurvirostra americana`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Common Ringed Plover`,
        id: `common_ringed_plover`,
        scientific: `Charadrius hiaticula`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Three-banded Plover`,
        id: `three-banded_plover`,
        scientific: `Charadrius tricollaris`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Northern Lapwing`,
        id: `northern_lapwing`,
        scientific: `Vanellus vanellus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Ireland",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Finland",
            "Denmark",
            "Belgium",
            "Estonia",
            "Ukraine"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Blacksmith Lapwing`,
        id: `blacksmith_lapwing`,
        scientific: `Vanellus armatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Spur-winged Lapwing`,
        id: `spur-winged_lapwing`,
        scientific: `Vanellus spinosus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "AF"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Grey-headed Lapwing`,
        id: `grey-headed_lapwing`,
        scientific: `Vanellus cinereus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-wattled Lapwing`,
        id: `red-wattled_lapwing`,
        scientific: `Vanellus indicus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Masked Lapwing`,
        id: `masked_lapwing`,
        scientific: `Vanellus miles`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Southern Lapwing`,
        id: `southern_lapwing`,
        scientific: `Vanellus chilensis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: true
    },
    {
        name: `African Jacana`,
        id: `african_jacana`,
        scientific: `Actophilornis africanus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Eurasian Whimbrel`,
        id: `eurasian_whimbrel`,
        scientific: `Numenius phaeopus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-tailed Godwit`,
        id: `black-tailed_godwit`,
        scientific: `Limosa limosa`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `American Woodcock`,
        id: `american_woodcock`,
        scientific: `Scolopax minor`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "United States"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Snipe`,
        id: `common_snipe`,
        scientific: `Gallinago gallinago`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Ireland",
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Wilson's Snipe`,
        id: `wilson's_snipe`,
        scientific: `Gallinago delicata`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Red-necked Phalarope`,
        id: `red-necked_phalarope`,
        scientific: `Phalaropus lobatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Redshank`,
        id: `common_redshank`,
        scientific: `Tringa totanus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Arctic Tern`,
        id: `arctic_tern`,
        scientific: `Sterna paradisaea`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "NA"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Antarctic Tern`,
        id: `antarctic_tern`,
        scientific: `Sterna vittata`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Common Tern`,
        id: `common_tern`,
        scientific: `Sterna hirundo`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "NA"
        ],
        commonCountryNames: [
            "Netherlands",
            "Denmark"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-legged Kittiwake`,
        id: `black-legged_kittiwake`,
        scientific: `Rissa tridactyla`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "NA"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Bonaparte's Gull`,
        id: `bonaparte's_gull`,
        scientific: `Chroicocephalus philadelphia`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Silver Gull`,
        id: `silver_gull`,
        scientific: `Chroicocephalus novaehollandiae`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: true
    },
    {
        name: `Black-headed Gull`,
        id: `black-headed_gull`,
        scientific: `Chroicocephalus ridibundus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "China",
            "Japan",
            "Ireland",
            "Poland",
            "Russia",
            "Netherlands",
            "Italy",
            "Finland",
            "Denmark",
            "Czech Republic",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Iceland",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Grey-headed Gull`,
        id: `grey-headed_gull`,
        scientific: `Chroicocephalus cirrocephalus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA",
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-tailed Gull`,
        id: `black-tailed_gull`,
        scientific: `Larus crassirostris`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Gull`,
        id: `common_gull`,
        scientific: `Larus canus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "Ireland",
            "Finland",
            "Estonia",
            "Ukraine",
            "Iceland",
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Ring-billed Gull`,
        id: `ring-billed_gull`,
        scientific: `Larus delawarensis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Kelp Gull`,
        id: `kelp_gull`,
        scientific: `Larus dominicanus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA",
            "AU",
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `European Herring Gull`,
        id: `european_herring_gull`,
        scientific: `Larus argentatus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Canada",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Denmark",
            "Czech Republic",
            "Estonia",
            "Ukraine",
            "Iceland",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL",
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Great Black-backed Gull`,
        id: `great_black-backed_gull`,
        scientific: `Larus marinus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `California Gull`,
        id: `california_gull`,
        scientific: `Larus californicus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `American Herring Gull`,
        id: `american_herring_gull`,
        scientific: `Larus smithsonianus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "Canada"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Great Skua`,
        id: `great_skua`,
        scientific: `Stercorarius skua`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `South Polar Skua`,
        id: `south_polar_skua`,
        scientific: `Stercorarius maccormicki`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AN"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Black Guillemot`,
        id: `black_guillemot`,
        scientific: `Cepphus grylle`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Murre`,
        id: `common_murre`,
        scientific: `Uria aalge`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-throated Loon`,
        id: `red-throated_loon`,
        scientific: `Gavia stellata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Loon`,
        id: `common_loon`,
        scientific: `Gavia immer`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Emperor Penguin`,
        id: `emperor_penguin`,
        scientific: `Aptenodytes forsteri`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AN"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Adelie Penguin`,
        id: `adelie_penguin`,
        scientific: `Pygoscelis adeliae`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO",
            "AN"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Chinstrap Penguin`,
        id: `chinstrap_penguin`,
        scientific: `Pygoscelis antarcticus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO",
            "AN"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Gentoo Penguin`,
        id: `gentoo_penguin`,
        scientific: `Pygoscelis papua`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Little Penguin`,
        id: `little_penguin`,
        scientific: `Eudyptula minor`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `African Penguin`,
        id: `african_penguin`,
        scientific: `Spheniscus demersus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Wilson's Storm Petrel`,
        id: `wilson's_storm_petrel`,
        scientific: `Oceanites oceanicus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Black-bellied Storm Petrel`,
        id: `black-bellied_storm_petrel`,
        scientific: `Fregetta tropica`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Snowy Albatross`,
        id: `snowy_albatross`,
        scientific: `Diomedea exulans`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Black-browed Albatross`,
        id: `black-browed_albatross`,
        scientific: `Thalassarche melanophris`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Southern Giant Petrel`,
        id: `southern_giant_petrel`,
        scientific: `Macronectes giganteus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO",
            "AN"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Northern Giant Petrel`,
        id: `northern_giant_petrel`,
        scientific: `Macronectes halli`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Northern Fulmar`,
        id: `northern_fulmar`,
        scientific: `Fulmarus glacialis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Southern Fulmar`,
        id: `southern_fulmar`,
        scientific: `Fulmarus glacialoides`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO",
            "AN"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Antarctic Petrel`,
        id: `antarctic_petrel`,
        scientific: `Thalassoica antarctica`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO",
            "AN"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Cape Petrel`,
        id: `cape_petrel`,
        scientific: `Daption capense`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO",
            "AN"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Snow Petrel`,
        id: `snow_petrel`,
        scientific: `Pagodroma nivea`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO",
            "AN"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `Antarctic Prion`,
        id: `antarctic_prion`,
        scientific: `Pachyptila desolata`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO",
            "AN"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `South Georgia Diving Petrel`,
        id: `south_georgia_diving_petrel`,
        scientific: `Pelecanoides georgicus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `African Openbill`,
        id: `african_openbill`,
        scientific: `Anastomus lamelligerus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Asian Openbill`,
        id: `asian_openbill`,
        scientific: `Anastomus oscitans`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Marabou Stork`,
        id: `marabou_stork`,
        scientific: `Leptoptilos crumenifer`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Yellow-billed Stork`,
        id: `yellow-billed_stork`,
        scientific: `Mycteria ibis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Painted Stork`,
        id: `painted_stork`,
        scientific: `Mycteria leucocephala`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Maguari Stork`,
        id: `maguari_stork`,
        scientific: `Ciconia maguari`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `White Stork`,
        id: `white_stork`,
        scientific: `Ciconia ciconia`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "AF"
        ],
        commonCountryNames: [
            "Portugal",
            "Poland"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Australasian Gannet`,
        id: `australasian_gannet`,
        scientific: `Morus serrator`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `African Darter`,
        id: `african_darter`,
        scientific: `Anhinga rufa`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF",
            "PAL"
        ],
        commonCountryNames: [
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Little Pied Cormorant`,
        id: `little_pied_cormorant`,
        scientific: `Microcarbo melanoleucos`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Australian Pied Cormorant`,
        id: `australian_pied_cormorant`,
        scientific: `Phalacrocorax varius`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Indian Cormorant`,
        id: `indian_cormorant`,
        scientific: `Phalacrocorax fuscicollis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Japanese Cormorant`,
        id: `japanese_cormorant`,
        scientific: `Phalacrocorax capillatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-breasted Cormorant`,
        id: `white-breasted_cormorant`,
        scientific: `Phalacrocorax lucidus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Great Cormorant`,
        id: `great_cormorant`,
        scientific: `Phalacrocorax carbo`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "AU",
            "OR",
            "NA",
            "AF"
        ],
        commonCountryNames: [
            "Denmark"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `European Shag`,
        id: `european_shag`,
        scientific: `Gulosus aristotelis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Antarctic Shag`,
        id: `antarctic_shag`,
        scientific: `Leucocarbo bransfieldensis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SO"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AN"
        ],
        commonAll: false
    },
    {
        name: `African Sacred Ibis`,
        id: `african_sacred_ibis`,
        scientific: `Threskiornis aethiopicus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Black-headed Ibis`,
        id: `black-headed_ibis`,
        scientific: `Threskiornis melanocephalus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Australian White Ibis`,
        id: `australian_white_ibis`,
        scientific: `Threskiornis molucca`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia",
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: true
    },
    {
        name: `Straw-necked Ibis`,
        id: `straw-necked_ibis`,
        scientific: `Threskiornis spinicollis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Hadada Ibis`,
        id: `hadada_ibis`,
        scientific: `Bostrychia hagedash`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa",
            "Tanzania",
            "Kenya",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: true
    },
    {
        name: `Buff-necked Ibis`,
        id: `buff-necked_ibis`,
        scientific: `Theristicus caudatus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Bare-faced Ibis`,
        id: `bare-faced_ibis`,
        scientific: `Phimosus infuscatus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Scarlet Ibis`,
        id: `scarlet_ibis`,
        scientific: `Eudocimus ruber`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `African Spoonbill`,
        id: `african_spoonbill`,
        scientific: `Platalea alba`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `American Bittern`,
        id: `american_bittern`,
        scientific: `Botaurus lentiginosus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Black-crowned Night Heron`,
        id: `black-crowned_night_heron`,
        scientific: `Nycticorax nycticorax`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "Worldwide"
        ],
        commonCountryNames: [
            "China",
            "Spain",
            "Argentina",
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [
            "NA",
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Japanese Night Heron`,
        id: `japanese_night_heron`,
        scientific: `Gorsachius goisagi`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Snowy Egret`,
        id: `snowy_egret`,
        scientific: `Egretta thula`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Little Egret`,
        id: `little_egret`,
        scientific: `Egretta garzetta`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "AF",
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "China",
            "Spain",
            "Uganda",
            "Zambia",
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `White-faced Heron`,
        id: `white-faced_heron`,
        scientific: `Egretta novaehollandiae`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Striated Heron`,
        id: `striated_heron`,
        scientific: `Butorides striata`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA",
            "PAL",
            "AF",
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Malagasy Pond Heron`,
        id: `malagasy_pond_heron`,
        scientific: `Ardeola idae`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar",
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Indian Pond Heron`,
        id: `indian_pond_heron`,
        scientific: `Ardeola grayii`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Chinese Pond Heron`,
        id: `chinese_pond_heron`,
        scientific: `Ardeola bacchus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Javan Pond Heron`,
        id: `javan_pond_heron`,
        scientific: `Ardeola speciosa`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Indonesia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Eastern Cattle Egret`,
        id: `eastern_cattle_egret`,
        scientific: `Bubulcus coromandus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Great Egret`,
        id: `great_egret`,
        scientific: `Ardea alba`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "SA",
            "AF",
            "PAL",
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "China",
            "New Zealand",
            "Argentina"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Grey Heron`,
        id: `grey_heron`,
        scientific: `Ardea cinerea`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "AF",
            "OR"
        ],
        commonCountryNames: [
            "Japan",
            "Tanzania",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Great Blue Heron`,
        id: `great_blue_heron`,
        scientific: `Ardea herodias`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Purple Heron`,
        id: `purple_heron`,
        scientific: `Ardea purpurea`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "OR",
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Black-headed Heron`,
        id: `black-headed_heron`,
        scientific: `Ardea melanocephala`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Australian Pelican`,
        id: `australian_pelican`,
        scientific: `Pelecanus conspicillatus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia",
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `American White Pelican`,
        id: `american_white_pelican`,
        scientific: `Pelecanus erythrorhynchos`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Andean Condor`,
        id: `andean_condor`,
        scientific: `Vultur gryphus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Black Vulture`,
        id: `black_vulture`,
        scientific: `Coragyps atratus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Turkey Vulture`,
        id: `turkey_vulture`,
        scientific: `Cathartes aura`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Secretarybird`,
        id: `secretarybird`,
        scientific: `Sagittarius serpentarius`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Black-winged Kite`,
        id: `black-winged_kite`,
        scientific: `Elanus caeruleus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF",
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Portugal"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Madagascar Harrier-Hawk`,
        id: `madagascar_harrier-hawk`,
        scientific: `Polyboroides radiatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-backed Vulture`,
        id: `white-backed_vulture`,
        scientific: `Gyps africanus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `R\xfcppell's Vulture`,
        id: `r\xfcppell's_vulture`,
        scientific: `Gyps rueppelli`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Crested Serpent Eagle`,
        id: `crested_serpent_eagle`,
        scientific: `Spilornis cheela`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Harpy Eagle`,
        id: `harpy_eagle`,
        scientific: `Harpia harpyja`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Brown Goshawk`,
        id: `brown_goshawk`,
        scientific: `Accipiter fasciatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Japanese Sparrowhawk`,
        id: `japanese_sparrowhawk`,
        scientific: `Accipiter gularis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Eurasian Sparrowhawk`,
        id: `eurasian_sparrowhawk`,
        scientific: `Accipiter nisus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Greece",
            "Portugal",
            "Russia",
            "Austria",
            "Switzerland",
            "Turkey",
            "Croatia",
            "Hungary"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Swamp Harrier`,
        id: `swamp_harrier`,
        scientific: `Circus approximans`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Malagasy Harrier`,
        id: `malagasy_harrier`,
        scientific: `Circus macrosceles`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black Kite`,
        id: `black_kite`,
        scientific: `Milvus migrans`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "AF",
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Yellow-billed Kite`,
        id: `yellow-billed_kite`,
        scientific: `Milvus aegyptius`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Brahminy Kite`,
        id: `brahminy_kite`,
        scientific: `Haliastur indus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Bald Eagle`,
        id: `bald_eagle`,
        scientific: `Haliaeetus leucocephalus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `White-bellied Sea Eagle`,
        id: `white-bellied_sea_eagle`,
        scientific: `Icthyophaga leucogaster`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR",
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Sanford's Sea Eagle`,
        id: `sanford's_sea_eagle`,
        scientific: `Icthyophaga sanfordi`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands",
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `African Fish Eagle`,
        id: `african_fish_eagle`,
        scientific: `Icthyophaga vocifer`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Madagascar Fish Eagle`,
        id: `madagascar_fish_eagle`,
        scientific: `Icthyophaga vociferoides`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-collared Hawk`,
        id: `black-collared_hawk`,
        scientific: `Busarellus nigricollis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Red-tailed Hawk`,
        id: `red-tailed_hawk`,
        scientific: `Buteo jamaicensis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "United States"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Common Buzzard`,
        id: `common_buzzard`,
        scientific: `Buteo buteo`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Russia"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Madagascar Buzzard`,
        id: `madagascar_buzzard`,
        scientific: `Buteo brachypterus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Little Owl`,
        id: `little_owl`,
        scientific: `Athene noctua`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "AF"
        ],
        commonCountryNames: [
            "Portugal"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Ferruginous Pygmy Owl`,
        id: `ferruginous_pygmy_owl`,
        scientific: `Glaucidium brasilianum`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Brazil"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Snowy Owl`,
        id: `snowy_owl`,
        scientific: `Bubo scandiacus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Pel's Fishing Owl`,
        id: `pel's_fishing_owl`,
        scientific: `Scotopelia peli`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Tawny Owl`,
        id: `tawny_owl`,
        scientific: `Strix aluco`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Speckled Mousebird`,
        id: `speckled_mousebird`,
        scientific: `Colius striatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Resplendent Quetzal`,
        id: `resplendent_quetzal`,
        scientific: `Pharomachrus mocinno`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Black-headed Trogon`,
        id: `black-headed_trogon`,
        scientific: `Trogon melanocephalus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Gartered Trogon`,
        id: `gartered_trogon`,
        scientific: `Trogon caligatus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Eurasian Hoopoe`,
        id: `eurasian_hoopoe`,
        scientific: `Upupa epops`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "Spain",
            "Greece",
            "Portugal"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `African Hoopoe`,
        id: `african_hoopoe`,
        scientific: `Upupa africana`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Madagascar Hoopoe`,
        id: `madagascar_hoopoe`,
        scientific: `Upupa marginata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Southern Yellow-billed Hornbill`,
        id: `southern_yellow-billed_hornbill`,
        scientific: `Tockus leucomelas`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Kenya"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `African Grey Hornbill`,
        id: `african_grey_hornbill`,
        scientific: `Lophoceros nasutus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Oriental Pied Hornbill`,
        id: `oriental_pied_hornbill`,
        scientific: `Anthracoceros albirostris`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Indian Grey Hornbill`,
        id: `indian_grey_hornbill`,
        scientific: `Ocyceros birostris`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Blyth's Hornbill`,
        id: `blyth's_hornbill`,
        scientific: `Rhyticeros plicatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Indian Roller`,
        id: `indian_roller`,
        scientific: `Coracias benghalensis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Lilac-breasted Roller`,
        id: `lilac-breasted_roller`,
        scientific: `Coracias caudatus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `European Roller`,
        id: `european_roller`,
        scientific: `Coracias garrulus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Oriental Dollarbird`,
        id: `oriental_dollarbird`,
        scientific: `Eurystomus orientalis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Azure Dollarbird`,
        id: `azure_dollarbird`,
        scientific: `Eurystomus azureus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Paradise Kingfisher`,
        id: `common_paradise_kingfisher`,
        scientific: `Tanysiptera galatea`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Laughing Kookaburra`,
        id: `laughing_kookaburra`,
        scientific: `Dacelo novaeguineae`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Stork-billed Kingfisher`,
        id: `stork-billed_kingfisher`,
        scientific: `Pelargopsis capensis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `White-throated Kingfisher`,
        id: `white-throated_kingfisher`,
        scientific: `Halcyon smyrnensis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India",
            "Thailand"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: true
    },
    {
        name: `Black-capped Kingfisher`,
        id: `black-capped_kingfisher`,
        scientific: `Halcyon pileata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Grey-headed Kingfisher`,
        id: `grey-headed_kingfisher`,
        scientific: `Halcyon leucocephala`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Ultramarine Kingfisher`,
        id: `ultramarine_kingfisher`,
        scientific: `Todiramphus leucopygius`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Vanuatu Kingfisher`,
        id: `vanuatu_kingfisher`,
        scientific: `Todiramphus farquhari`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Collared Kingfisher`,
        id: `collared_kingfisher`,
        scientific: `Todiramphus chloris`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Sacred Kingfisher`,
        id: `sacred_kingfisher`,
        scientific: `Todiramphus sanctus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR",
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Yellow-billed Kingfisher`,
        id: `yellow-billed_kingfisher`,
        scientific: `Syma torotoro`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `African Pygmy Kingfisher`,
        id: `african_pygmy_kingfisher`,
        scientific: `Ispidina picta`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Malachite Kingfisher`,
        id: `malachite_kingfisher`,
        scientific: `Corythornis cristatus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Kenya",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Malagasy Kingfisher`,
        id: `malagasy_kingfisher`,
        scientific: `Corythornis vintsioides`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Kingfisher`,
        id: `common_kingfisher`,
        scientific: `Alcedo atthis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "China",
            "India",
            "Spain",
            "Italy",
            "Ukraine",
            "Croatia",
            "Hungary",
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [
            "PAL",
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Ringed Kingfisher`,
        id: `ringed_kingfisher`,
        scientific: `Megaceryle torquata`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Belted Kingfisher`,
        id: `belted_kingfisher`,
        scientific: `Megaceryle alcyon`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Lesson's Motmot`,
        id: `lesson's_motmot`,
        scientific: `Momotus lessonii`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Amazonian Motmot`,
        id: `amazonian_motmot`,
        scientific: `Momotus momota`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Turquoise-browed Motmot`,
        id: `turquoise-browed_motmot`,
        scientific: `Eumomota superciliosa`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Little Bee-eater`,
        id: `little_bee-eater`,
        scientific: `Merops pusillus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `White-fronted Bee-eater`,
        id: `white-fronted_bee-eater`,
        scientific: `Merops bullockoides`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `White-throated Bee-eater`,
        id: `white-throated_bee-eater`,
        scientific: `Merops albicollis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Olive Bee-eater`,
        id: `olive_bee-eater`,
        scientific: `Merops superciliosus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Rainbow Bee-eater`,
        id: `rainbow_bee-eater`,
        scientific: `Merops ornatus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Chestnut-headed Bee-eater`,
        id: `chestnut-headed_bee-eater`,
        scientific: `Merops leschenaulti`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `European Bee-eater`,
        id: `european_bee-eater`,
        scientific: `Merops apiaster`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "AF"
        ],
        commonCountryNames: [
            "Spain",
            "Greece"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Rufous-tailed Jacamar`,
        id: `rufous-tailed_jacamar`,
        scientific: `Galbula ruficauda`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `White-eared Puffbird`,
        id: `white-eared_puffbird`,
        scientific: `Nystalus chacuru`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Chestnut-eared Aracari`,
        id: `chestnut-eared_aracari`,
        scientific: `Pteroglossus castanotis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Collared Aracari`,
        id: `collared_aracari`,
        scientific: `Pteroglossus torquatus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Keel-billed Toucan`,
        id: `keel-billed_toucan`,
        scientific: `Ramphastos sulfuratus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Toco Toucan`,
        id: `toco_toucan`,
        scientific: `Ramphastos toco`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `White-throated Toucan`,
        id: `white-throated_toucan`,
        scientific: `Ramphastos tucanus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Red-crowned Barbet`,
        id: `red-crowned_barbet`,
        scientific: `Psilopogon rafflesii`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Indonesia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Yellow-rumped Tinkerbird`,
        id: `yellow-rumped_tinkerbird`,
        scientific: `Pogoniulus bilineatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-headed Barbet`,
        id: `white-headed_barbet`,
        scientific: `Lybius leucocephalus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-cheeked Woodpecker`,
        id: `black-cheeked_woodpecker`,
        scientific: `Melanerpes pucherani`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Red-crowned Woodpecker`,
        id: `red-crowned_woodpecker`,
        scientific: `Melanerpes rubricapillus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Golden-fronted Woodpecker`,
        id: `golden-fronted_woodpecker`,
        scientific: `Melanerpes aurifrons`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Sunda Pygmy Woodpecker`,
        id: `sunda_pygmy_woodpecker`,
        scientific: `Yungipicus moluccensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Japanese Pygmy Woodpecker`,
        id: `japanese_pygmy_woodpecker`,
        scientific: `Yungipicus kizuki`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Downy Woodpecker`,
        id: `downy_woodpecker`,
        scientific: `Dryobates pubescens`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "United States",
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Northern Flicker`,
        id: `northern_flicker`,
        scientific: `Colaptes auratus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "United States"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `European Green Woodpecker`,
        id: `european_green_woodpecker`,
        scientific: `Picus viridis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Greece",
            "France",
            "Italy"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Black-rumped Flameback`,
        id: `black-rumped_flameback`,
        scientific: `Dinopium benghalense`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-legged Seriema`,
        id: `red-legged_seriema`,
        scientific: `Cariama cristata`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Crested Caracara`,
        id: `crested_caracara`,
        scientific: `Caracara plancus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Yellow-headed Caracara`,
        id: `yellow-headed_caracara`,
        scientific: `Milvago chimachima`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Common Kestrel`,
        id: `common_kestrel`,
        scientific: `Falco tinnunculus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "AF"
        ],
        commonCountryNames: [
            "Germany",
            "Portugal",
            "France",
            "Austria",
            "Switzerland",
            "Czech Republic",
            "Belgium",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Malagasy Kestrel`,
        id: `malagasy_kestrel`,
        scientific: `Falco newtoni`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Nankeen Kestrel`,
        id: `nankeen_kestrel`,
        scientific: `Falco cenchroides`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `American Kestrel`,
        id: `american_kestrel`,
        scientific: `Falco sparverius`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "United States",
            "Canada",
            "Peru"
        ],
        commonRegionCodes: [
            "NA",
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Australian Hobby`,
        id: `australian_hobby`,
        scientific: `Falco longipennis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Yellow-tailed Black Cockatoo`,
        id: `yellow-tailed_black_cockatoo`,
        scientific: `Zanda funerea`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Palm Cockatoo`,
        id: `palm_cockatoo`,
        scientific: `Probosciger aterrimus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Galah`,
        id: `galah`,
        scientific: `Eolophus roseicapilla`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Solomons Cockatoo`,
        id: `solomons_cockatoo`,
        scientific: `Cacatua ducorpsii`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Little Corella`,
        id: `little_corella`,
        scientific: `Cacatua sanguinea`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Sulphur-crested Cockatoo`,
        id: `sulphur-crested_cockatoo`,
        scientific: `Cacatua galerita`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Grey Parrot`,
        id: `grey_parrot`,
        scientific: `Psittacus erithacus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Monk Parakeet`,
        id: `monk_parakeet`,
        scientific: `Myiopsitta monachus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Spain",
            "Portugal",
            "Argentina"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Yellow-chevroned Parakeet`,
        id: `yellow-chevroned_parakeet`,
        scientific: `Brotogeris chiriri`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Orange-chinned Parakeet`,
        id: `orange-chinned_parakeet`,
        scientific: `Brotogeris jugularis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Blue-headed Parrot`,
        id: `blue-headed_parrot`,
        scientific: `Pionus menstruus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Orange-winged Amazon`,
        id: `orange-winged_amazon`,
        scientific: `Amazona amazonica`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Green-rumped Parrotlet`,
        id: `green-rumped_parrotlet`,
        scientific: `Forpus passerinus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Hyacinth Macaw`,
        id: `hyacinth_macaw`,
        scientific: `Anodorhynchus hyacinthinus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Olive-throated Parakeet`,
        id: `olive-throated_parakeet`,
        scientific: `Eupsittula nana`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Blue-and-yellow Macaw`,
        id: `blue-and-yellow_macaw`,
        scientific: `Ara ararauna`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: true
    },
    {
        name: `Scarlet Macaw`,
        id: `scarlet_macaw`,
        scientific: `Ara macao`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Blue-crowned Parakeet`,
        id: `blue-crowned_parakeet`,
        scientific: `Thectocercus acuticaudatus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `White-eyed Parakeet`,
        id: `white-eyed_parakeet`,
        scientific: `Psittacara leucophthalmus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Argentina"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Lesser Vasa Parrot`,
        id: `lesser_vasa_parrot`,
        scientific: `Coracopsis nigra`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Australian King Parrot`,
        id: `australian_king_parrot`,
        scientific: `Alisterus scapularis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Eclectus Parrot`,
        id: `eclectus_parrot`,
        scientific: `Eclectus roratus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-cheeked Parrot`,
        id: `red-cheeked_parrot`,
        scientific: `Geoffroyus geoffroyi`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Rose-ringed Parakeet`,
        id: `rose-ringed_parakeet`,
        scientific: `Psittacula krameri`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF",
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Crimson Rosella`,
        id: `crimson_rosella`,
        scientific: `Platycercus elegans`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Eastern Rosella`,
        id: `eastern_rosella`,
        scientific: `Platycercus eximius`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia",
            "New Zealand"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Duchess Lorikeet`,
        id: `duchess_lorikeet`,
        scientific: `Charmosynoides margarethae`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Yellow-bibbed Lory`,
        id: `yellow-bibbed_lory`,
        scientific: `Lorius chlorocercus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Rainbow Lorikeet`,
        id: `rainbow_lorikeet`,
        scientific: `Trichoglossus moluccanus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia",
            "Papua New Guinea"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: true
    },
    {
        name: `Indian Pitta`,
        id: `indian_pitta`,
        scientific: `Pitta brachyura`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Western Hooded Pitta`,
        id: `western_hooded_pitta`,
        scientific: `Pitta sordida`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-faced Pitta`,
        id: `black-faced_pitta`,
        scientific: `Pitta anerythra`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Plain Xenops`,
        id: `plain_xenops`,
        scientific: `Xenops genibarbis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Rufous Hornero`,
        id: `rufous_hornero`,
        scientific: `Furnarius rufus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: true
    },
    {
        name: `Ochre-throated Foliage-gleaner`,
        id: `ochre-throated_foliage-gleaner`,
        scientific: `Automolus ochrolaemus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Rufous-fronted Thornbird`,
        id: `rufous-fronted_thornbird`,
        scientific: `Phacellodomus rufifrons`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Rufous-capped Spinetail`,
        id: `rufous-capped_spinetail`,
        scientific: `Synallaxis ruficapilla`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Rufous-breasted Spinetail`,
        id: `rufous-breasted_spinetail`,
        scientific: `Synallaxis erythrothorax`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Yellow-bellied Elaenia`,
        id: `yellow-bellied_elaenia`,
        scientific: `Elaenia flavogaster`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Black Phoebe`,
        id: `black_phoebe`,
        scientific: `Sayornis nigricans`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Yellow-browed Tyrant`,
        id: `yellow-browed_tyrant`,
        scientific: `Satrapa icterophrys`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Cattle Tyrant`,
        id: `cattle_tyrant`,
        scientific: `Machetornis rixosa`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Brazil"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Rusty-margined Flycatcher`,
        id: `rusty-margined_flycatcher`,
        scientific: `Myiozetetes cayanensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Social Flycatcher`,
        id: `social_flycatcher`,
        scientific: `Myiozetetes similis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Mexico",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: true
    },
    {
        name: `Great Kiskadee`,
        id: `great_kiskadee`,
        scientific: `Pitangus sulphuratus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Mexico",
            "Argentina",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "MA",
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Sulphur-bellied Flycatcher`,
        id: `sulphur-bellied_flycatcher`,
        scientific: `Myiodynastes luteiventris`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Streaked Flycatcher`,
        id: `streaked_flycatcher`,
        scientific: `Myiodynastes maculatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Tropical Kingbird`,
        id: `tropical_kingbird`,
        scientific: `Tyrannus melancholicus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Mexico",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Fork-tailed Flycatcher`,
        id: `fork-tailed_flycatcher`,
        scientific: `Tyrannus savana`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Argentina"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Rufous Mourner`,
        id: `rufous_mourner`,
        scientific: `Rhytipterna holerythra`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Screaming Piha`,
        id: `screaming_piha`,
        scientific: `Lipaugus vociferans`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Long-tailed Manakin`,
        id: `long-tailed_manakin`,
        scientific: `Chiroxiphia linearis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Masked Tityra`,
        id: `masked_tityra`,
        scientific: `Tityra semifasciata`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `White-winged Becard`,
        id: `white-winged_becard`,
        scientific: `Pachyramphus polychopterus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Argentina"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Superb Fairywren`,
        id: `superb_fairywren`,
        scientific: `Malurus cyaneus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Red-backed Fairywren`,
        id: `red-backed_fairywren`,
        scientific: `Malurus melanocephalus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Eastern Spinebill`,
        id: `eastern_spinebill`,
        scientific: `Acanthorhynchus tenuirostris`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Tui`,
        id: `tui`,
        scientific: `Prosthemadera novaeseelandiae`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `New Holland Honeyeater`,
        id: `new_holland_honeyeater`,
        scientific: `Phylidonyris novaehollandiae`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Guadalcanal Honeyeater`,
        id: `guadalcanal_honeyeater`,
        scientific: `Guadalcanaria inexpectata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Varied Honeyeater`,
        id: `varied_honeyeater`,
        scientific: `Gavicalis versicolor`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Yellow-faced Honeyeater`,
        id: `yellow-faced_honeyeater`,
        scientific: `Caligavis chrysops`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Noisy Miner`,
        id: `noisy_miner`,
        scientific: `Manorina melanocephala`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Fairy Gerygone`,
        id: `fairy_gerygone`,
        scientific: `Gerygone palpebrosa`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Grey Gerygone`,
        id: `grey_gerygone`,
        scientific: `Gerygone igata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-headed Gonolek`,
        id: `black-headed_gonolek`,
        scientific: `Laniarius erythrogaster`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Woodshrike`,
        id: `common_woodshrike`,
        scientific: `Tephrodornis pondicerianus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black Butcherbird`,
        id: `black_butcherbird`,
        scientific: `Melloria quoyi`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Australian Magpie`,
        id: `australian_magpie`,
        scientific: `Gymnorhina tibicen`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: true
    },
    {
        name: `White-bellied Cuckooshrike`,
        id: `white-bellied_cuckooshrike`,
        scientific: `Coracina papuensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Cicadabird`,
        id: `common_cicadabird`,
        scientific: `Edolisoma tenuirostre`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Varied Sittella`,
        id: `varied_sittella`,
        scientific: `Daphoenositta chrysoptera`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Australian Golden Whistler`,
        id: `australian_golden_whistler`,
        scientific: `Pachycephala pectoralis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-eyed Vireo`,
        id: `white-eyed_vireo`,
        scientific: `Vireo griseus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Australasian Figbird`,
        id: `australasian_figbird`,
        scientific: `Sphecotheres vieilloti`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Black-headed Oriole`,
        id: `black-headed_oriole`,
        scientific: `Oriolus larvatus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Black-naped Oriole`,
        id: `black-naped_oriole`,
        scientific: `Oriolus chinensis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Greater Racket-tailed Drongo`,
        id: `greater_racket-tailed_drongo`,
        scientific: `Dicrurus paradiseus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Fork-tailed Drongo`,
        id: `fork-tailed_drongo`,
        scientific: `Dicrurus adsimilis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black Drongo`,
        id: `black_drongo`,
        scientific: `Dicrurus macrocercus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "China",
            "India"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `White-throated Fantail`,
        id: `white-throated_fantail`,
        scientific: `Rhipidura albicollis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Malaysian Pied Fantail`,
        id: `malaysian_pied_fantail`,
        scientific: `Rhipidura javanica`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Willie Wagtail`,
        id: `willie_wagtail`,
        scientific: `Rhipidura leucophrys`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Grey Fantail`,
        id: `grey_fantail`,
        scientific: `Rhipidura albiscapa`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `New Zealand Fantail`,
        id: `new_zealand_fantail`,
        scientific: `Rhipidura fuliginosa`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Malaita Fantail`,
        id: `malaita_fantail`,
        scientific: `Rhipidura malaitae`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `African Paradise Flycatcher`,
        id: `african_paradise_flycatcher`,
        scientific: `Terpsiphone viridis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Indian Paradise Flycatcher`,
        id: `indian_paradise_flycatcher`,
        scientific: `Terpsiphone paradisi`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Malagasy Paradise Flycatcher`,
        id: `malagasy_paradise_flycatcher`,
        scientific: `Terpsiphone mutata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Kolombangara Monarch`,
        id: `kolombangara_monarch`,
        scientific: `Symposiachrus browni`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-collared Monarch`,
        id: `white-collared_monarch`,
        scientific: `Symposiachrus vidua`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Magpie-lark`,
        id: `magpie-lark`,
        scientific: `Grallina cyanoleuca`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Melanesian Flycatcher`,
        id: `melanesian_flycatcher`,
        scientific: `Myiagra caledonica`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Iberian Grey Shrike`,
        id: `iberian_grey_shrike`,
        scientific: `Lanius meridionalis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Portugal"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Southern Fiscal`,
        id: `southern_fiscal`,
        scientific: `Lanius collaris`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-backed Shrike`,
        id: `red-backed_shrike`,
        scientific: `Lanius collurio`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Turkey",
            "Hungary"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Brown Shrike`,
        id: `brown_shrike`,
        scientific: `Lanius cristatus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Black-throated Jay`,
        id: `black-throated_jay`,
        scientific: `Cyanolyca pumilo`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Green Jay`,
        id: `green_jay`,
        scientific: `Cyanocorax luxuosus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Brown Jay`,
        id: `brown_jay`,
        scientific: `Psilorhinus morio`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-throated Magpie-Jay`,
        id: `white-throated_magpie-jay`,
        scientific: `Calocitta formosa`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Blue Jay`,
        id: `blue_jay`,
        scientific: `Cyanocitta cristata`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "United States",
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Eurasian Jay`,
        id: `eurasian_jay`,
        scientific: `Garrulus glandarius`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "Spain",
            "Ireland",
            "Greece",
            "Portugal",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Azure-winged Magpie`,
        id: `azure-winged_magpie`,
        scientific: `Cyanopica cyanus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "China",
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Iberian Magpie`,
        id: `iberian_magpie`,
        scientific: `Cyanopica cooki`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Spain"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-billed Blue Magpie`,
        id: `red-billed_blue_magpie`,
        scientific: `Urocissa erythroryncha`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Eurasian Magpie`,
        id: `eurasian_magpie`,
        scientific: `Pica pica`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Spain",
            "Ireland",
            "Greece",
            "Portugal",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Western Jackdaw`,
        id: `western_jackdaw`,
        scientific: `Coloeus monedula`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Sweden",
            "Norway",
            "United Kingdom"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `House Crow`,
        id: `house_crow`,
        scientific: `Corvus splendens`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India",
            "Indonesia"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: true
    },
    {
        name: `White-billed Crow`,
        id: `white-billed_crow`,
        scientific: `Corvus woodfordi`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `American Crow`,
        id: `american_crow`,
        scientific: `Corvus brachyrhynchos`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "United States",
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: true
    },
    {
        name: `Carrion Crow`,
        id: `carrion_crow`,
        scientific: `Corvus corone`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan",
            "Germany",
            "Ireland",
            "Poland",
            "Russia",
            "France",
            "Netherlands",
            "Italy",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Croatia",
            "United Kingdom"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Hooded Crow`,
        id: `hooded_crow`,
        scientific: `Corvus cornix`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Ireland",
            "Russia",
            "Italy",
            "Austria",
            "Switzerland",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Large-billed Crow`,
        id: `large-billed_crow`,
        scientific: `Corvus macrorhynchos`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "China",
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Torresian Crow`,
        id: `torresian_crow`,
        scientific: `Corvus orru`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Australian Raven`,
        id: `australian_raven`,
        scientific: `Corvus coronoides`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Pied Crow`,
        id: `pied_crow`,
        scientific: `Corvus albus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa",
            "Tanzania",
            "Kenya",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Northern Raven`,
        id: `northern_raven`,
        scientific: `Corvus corax`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA",
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Iceland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-winged Chough`,
        id: `white-winged_chough`,
        scientific: `Corcorax melanorhamphos`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Pacific Robin`,
        id: `pacific_robin`,
        scientific: `Petroica pusilla`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU",
            "PO"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Eastern Yellow Robin`,
        id: `eastern_yellow_robin`,
        scientific: `Eopsaltria australis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Cedar Waxwing`,
        id: `cedar_waxwing`,
        scientific: `Bombycilla cedrorum`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "United States",
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Grey-headed Canary-flycatcher`,
        id: `grey-headed_canary-flycatcher`,
        scientific: `Culicicapa ceylonensis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Crested Tit`,
        id: `crested_tit`,
        scientific: `Lophophanes cristatus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Tufted Titmouse`,
        id: `tufted_titmouse`,
        scientific: `Baeolophus bicolor`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "United States",
            "Canada"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Varied Tit`,
        id: `varied_tit`,
        scientific: `Sittiparus varius`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Carolina Chickadee`,
        id: `carolina_chickadee`,
        scientific: `Poecile carolinensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "United States"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-capped Chickadee`,
        id: `black-capped_chickadee`,
        scientific: `Poecile atricapillus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "United States",
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Eurasian Blue Tit`,
        id: `eurasian_blue_tit`,
        scientific: `Cyanistes caeruleus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Spain",
            "Ireland",
            "Greece",
            "Portugal",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: true
    },
    {
        name: `Great Tit`,
        id: `great_tit`,
        scientific: `Parus major`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "China",
            "Japan",
            "Germany",
            "Spain",
            "Ireland",
            "Greece",
            "Portugal",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Japanese Tit`,
        id: `japanese_tit`,
        scientific: `Parus minor`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Madagascar Lark`,
        id: `madagascar_lark`,
        scientific: `Eremopterix hova`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Eurasian Skylark`,
        id: `eurasian_skylark`,
        scientific: `Alauda arvensis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan",
            "Ireland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Italy"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Crested Lark`,
        id: `crested_lark`,
        scientific: `Galerida cristata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "AF"
        ],
        commonCountryNames: [
            "Spain"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Brown-eared Bulbul`,
        id: `brown-eared_bulbul`,
        scientific: `Hypsipetes amaurotis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Malagasy Bulbul`,
        id: `malagasy_bulbul`,
        scientific: `Hypsipetes madagascariensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Olive-winged Bulbul`,
        id: `olive-winged_bulbul`,
        scientific: `Pycnonotus plumosus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Light-vented Bulbul`,
        id: `light-vented_bulbul`,
        scientific: `Pycnonotus sinensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "China",
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-whiskered Bulbul`,
        id: `red-whiskered_bulbul`,
        scientific: `Pycnonotus jocosus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: true
    },
    {
        name: `Yellow-vented Bulbul`,
        id: `yellow-vented_bulbul`,
        scientific: `Pycnonotus goiavier`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-vented Bulbul`,
        id: `red-vented_bulbul`,
        scientific: `Pycnonotus cafer`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Common Bulbul`,
        id: `common_bulbul`,
        scientific: `Pycnonotus barbatus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: true
    },
    {
        name: `White-rumped Swallow`,
        id: `white-rumped_swallow`,
        scientific: `Tachycineta leucorrhoa`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Argentina"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Brown-chested Martin`,
        id: `brown-chested_martin`,
        scientific: `Progne tapera`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Grey-breasted Martin`,
        id: `grey-breasted_martin`,
        scientific: `Progne chalybea`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Mexico",
            "Colombia",
            "Ecuador"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Blue-and-white Swallow`,
        id: `blue-and-white_swallow`,
        scientific: `Pygochelidon cyanoleuca`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Argentina"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Eurasian Crag Martin`,
        id: `eurasian_crag_martin`,
        scientific: `Ptyonoprogne rupestris`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Greece"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Pacific Swallow`,
        id: `pacific_swallow`,
        scientific: `Hirundo tahitica`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR",
            "AU",
            "PO"
        ],
        commonCountryNames: [
            "Japan",
            "Indonesia",
            "Malaysia",
            "Thailand",
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Welcome Swallow`,
        id: `welcome_swallow`,
        scientific: `Hirundo neoxena`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Australia",
            "New Zealand"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: true
    },
    {
        name: `Barn Swallow`,
        id: `barn_swallow`,
        scientific: `Hirundo rustica`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "Worldwide"
        ],
        commonCountryNames: [
            "China",
            "Japan",
            "Germany",
            "Spain",
            "Ireland",
            "Greece",
            "Portugal",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Common House Martin`,
        id: `common_house_martin`,
        scientific: `Delichon urbicum`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Russia",
            "Netherlands",
            "Denmark",
            "Turkey",
            "United Kingdom"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-rumped Swallow`,
        id: `red-rumped_swallow`,
        scientific: `Cecropis daurica`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "OR",
            "AF"
        ],
        commonCountryNames: [
            "Greece"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Japanese Bush Warbler`,
        id: `japanese_bush_warbler`,
        scientific: `Horornis diphone`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Cetti's Warbler`,
        id: `cetti's_warbler`,
        scientific: `Cettia cetti`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Spain",
            "Portugal"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Western Bonelli's Warbler`,
        id: `western_bonelli's_warbler`,
        scientific: `Phylloscopus bonelli`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Portugal"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Yellow-browed Warbler`,
        id: `yellow-browed_warbler`,
        scientific: `Phylloscopus inornatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Willow Warbler`,
        id: `willow_warbler`,
        scientific: `Phylloscopus trochilus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Finland",
            "Estonia"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Malagasy Brush Warbler`,
        id: `malagasy_brush_warbler`,
        scientific: `Nesillas typica`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Australian Reed Warbler`,
        id: `australian_reed_warbler`,
        scientific: `Acrocephalus australis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Common Reed Warbler`,
        id: `common_reed_warbler`,
        scientific: `Acrocephalus scirpaceus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Black-capped Donacobius`,
        id: `black-capped_donacobius`,
        scientific: `Donacobius atricapilla`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Zitting Cisticola`,
        id: `zitting_cisticola`,
        scientific: `Cisticola juncidis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "AF",
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Portugal"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Madagascar Cisticola`,
        id: `madagascar_cisticola`,
        scientific: `Cisticola cherina`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Yellow-bellied Prinia`,
        id: `yellow-bellied_prinia`,
        scientific: `Prinia flaviventris`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Plain Prinia`,
        id: `plain_prinia`,
        scientific: `Prinia inornata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Tailorbird`,
        id: `common_tailorbird`,
        scientific: `Orthotomus sutorius`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India",
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Eurasian Blackcap`,
        id: `eurasian_blackcap`,
        scientific: `Sylvia atricapilla`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Portugal"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Sardinian Warbler`,
        id: `sardinian_warbler`,
        scientific: `Curruca melanocephala`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Spain",
            "Greece"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Whitethroat`,
        id: `common_whitethroat`,
        scientific: `Curruca communis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Russia",
            "France",
            "Belgium"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Vinous-throated Parrotbill`,
        id: `vinous-throated_parrotbill`,
        scientific: `Suthora webbiana`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Warbling White-eye`,
        id: `warbling_white-eye`,
        scientific: `Zosterops japonicus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Indian White-eye`,
        id: `indian_white-eye`,
        scientific: `Zosterops palpebrosus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Cape White-eye`,
        id: `cape_white-eye`,
        scientific: `Zosterops virens`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Malagasy White-eye`,
        id: `malagasy_white-eye`,
        scientific: `Zosterops maderaspatanus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Silvereye`,
        id: `silvereye`,
        scientific: `Zosterops lateralis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AU",
            "PO"
        ],
        commonCountryNames: [
            "New Zealand"
        ],
        commonRegionCodes: [
            "AU"
        ],
        commonAll: false
    },
    {
        name: `Solomons White-eye`,
        id: `solomons_white-eye`,
        scientific: `Zosterops kulambangrae`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Jungle Babbler`,
        id: `jungle_babbler`,
        scientific: `Argya striata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Chinese Hwamei`,
        id: `chinese_hwamei`,
        scientific: `Garrulax canorus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Asian Fairy-bluebird`,
        id: `asian_fairy-bluebird`,
        scientific: `Irena puella`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Ruby-crowned Kinglet`,
        id: `ruby-crowned_kinglet`,
        scientific: `Corthylio calendula`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Goldcrest`,
        id: `goldcrest`,
        scientific: `Regulus regulus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Veracruz Wren`,
        id: `veracruz_wren`,
        scientific: `Campylorhynchus rufinucha`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Rufous-and-white Wren`,
        id: `rufous-and-white_wren`,
        scientific: `Thryophilus rufalbus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: true
    },
    {
        name: `Carolina Wren`,
        id: `carolina_wren`,
        scientific: `Thryothorus ludovicianus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "United States"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Eurasian Wren`,
        id: `eurasian_wren`,
        scientific: `Troglodytes troglodytes`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Ireland",
            "Greece",
            "Portugal",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `House Wren`,
        id: `house_wren`,
        scientific: `Troglodytes aedon`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Blue-gray Gnatcatcher`,
        id: `blue-gray_gnatcatcher`,
        scientific: `Polioptila caerulea`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-breasted Nuthatch`,
        id: `white-breasted_nuthatch`,
        scientific: `Sitta carolinensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "United States"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Western Rock Nuthatch`,
        id: `western_rock_nuthatch`,
        scientific: `Sitta neumayer`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Greece"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Eurasian Nuthatch`,
        id: `eurasian_nuthatch`,
        scientific: `Sitta europaea`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Spain",
            "Greece",
            "Italy",
            "Austria",
            "Czech Republic",
            "Estonia",
            "Turkey",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Northern Mockingbird`,
        id: `northern_mockingbird`,
        scientific: `Mimus polyglottos`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "United States",
            "Canada",
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Tropical Mockingbird`,
        id: `tropical_mockingbird`,
        scientific: `Mimus gilvus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Chalk-browed Mockingbird`,
        id: `chalk-browed_mockingbird`,
        scientific: `Mimus saturninus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Asian Glossy Starling`,
        id: `asian_glossy_starling`,
        scientific: `Aplonis panayensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Yellow-faced Myna`,
        id: `yellow-faced_myna`,
        scientific: `Mino dumontii`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Long-tailed Myna`,
        id: `long-tailed_myna`,
        scientific: `Mino kreffti`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Crested Myna`,
        id: `crested_myna`,
        scientific: `Acridotheres cristatellus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Jungle Myna`,
        id: `jungle_myna`,
        scientific: `Acridotheres fuscus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Common Myna`,
        id: `common_myna`,
        scientific: `Acridotheres tristis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Australia",
            "India",
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: true
    },
    {
        name: `White-cheeked Starling`,
        id: `white-cheeked_starling`,
        scientific: `Spodiopsar cineraceus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-collared Starling`,
        id: `black-collared_starling`,
        scientific: `Gracupica nigricollis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Brahminy Starling`,
        id: `brahminy_starling`,
        scientific: `Sturnia pagodarum`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Starling`,
        id: `common_starling`,
        scientific: `Sturnus vulgaris`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "United States",
            "Canada",
            "Germany",
            "New Zealand",
            "Ireland",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: true
    },
    {
        name: `Spotless Starling`,
        id: `spotless_starling`,
        scientific: `Sturnus unicolor`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Spain",
            "Portugal"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Cape Starling`,
        id: `cape_starling`,
        scientific: `Lamprotornis nitens`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Greater Blue-eared Starling`,
        id: `greater_blue-eared_starling`,
        scientific: `Lamprotornis chalybaeus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya",
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Superb Starling`,
        id: `superb_starling`,
        scientific: `Lamprotornis superbus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Madagascar Starling`,
        id: `madagascar_starling`,
        scientific: `Hartlaubius auratus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Violet-backed Starling`,
        id: `violet-backed_starling`,
        scientific: `Cinnyricinclus leucogaster`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-winged Starling`,
        id: `red-winged_starling`,
        scientific: `Onychognathus morio`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa",
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Yellow-billed Oxpecker`,
        id: `yellow-billed_oxpecker`,
        scientific: `Buphagus africanus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Eastern Bluebird`,
        id: `eastern_bluebird`,
        scientific: `Sialia sialis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "United States"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Song Thrush`,
        id: `song_thrush`,
        scientific: `Turdus philomelos`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "New Zealand",
            "Ireland",
            "Poland",
            "France",
            "Austria",
            "Switzerland",
            "Czech Republic",
            "Belgium",
            "Croatia",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Mistle Thrush`,
        id: `mistle_thrush`,
        scientific: `Turdus viscivorus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Ireland",
            "France",
            "Sweden",
            "Norway",
            "Austria",
            "Switzerland",
            "Belgium",
            "Estonia",
            "Ukraine"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Olive Thrush`,
        id: `olive_thrush`,
        scientific: `Turdus olivaceus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Redwing`,
        id: `redwing`,
        scientific: `Turdus iliacus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Ireland",
            "Russia",
            "Sweden",
            "Norway",
            "Finland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Blackbird`,
        id: `common_blackbird`,
        scientific: `Turdus merula`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "Germany",
            "Germany",
            "New Zealand",
            "Spain",
            "Ireland",
            "Greece",
            "Portugal",
            "Poland",
            "Poland",
            "Russia",
            "France",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Netherlands",
            "Italy",
            "Italy",
            "Finland",
            "Austria",
            "Austria",
            "Switzerland",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Czech Republic",
            "Belgium",
            "Belgium",
            "Belgium",
            "Estonia",
            "Estonia",
            "Ukraine",
            "Ukraine",
            "Turkey",
            "Turkey",
            "Croatia",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: true
    },
    {
        name: `Island Thrush`,
        id: `island_thrush`,
        scientific: `Turdus poliocephalus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR",
            "AU",
            "PO"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Fieldfare`,
        id: `fieldfare`,
        scientific: `Turdus pilaris`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Sweden",
            "Norway"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `American Robin`,
        id: `american_robin`,
        scientific: `Turdus migratorius`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "United States",
            "Canada",
            "Mexico"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: true
    },
    {
        name: `Rufous-bellied Thrush`,
        id: `rufous-bellied_thrush`,
        scientific: `Turdus rufiventris`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Clay-colored Thrush`,
        id: `clay-colored_thrush`,
        scientific: `Turdus grayi`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Mexico",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: true
    },
    {
        name: `Oriental Magpie-Robin`,
        id: `oriental_magpie-robin`,
        scientific: `Copsychus saularis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "China",
            "India",
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Madagascar Magpie-Robin`,
        id: `madagascar_magpie-robin`,
        scientific: `Copsychus albospecularis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Indian Robin`,
        id: `indian_robin`,
        scientific: `Copsychus fulicatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-rumped Shama`,
        id: `white-rumped_shama`,
        scientific: `Copsychus malabaricus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Fiscal Flycatcher`,
        id: `fiscal_flycatcher`,
        scientific: `Sigelus silens`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Asian Brown Flycatcher`,
        id: `asian_brown_flycatcher`,
        scientific: `Muscicapa dauurica`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `European Robin`,
        id: `european_robin`,
        scientific: `Erithacus rubecula`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Spain",
            "Ireland",
            "Greece",
            "Portugal",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `White-browed Robin-Chat`,
        id: `white-browed_robin-chat`,
        scientific: `Cossypha heuglini`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Uganda"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Cape Robin-Chat`,
        id: `cape_robin-chat`,
        scientific: `Dessonornis caffer`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Nightingale`,
        id: `common_nightingale`,
        scientific: `Luscinia megarhynchos`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Italy",
            "Turkey",
            "Hungary"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Japanese Robin`,
        id: `japanese_robin`,
        scientific: `Larvivora akahige`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `European Pied Flycatcher`,
        id: `european_pied_flycatcher`,
        scientific: `Ficedula hypoleuca`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Collared Flycatcher`,
        id: `collared_flycatcher`,
        scientific: `Ficedula albicollis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Greece"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-flanked Bluetail`,
        id: `red-flanked_bluetail`,
        scientific: `Tarsiger cyanurus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black Redstart`,
        id: `black_redstart`,
        scientific: `Phoenicurus ochruros`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "Spain",
            "France",
            "Austria",
            "Switzerland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Redstart`,
        id: `common_redstart`,
        scientific: `Phoenicurus phoenicurus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "France"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Daurian Redstart`,
        id: `daurian_redstart`,
        scientific: `Phoenicurus auroreus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Blue Rock Thrush`,
        id: `blue_rock_thrush`,
        scientific: `Monticola solitarius`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "Greece"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Pied Bush Chat`,
        id: `pied_bush_chat`,
        scientific: `Saxicola caprata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `African Stonechat`,
        id: `african_stonechat`,
        scientific: `Saxicola torquatus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Madagascar Stonechat`,
        id: `madagascar_stonechat`,
        scientific: `Saxicola sibilla`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `European Stonechat`,
        id: `european_stonechat`,
        scientific: `Saxicola rubicola`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Portugal"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Northern Wheatear`,
        id: `northern_wheatear`,
        scientific: `Oenanthe oenanthe`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `American Dipper`,
        id: `american_dipper`,
        scientific: `Cinclus mexicanus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Midget Flowerpecker`,
        id: `midget_flowerpecker`,
        scientific: `Dicaeum aeneum`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Solomon Islands"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-chested Sunbird`,
        id: `red-chested_sunbird`,
        scientific: `Cinnyris erythrocercus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Purple Sunbird`,
        id: `purple_sunbird`,
        scientific: `Cinnyris asiaticus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Olive-backed Sunbird`,
        id: `olive-backed_sunbird`,
        scientific: `Cinnyris jugularis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Malagasy Green Sunbird`,
        id: `malagasy_green_sunbird`,
        scientific: `Cinnyris notatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Rock Sparrow`,
        id: `rock_sparrow`,
        scientific: `Petronia petronia`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Greece"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Cape Sparrow`,
        id: `cape_sparrow`,
        scientific: `Passer melanurus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Eurasian Tree Sparrow`,
        id: `eurasian_tree_sparrow`,
        scientific: `Passer montanus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "China",
            "Japan",
            "Poland",
            "Russia",
            "Sweden",
            "Norway",
            "Netherlands",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Italian Sparrow`,
        id: `italian_sparrow`,
        scientific: `Passer italiae`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Italy"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `House Sparrow`,
        id: `house_sparrow`,
        scientific: `Passer domesticus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "OR",
            "AF"
        ],
        commonCountryNames: [
            "United States",
            "Canada",
            "India",
            "Brazil",
            "Germany",
            "Mexico",
            "New Zealand",
            "Spain",
            "Ireland",
            "Greece",
            "Portugal",
            "Poland",
            "Russia",
            "Argentina",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "Colombia",
            "Ecuador",
            "Peru",
            "Peru",
            "Malaysia",
            "Thailand",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL",
            "NA"
        ],
        commonAll: true
    },
    {
        name: `Southern Masked Weaver`,
        id: `southern_masked_weaver`,
        scientific: `Ploceus velatus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa",
            "Tanzania"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Red-billed Quelea`,
        id: `red-billed_quelea`,
        scientific: `Quelea quelea`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: true
    },
    {
        name: `Red Fody`,
        id: `red_fody`,
        scientific: `Foudia madagascariensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-winged Red Bishop`,
        id: `black-winged_red_bishop`,
        scientific: `Euplectes hordeaceus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Southern Red Bishop`,
        id: `southern_red_bishop`,
        scientific: `Euplectes orix`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Madagascar Mannikin`,
        id: `madagascar_mannikin`,
        scientific: `Lepidopygia nana`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Indian Silverbill`,
        id: `indian_silverbill`,
        scientific: `Euodice malabarica`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "India"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Java Sparrow`,
        id: `java_sparrow`,
        scientific: `Padda oryzivora`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Indonesia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Scaly-breasted Munia`,
        id: `scaly-breasted_munia`,
        scientific: `Lonchura punctulata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR",
            "AU"
        ],
        commonCountryNames: [
            "Malaysia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Javan Munia`,
        id: `javan_munia`,
        scientific: `Lonchura leucogastroides`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Indonesia",
            "Malaysia",
            "Thailand"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White-headed Munia`,
        id: `white-headed_munia`,
        scientific: `Lonchura maja`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "OR"
        ],
        commonCountryNames: [
            "Indonesia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Blue-faced Parrotfinch`,
        id: `blue-faced_parrotfinch`,
        scientific: `Erythrura trichroa`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AU"
        ],
        commonCountryNames: [
            "Papua New Guinea"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Waxbill`,
        id: `common_waxbill`,
        scientific: `Estrilda astrild`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa",
            "Portugal"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-billed Firefinch`,
        id: `red-billed_firefinch`,
        scientific: `Lagonosticta senegala`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `African Firefinch`,
        id: `african_firefinch`,
        scientific: `Lagonosticta rubricata`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Dunnock`,
        id: `dunnock`,
        scientific: `Prunella modularis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "New Zealand",
            "United Kingdom"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Western Yellow Wagtail`,
        id: `western_yellow_wagtail`,
        scientific: `Motacilla flava`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Russia"
        ],
        commonRegionCodes: [
            "OR"
        ],
        commonAll: false
    },
    {
        name: `Madagascar Wagtail`,
        id: `madagascar_wagtail`,
        scientific: `Motacilla flaviventris`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Madagascar"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `White Wagtail`,
        id: `white_wagtail`,
        scientific: `Motacilla alba`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Finland",
            "Austria",
            "Switzerland",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `African Pied Wagtail`,
        id: `african_pied_wagtail`,
        scientific: `Motacilla aguimp`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "Uganda",
            "Zambia"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Japanese Wagtail`,
        id: `japanese_wagtail`,
        scientific: `Motacilla grandis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `African Pipit`,
        id: `african_pipit`,
        scientific: `Anthus cinnamomeus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Meadow Pipit`,
        id: `meadow_pipit`,
        scientific: `Anthus pratensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Ireland"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Tree Pipit`,
        id: `tree_pipit`,
        scientific: `Anthus trivialis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Russia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Chaffinch`,
        id: `common_chaffinch`,
        scientific: `Fringilla coelebs`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "New Zealand",
            "Spain",
            "Ireland",
            "Greece",
            "Portugal",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: true
    },
    {
        name: `Chinese Grosbeak`,
        id: `chinese_grosbeak`,
        scientific: `Eophona migratoria`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Japanese Grosbeak`,
        id: `japanese_grosbeak`,
        scientific: `Eophona personata`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Eurasian Bullfinch`,
        id: `eurasian_bullfinch`,
        scientific: `Pyrrhula pyrrhula`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Sweden",
            "Norway",
            "Finland",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `House Finch`,
        id: `house_finch`,
        scientific: `Haemorhous mexicanus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "United States",
            "Canada",
            "Brazil"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `European Greenfinch`,
        id: `european_greenfinch`,
        scientific: `Chloris chloris`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Spain",
            "Ireland",
            "Portugal",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Grey-capped Greenfinch`,
        id: `grey-capped_greenfinch`,
        scientific: `Chloris sinica`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "OR"
        ],
        commonCountryNames: [
            "China"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Yellow-fronted Canary`,
        id: `yellow-fronted_canary`,
        scientific: `Crithagra mozambica`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "AF"
        ],
        commonCountryNames: [
            "South Africa",
            "Tanzania",
            "Kenya"
        ],
        commonRegionCodes: [
            "AF"
        ],
        commonAll: false
    },
    {
        name: `Common Linnet`,
        id: `common_linnet`,
        scientific: `Linaria cannabina`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Ireland",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Switzerland",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Croatia",
            "Hungary"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Common Redpoll`,
        id: `common_redpoll`,
        scientific: `Acanthis flammea`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL",
            "NA"
        ],
        commonCountryNames: [
            "Sweden",
            "Norway",
            "Finland",
            "United Kingdom"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `European Goldfinch`,
        id: `european_goldfinch`,
        scientific: `Carduelis carduelis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Spain",
            "Ireland",
            "Greece",
            "Portugal",
            "Poland",
            "Russia",
            "France",
            "Sweden",
            "Norway",
            "Netherlands",
            "Italy",
            "Finland",
            "Austria",
            "Switzerland",
            "Denmark",
            "Czech Republic",
            "Belgium",
            "Estonia",
            "Ukraine",
            "Turkey",
            "Croatia",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `European Serin`,
        id: `european_serin`,
        scientific: `Serinus serinus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL",
            "AF"
        ],
        commonCountryNames: [
            "Spain",
            "Greece",
            "Portugal",
            "Italy",
            "Austria"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `American Goldfinch`,
        id: `american_goldfinch`,
        scientific: `Spinus tristis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "United States",
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Eurasian Siskin`,
        id: `eurasian_siskin`,
        scientific: `Spinus spinus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Greece",
            "Finland",
            "Turkey",
            "Hungary",
            "United Kingdom"
        ],
        commonRegionCodes: [
            "PAL"
        ],
        commonAll: false
    },
    {
        name: `Yellow-throated Euphonia`,
        id: `yellow-throated_euphonia`,
        scientific: `Euphonia hirundinacea`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Snow Bunting`,
        id: `snow_bunting`,
        scientific: `Plectrophenax nivalis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "PAL"
        ],
        commonCountryNames: [
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Corn Bunting`,
        id: `corn_bunting`,
        scientific: `Emberiza calandra`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Portugal"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Yellowhammer`,
        id: `yellowhammer`,
        scientific: `Emberiza citrinella`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "New Zealand",
            "Estonia"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Cretzschmar's Bunting`,
        id: `cretzschmar's_bunting`,
        scientific: `Emberiza caesia`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Greece"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-headed Bunting`,
        id: `black-headed_bunting`,
        scientific: `Emberiza melanocephala`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Greece"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-faced Bunting`,
        id: `black-faced_bunting`,
        scientific: `Emberiza spodocephala`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Ochre-rumped Bunting`,
        id: `ochre-rumped_bunting`,
        scientific: `Emberiza yessoensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Japan"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Common Reed Bunting`,
        id: `common_reed_bunting`,
        scientific: `Emberiza schoeniclus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "PAL"
        ],
        commonCountryNames: [
            "Germany",
            "Italy"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-chinned Sparrow`,
        id: `black-chinned_sparrow`,
        scientific: `Spizella atrogularis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `American Tree Sparrow`,
        id: `american_tree_sparrow`,
        scientific: `Spizelloides arborea`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Dark-eyed Junco`,
        id: `dark-eyed_junco`,
        scientific: `Junco hyemalis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "United States",
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Rufous-collared Sparrow`,
        id: `rufous-collared_sparrow`,
        scientific: `Zonotrichia capensis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "MA",
            "SA"
        ],
        commonAll: true
    },
    {
        name: `White-throated Sparrow`,
        id: `white-throated_sparrow`,
        scientific: `Zonotrichia albicollis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "Canada"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `Song Sparrow`,
        id: `song_sparrow`,
        scientific: `Melospiza melodia`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "United States",
            "Canada"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Red-breasted Meadowlark`,
        id: `red-breasted_meadowlark`,
        scientific: `Leistes militaris`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Montezuma Oropendola`,
        id: `montezuma_oropendola`,
        scientific: `Psarocolius montezuma`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Golden-winged Cacique`,
        id: `golden-winged_cacique`,
        scientific: `Cacicus chrysopterus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Yellow-rumped Cacique`,
        id: `yellow-rumped_cacique`,
        scientific: `Cacicus cela`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Altamira Oriole`,
        id: `altamira_oriole`,
        scientific: `Icterus gularis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Streak-backed Oriole`,
        id: `streak-backed_oriole`,
        scientific: `Icterus pustulatus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Baltimore Oriole`,
        id: `baltimore_oriole`,
        scientific: `Icterus galbula`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "United States"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-vented Oriole`,
        id: `black-vented_oriole`,
        scientific: `Icterus wagleri`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-cowled Oriole`,
        id: `black-cowled_oriole`,
        scientific: `Icterus prosthemelas`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Red-winged Blackbird`,
        id: `red-winged_blackbird`,
        scientific: `Agelaius phoeniceus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "United States",
            "Canada",
            "Mexico"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: true
    },
    {
        name: `Shiny Cowbird`,
        id: `shiny_cowbird`,
        scientific: `Molothrus bonariensis`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "SA"
        ],
        commonCountryNames: [
            "Brazil"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Melodious Blackbird`,
        id: `melodious_blackbird`,
        scientific: `Dives dives`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Common Grackle`,
        id: `common_grackle`,
        scientific: `Quiscalus quiscula`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [
            "United States",
            "Canada",
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Great-tailed Grackle`,
        id: `great-tailed_grackle`,
        scientific: `Quiscalus mexicanus`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: true
    },
    {
        name: `Chestnut-capped Blackbird`,
        id: `chestnut-capped_blackbird`,
        scientific: `Chrysomus ruficapillus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Golden-winged Warbler`,
        id: `golden-winged_warbler`,
        scientific: `Vermivora chrysoptera`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Masked Yellowthroat`,
        id: `masked_yellowthroat`,
        scientific: `Geothlypis aequinoctialis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `American Redstart`,
        id: `american_redstart`,
        scientific: `Setophaga ruticilla`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: false
    },
    {
        name: `American Yellow Warbler`,
        id: `american_yellow_warbler`,
        scientific: `Setophaga aestiva`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "Mexico",
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Mangrove Warbler`,
        id: `mangrove_warbler`,
        scientific: `Setophaga petechia`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "NA",
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Chestnut-sided Warbler`,
        id: `chestnut-sided_warbler`,
        scientific: `Setophaga pensylvanica`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "NA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Collared Whitestart`,
        id: `collared_whitestart`,
        scientific: `Myioborus torquatus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Northern Cardinal`,
        id: `northern_cardinal`,
        scientific: `Cardinalis cardinalis`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "NA",
            "MA"
        ],
        commonCountryNames: [
            "United States",
            "Canada",
            "Mexico"
        ],
        commonRegionCodes: [
            "NA"
        ],
        commonAll: true
    },
    {
        name: `Red-legged Honeycreeper`,
        id: `red-legged_honeycreeper`,
        scientific: `Cyanerpes cyaneus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Buff-throated Saltator`,
        id: `buff-throated_saltator`,
        scientific: `Saltator maximus`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Black-headed Saltator`,
        id: `black-headed_saltator`,
        scientific: `Saltator atriceps`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Golden-billed Saltator`,
        id: `golden-billed_saltator`,
        scientific: `Saltator aurantiirostris`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Argentina"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Bananaquit`,
        id: `bananaquit`,
        scientific: `Coereba flaveola`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Blue-black Grassquit`,
        id: `blue-black_grassquit`,
        scientific: `Volatinia jacarina`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Cinnamon-rumped Seedeater`,
        id: `cinnamon-rumped_seedeater`,
        scientific: `Sporophila torqueola`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "MA"
        ],
        commonCountryNames: [
            "Mexico"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Black-and-rufous Warbling Finch`,
        id: `black-and-rufous_warbling_finch`,
        scientific: `Poospiza nigrorufa`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Argentina"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Saffron Finch`,
        id: `saffron_finch`,
        scientific: `Sicalis flaveola`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil",
            "Argentina"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: true
    },
    {
        name: `Red-crested Cardinal`,
        id: `red-crested_cardinal`,
        scientific: `Paroaria coronata`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: true
    },
    {
        name: `Yellow-billed Cardinal`,
        id: `yellow-billed_cardinal`,
        scientific: `Paroaria capitata`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Argentina"
        ],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Red-capped Cardinal`,
        id: `red-capped_cardinal`,
        scientific: `Paroaria gularis`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "SA"
        ],
        commonAll: false
    },
    {
        name: `Blue-gray Tanager`,
        id: `blue-gray_tanager`,
        scientific: `Thraupis episcopus`,
        commonCountry: true,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [
            "Colombia",
            "Ecuador",
            "Peru"
        ],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    },
    {
        name: `Sayaca Tanager`,
        id: `sayaca_tanager`,
        scientific: `Thraupis sayaca`,
        commonCountry: true,
        commonRegion: false,
        breedingRegion: [
            "SA"
        ],
        commonCountryNames: [
            "Brazil"
        ],
        commonRegionCodes: [],
        commonAll: false
    },
    {
        name: `Golden-hooded Tanager`,
        id: `golden-hooded_tanager`,
        scientific: `Stilpnia larvata`,
        commonCountry: false,
        commonRegion: true,
        breedingRegion: [
            "MA",
            "SA"
        ],
        commonCountryNames: [],
        commonRegionCodes: [
            "MA"
        ],
        commonAll: false
    }
];


const $bd02c871d9c5ba8e$export$d047a7c56db64af4 = async function(url) {
    try {
        const res = await fetch(url);
        return res;
    } catch (err) {
        console.log(err);
    }
};


const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    birds: [],
    favourites: [],
    likedTracks: [],
    menu: "closed",
    activeMenu: "",
    search: {
        regionCode: "ALL",
        region: "Worldwide",
        countryCode2: "",
        countryCode3: "",
        country: "Worldwide",
        results: [],
        loadedCountry: "",
        loadedRegion: ""
    },
    activeBirdId: "",
    activeAudioTypeIndex: 0,
    activeAudioTrackIndex: 0,
    selectAudioTypeIndex: 0,
    selectAudioTrackIndex: 0,
    availableAudioTypes: [],
    availableAudioTracks: 0,
    loadedRecordings: {
        call: [],
        song: [],
        alarm: []
    },
    settings: {
        settingDarkMode: "off",
        settingDisableImages: "off",
        likedAudio: "off",
        // settingAccessibilityColours: "off",
        theme: "",
        themeRangeColour: 195,
        themeRangeContrast: 80,
        themeRangeBrightness: 95
    },
    xenoLoading: false,
    xenoLoaded: false,
    xenoApiDisabled: false,
    version: ""
};
const $0f1d4402dffacf5b$var$createBirdObject = function(bird) {
    return {
        name: bird.name,
        scientific: bird.scientific,
        id: bird.name.toLowerCase().replaceAll(" ", "_"),
        location: {
            commonCountryNames: bird.commonCountryNames,
            commonRegionCodes: bird.commonRegionCodes.length > 0 ? bird.commonRegionCodes.map((code)=>(0, $ba30e20475feac5a$export$36b79d2b85570e14).filter((reg)=>reg.code === code)[0].name) : bird.commonCountryNames.map((name)=>(0, $ba30e20475feac5a$export$4d78c43b7fa734a7).filter((country)=>country.name === name)[0].region).filter((val, i, arr)=>arr.indexOf(val) === i)
        },
        recordings: {
            loaded: false,
            loadedCountry: "",
            loadedRegion: "",
            loadedArea: "",
            loadedAreas: [],
            call: [],
            song: [],
            alarm: []
        },
        favourite: false,
        image: {
            pageid: "",
            title: "",
            src: "",
            thumb: "",
            filename: "",
            attribution: {
                attribution: false,
                artist: "",
                credit: "",
                license: "",
                licenseUrl: ""
            }
        }
    };
};
const $0f1d4402dffacf5b$var$createRecordingObject = function(data) {
    const recording = data;
    return {
        id: recording.id,
        en: recording.en,
        file: recording.file,
        recordist: recording.rec,
        area: $0f1d4402dffacf5b$var$getRegion(recording.cnt),
        country: recording.cnt,
        location: recording.loc,
        also: recording.also,
        type: recording.type,
        date: recording.date,
        url: recording.url,
        active: false,
        liked: $0f1d4402dffacf5b$export$ca000e230c0caa3e.likedTracks.includes(recording.id) ? true : false
    };
};
const $0f1d4402dffacf5b$var$createAttributionObject = function(data) {
    return {
        attribution: data.AttributionRequired.value,
        artist: data.Artist ? data.Artist.value : "",
        credit: data.Credit ? data.Credit.value : "",
        license: data.LicenseShortName ? data.LicenseShortName.value : "",
        licenseUrl: data.LicenseUrl ? data.LicenseUrl.value : ""
    };
};
//////////////////////////////////////////////////////
// SEARCH
//////////////////////////////////////////////////////
//
const $0f1d4402dffacf5b$var$getRegion = function(country) {
    let region;
    const countryObject = (0, $ba30e20475feac5a$export$4d78c43b7fa734a7).filter((cnt)=>cnt.name === country)[0];
    if (countryObject) region = countryObject.region;
    return region;
};
const $0f1d4402dffacf5b$export$e3340ddcfe22553f = function() {
    // console.log(state.search);
    let countryName, countryResults, regionResults, results;
    const regionCode = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.regionCode;
    const countryCode3 = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.countryCode3;
    // console.log(state.search);
    // console.log(countryNameFilter.length);
    if (countryCode3) {
        countryName = (0, $ba30e20475feac5a$export$4d78c43b7fa734a7).filter((country)=>country.code3 === countryCode3)[0].name;
        countryResults = (0, $c72b185320e6bb41$export$7028c44a8021654a).filter((bird)=>bird.commonCountryNames.includes(countryName));
        results = countryResults;
    }
    if (regionCode && regionCode !== "ALL") {
        regionResults = (0, $c72b185320e6bb41$export$7028c44a8021654a).filter((bird)=>bird.commonRegionCodes.includes(regionCode));
        results = regionResults;
    }
    if (regionCode === "ALL") {
        regionResults = (0, $c72b185320e6bb41$export$7028c44a8021654a).filter((bird)=>bird.commonAll);
        results = regionResults;
    }
    // console.log(results);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results = results;
// return results;
};
const $0f1d4402dffacf5b$export$284d082295e21ee8 = function() {
    // console.log(state.search.results);
    const birds = $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.filter((bird)=>$0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.map((el)=>el.name).includes(bird.name));
    // console.log(birds);
    return birds;
};
const $0f1d4402dffacf5b$export$f0692e1c55bfc4f1 = function(value) {
    let countryName = "Various";
    let regionCode, regionName, countryCode2, countryCode3;
    const countryNameFilter = (0, $ba30e20475feac5a$export$4d78c43b7fa734a7).filter((country)=>country.code3 === value);
    if (countryNameFilter.length === 1) {
        countryName = countryNameFilter[0].name;
        countryCode2 = countryNameFilter[0].code2;
        countryCode3 = value;
        regionName = countryNameFilter[0].region;
    }
    if (countryNameFilter.length === 0) {
        regionCode = value;
        regionName = (0, $ba30e20475feac5a$export$36b79d2b85570e14).filter((region)=>region.code === value)[0].name;
    }
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.regionCode = regionCode;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.region = regionName;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.countryCode2 = countryCode2;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.countryCode3 = countryCode3;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.country = countryName;
};
const $0f1d4402dffacf5b$export$b5153b0da6732e5f = function(menu) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeMenu = menu;
};
const $0f1d4402dffacf5b$export$ca9acaa75ad0e50f = function() {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.regionCode = "ALL";
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.region = "Worldwide";
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.country = "Worldwide";
};
const $0f1d4402dffacf5b$export$c60294ec74f48826 = function(orientation = "") {
    // console.log(`pre: ${state.menu}`);
    if (orientation === "landscape-primary") {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.menu = "open";
        // console.log(`post: ${state.menu}`);
        return;
    }
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.menu === "closed" ? $0f1d4402dffacf5b$export$ca000e230c0caa3e.menu = "open" : $0f1d4402dffacf5b$export$ca000e230c0caa3e.menu = "closed";
// console.log(`pre: ${state.menu}`);
};
const $0f1d4402dffacf5b$export$52aab5b30cfda272 = function() {
    // remove any birds no longer in the list
    $0f1d4402dffacf5b$var$removeBird();
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.forEach(function(bird) {
        if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.filter((el)=>el.name === bird.name && el.scientific !== "").length === 0) $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.push($0f1d4402dffacf5b$var$createBirdObject(bird));
    });
    // console.log(state.birds);
    // Calculate shortname for sorting
    $0f1d4402dffacf5b$var$calculateShortNames();
    // sort alphabetically
    $0f1d4402dffacf5b$export$6a47fc9e4493b73f();
    // add to local storage
    $0f1d4402dffacf5b$export$89a31c021be7d491();
};
const $0f1d4402dffacf5b$var$calculateShortNames = function() {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.forEach((bird)=>bird.shortName = bird.name.split(" ").filter((word)=>!(0, $ba30e20475feac5a$export$dbeb5b71dd82a6da).some((el)=>el == word)).join(" "));
};
// Remove bird if not in config list (amendments/updates)
const $0f1d4402dffacf5b$var$removeBird = function() {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.forEach((bird, i)=>{
        if (!(0, $c72b185320e6bb41$export$7028c44a8021654a).some((el)=>el.name === bird.name)) // console.log(bird.name);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.splice(i, 1);
    });
};
const $0f1d4402dffacf5b$export$6a47fc9e4493b73f = function() {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.sort($0f1d4402dffacf5b$var$sortBirds);
};
// Sort bird objects
const $0f1d4402dffacf5b$var$sortBirds = function compare(a, b) {
    if (a.shortName < b.shortName) return -1;
    if (a.shortName > b.shortName) return 1;
    return 0;
};
const $0f1d4402dffacf5b$export$c9818fd4c480edd5 = function(data) {
    data.forEach(function(bird) {
        if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.filter((el)=>el.name === bird.name).length === 0) // console.log(bird);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.push($0f1d4402dffacf5b$var$createBirdObject(bird));
    });
    // Calculate shortname for sorting
    $0f1d4402dffacf5b$var$calculateShortNames();
    // sort alphabetically
    $0f1d4402dffacf5b$export$6a47fc9e4493b73f();
    // console.log(state.birds);
    // add to local storage
    $0f1d4402dffacf5b$export$89a31c021be7d491();
};
const $0f1d4402dffacf5b$export$498616224de3edb7 = function(id) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId = id;
};
const $0f1d4402dffacf5b$export$31fcea2bd3618144 = function() {
    const bird = $0f1d4402dffacf5b$export$615a5fdd1e2537fe($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId)[0];
    if (bird) {
        const types = $0f1d4402dffacf5b$export$ca000e230c0caa3e.availableAudioTypes;
        const typeIndex = $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeAudioTypeIndex;
        const type = types[typeIndex];
        const track = $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeAudioTrackIndex;
        const recordingId = $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings[type][track].id;
        const recording = bird.recordings[type].filter((rec)=>rec.id === recordingId)[0];
        return recording;
    }
};
const $0f1d4402dffacf5b$var$getTotalRecordings = function() {
    const recordings = $0f1d4402dffacf5b$export$615a5fdd1e2537fe($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId)[0].recordings;
    const totalRecordings = recordings.call.length + recordings.alarm.length + recordings.song.length;
    return totalRecordings;
};
const $0f1d4402dffacf5b$export$26b30b22eb258808 = function() {
    const recording = $0f1d4402dffacf5b$export$31fcea2bd3618144();
    // console.log(recording);
    if (!recording) return;
    if (recording.liked === true) {
        recording.liked = false;
        const index = $0f1d4402dffacf5b$var$getLikedIndex(recording.id);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.likedTracks.splice(index, 1);
    } else if (recording.liked === false) {
        recording.liked = true;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.likedTracks.push(recording.id);
    }
    // console.log(state.likedTracks);
    $0f1d4402dffacf5b$export$3576fd8b5ce57a75();
    $0f1d4402dffacf5b$export$89a31c021be7d491();
    return recording.liked;
};
// Get liked track index from like tracks array
const $0f1d4402dffacf5b$var$getLikedIndex = function(id) {
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.likedTracks.indexOf(id);
};
const $0f1d4402dffacf5b$export$c546da718ba66399 = function() {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeAudioTypeIndex = 0;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeAudioTrackIndex = 0;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectAudioTypeIndex = 0;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectAudioTrackIndex = 0;
    $0f1d4402dffacf5b$export$1f655c5ff10c374f();
    $0f1d4402dffacf5b$export$34bc8d2cabae523c();
};
const $0f1d4402dffacf5b$export$ff826b15a132fd07 = function() {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectAudioTrackIndex = 0;
};
const $0f1d4402dffacf5b$export$3cb8948afa7dd2b = function(i) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectAudioTypeIndex = i;
    // console.log(state.selectAudioTypeIndex);
    $0f1d4402dffacf5b$export$34bc8d2cabae523c();
};
const $0f1d4402dffacf5b$export$27423439b6d37782 = function(i) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectAudioTrackIndex = i;
};
const $0f1d4402dffacf5b$export$1f655c5ff10c374f = function() {
    // set available types in state
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.availableAudioTypes = [];
    // const bird = getBird(state.activeBirdId)[0];
    // if (bird.recordings.call.length > 0) state.availableAudioTypes.push("call");
    // if (bird.recordings.song.length > 0) state.availableAudioTypes.push("song");
    // if (bird.recordings.alarm.length > 0) state.availableAudioTypes.push("alarm");
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.call.length > 0) $0f1d4402dffacf5b$export$ca000e230c0caa3e.availableAudioTypes.push("call");
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.song.length > 0) $0f1d4402dffacf5b$export$ca000e230c0caa3e.availableAudioTypes.push("song");
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.alarm.length > 0) $0f1d4402dffacf5b$export$ca000e230c0caa3e.availableAudioTypes.push("alarm");
};
const $0f1d4402dffacf5b$export$34bc8d2cabae523c = function() {
    // console.log(getBird(state.activeBirdId)[0]);
    const typeIndex = $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectAudioTypeIndex;
    const type = $0f1d4402dffacf5b$export$ca000e230c0caa3e.availableAudioTypes[typeIndex];
    // const tracks = getBird(state.activeBirdId)[0].recordings[type].length;
    const tracks = $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings[type].length;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.availableAudioTracks = tracks;
};
const $0f1d4402dffacf5b$export$615a5fdd1e2537fe = function(id) {
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.filter((bird)=>bird.id === id);
};
const $0f1d4402dffacf5b$export$23555acef75f97cd = function(id) {
    return (0, $c72b185320e6bb41$export$7028c44a8021654a).filter((bird)=>bird.id === id);
};
const $0f1d4402dffacf5b$export$c3c488c05aeea533 = function(searchQuery) {
    if (!searchQuery) return;
    let results = [];
    // formats the search query into bird id
    const input = searchQuery.toLowerCase().replaceAll(" ", "_");
    const len = input.length;
    // console.log(input);
    // filter results that include the input string id
    if (len >= 3) results = (0, $c72b185320e6bb41$export$7028c44a8021654a).filter((el)=>el.id.includes(input));
    if (len < 3) (0, $c72b185320e6bb41$export$7028c44a8021654a).forEach((el)=>{
        if (el.id.split("_").some((word)=>word.slice(0, len) === input)) results.push(el);
    });
    return results;
};
const $0f1d4402dffacf5b$export$8b1633c0f9396e07 = async function() {
    const selection = $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.filter((bird)=>$0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.map((el)=>el.name).includes(bird.name));
    const birdsNoImage = selection.filter((el)=>el.image.src === "");
    // Return if all bird objects have an image source
    if (birdsNoImage.length === 0) return;
    const len = birdsNoImage.length;
    const selectionArray = [];
    if (len > 50) {
        // create new arrays split into 50 queries per call
        const splits = len % 50 > 0 ? Math.trunc(len / 50) + 1 : len / 50;
        for(let i = 0; i < splits; i++)selectionArray.push(selection.slice(i * 50, i * 50 + 50));
    }
    if (len <= 50) selectionArray.push(birdsNoImage);
    // console.log(selectionArray);
    // call API with selection Array
    // selectionArray.forEach((query) => loadImages(query));
    const arrayLen = selectionArray.length;
    // console.log(len);
    // console.log(arrayLen);
    for(let i = 0; i < arrayLen; i++)await $0f1d4402dffacf5b$var$loadImages(selectionArray[i]);
// console.log("finishing call");
};
const $0f1d4402dffacf5b$var$loadImages = async function(query) {
    try {
        let redirects;
        const birds = query.map((el)=>el.name).join("|");
        // Call API
        const res = await fetch(`${(0, $ba30e20475feac5a$export$ff71a71136b6152f)}${birds}`);
        const data = await res.json();
        // console.log(data);
        if (data.query.redirects) redirects = data.query.redirects;
        const pages = data.query.pages;
        const pageKeys = Object.keys(pages);
        // console.log(data);
        // console.log(redirects);
        // console.log(pages);
        // console.log(pageKeys);
        // console.log(pages);
        // Add the corrected titles to state birds object (redirects)
        if (redirects) redirects.forEach(function(data) {
            const from = data.from;
            const to = data.to;
            const birdIndex = $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.findIndex((el)=>el.name === from);
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds[birdIndex].image.title = to;
        });
        // add titles to state birds object (non-redirects)
        pageKeys.forEach(function(pageKey) {
            const title = pages[pageKey].title;
            const birdIndex = $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.findIndex((el)=>el.name.toLowerCase() === title.toLowerCase());
            if (birdIndex >= 0) $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds[birdIndex].image.title = title;
        });
        // Add remaining data to images objects
        pageKeys.forEach(function(pageKey) {
            // console.log(pageKey);
            const title = pages[pageKey].title;
            const pageid = pages[pageKey].pageid;
            const original = pages[pageKey].original;
            const src = original ? pages[pageKey].original.source : "";
            const thumb = pages[pageKey].thumbnail;
            const thumbSrc = thumb ? pages[pageKey].thumbnail.source : "";
            const filename = src ? src.slice(`${src.lastIndexOf("/") + 1}`) : "";
            const birdIndex = $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.findIndex((el)=>el.image.title === title);
            const birdObject = $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds[birdIndex];
            // only add data to object if the object exists and there is an image source
            if (birdIndex >= 0 && src) {
                birdObject.image.pageid = pageid;
                birdObject.image.src = src;
                birdObject.image.thumb = thumbSrc;
                birdObject.image.filename = filename;
            }
            // console.log(birdObject);
            // update local storage
            $0f1d4402dffacf5b$export$89a31c021be7d491();
        });
    } catch (err) {
        console.error(err);
    }
};
const $0f1d4402dffacf5b$export$af0c6ae8e472b57c = async function(id) {
    try {
        // Get bird image object for birdID param
        const birdImage = $0f1d4402dffacf5b$export$615a5fdd1e2537fe(id)[0].image;
        // if attribution data then return
        if (birdImage.attribution.attribution) return;
        // filename
        const filename = birdImage.filename;
        // Call API
        const link = `${(0, $ba30e20475feac5a$export$ad220dd9b2ecd9a5)}${filename}&format=json`;
        const res = await fetch(link);
        const data = await res.json();
        // Response object path to meta data
        // data.query.pages[pageid or -1].imageinfo[0].extmetadata
        const pageid = Object.keys(data.query.pages)[0];
        const metadata = data.query.pages[`${pageid}`].imageinfo[0].extmetadata;
        // populate the attribution object for the bird image object
        birdImage.attribution = $0f1d4402dffacf5b$var$createAttributionObject(metadata);
    } catch (err) {
        console.error(err);
    }
};
//////////////////////////////////////////////////////////////////////////
// AUDIO - Xeno Canto API
//////////////////////////////////////////////////////////////////////////
// Get xeno region
const $0f1d4402dffacf5b$var$getXenoRegion = function() {
    let xenoRegion = "";
    const region = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.region;
    // console.log(region);
    if (region !== "") xenoRegion = (0, $ba30e20475feac5a$export$bc1f3e050d980d22).filter((reg)=>reg.region === region)[0].xenoRegion;
    // console.log(xenoRegion);
    return xenoRegion;
};
const $0f1d4402dffacf5b$export$284c42d23d05773e = async function(birdId) {
    try {
        let data;
        // return if api timeout has not finished
        if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.xenoApiDisabled === true || $0f1d4402dffacf5b$export$ca000e230c0caa3e.xenoLoading === true) return;
        let country, region, countryParam;
        let countryTag = "";
        let regionTag = "";
        const page = $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeMenu;
        country = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.country;
        countryParam = country;
        region = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.region;
        if (page === "favourites") {
            country = "Worldwide";
            region = "Worldwide";
        }
        let searchQuery = country ? country : region;
        if (region === "Worldwide") searchQuery = "Worldwide";
        if (country === "Various") searchQuery = region;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.loadedCountry = country;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.loadedRegion = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.region;
        // return if recordings already loaded
        const birdIndex = $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.findIndex((el)=>el.id === birdId);
        const bird = $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds[birdIndex];
        if (!bird.recordings.loadedAreas) bird.recordings.loadedAreas = [];
        if (bird.recordings.loadedAreas.includes(searchQuery)) {
            $0f1d4402dffacf5b$export$e9f0a571a9559e03();
            return;
        }
        bird.recordings.loadedAreas.push(searchQuery);
        // console.log(bird.recordings.loadedAreas);
        // if (bird.recordings.loaded && bird.recordings.loadedArea === searchQuery)
        //   return;
        // Set API query params
        if (country === "Various" || country === "Worldwide") countryParam = "";
        // console.log(region);
        if (region !== "") region = $0f1d4402dffacf5b$var$getXenoRegion();
        // bird.recordings = {
        //   loaded: false,
        //   loadedArea: "",
        //   call: [],
        //   song: [],
        //   alarm: [],
        // };
        bird.recordings.loadedCountry = "";
        bird.recordings.loadedRegion = "";
        if (country !== "" && country !== "Worldwide" && country !== "Various") {
            bird.recordings.loadedCountry = country;
            countryTag = `+cnt:"${countryParam}"`;
        // console.log(countryTag);
        }
        if (region !== "") {
            bird.recordings.loadedCountry = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.region;
            regionTag = `+area:${region}`;
        // console.log(regionTag);
        }
        ///////////////////////////////////////////////////////////////////////
        // Call API. If responses return no results, reduce criteria and retry
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.xenoLoading = true;
        let totalResults = 0;
        // Attempt 1
        data = await $0f1d4402dffacf5b$var$callXenoAPI(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?query=en:${birdId}+q:A${countryTag}${regionTag}+len:10-60&key=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}`);
        $0f1d4402dffacf5b$var$processXenoData(data);
        totalResults = $0f1d4402dffacf5b$var$getTotalRecordings();
        // Attempt 2
        if (totalResults < 4) {
            data = await $0f1d4402dffacf5b$var$callXenoAPI(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?query=en:${birdId}+q:A${regionTag}+len:10-60&key=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}`);
            // console.log(data);
            $0f1d4402dffacf5b$var$processXenoData(data);
        }
        // Attempt 3
        totalResults = $0f1d4402dffacf5b$var$getTotalRecordings();
        if (totalResults < 4) {
            data = await $0f1d4402dffacf5b$var$callXenoAPI(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?query=en:${birdId}+q:A+len:10-60&key=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}`);
            $0f1d4402dffacf5b$var$processXenoData(data);
        }
        // Attempt 4
        totalResults = $0f1d4402dffacf5b$var$getTotalRecordings();
        if (data.numRecordings === "0") {
            data = await $0f1d4402dffacf5b$var$callXenoAPI(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?query=en:${birdId}+len:10-60&key=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}`);
            $0f1d4402dffacf5b$var$processXenoData(data);
        }
        // mark bird object as loaded
        bird.recordings.loaded = true;
        // set loaded audio in state
        $0f1d4402dffacf5b$export$e9f0a571a9559e03();
        // set available types in state
        $0f1d4402dffacf5b$export$1f655c5ff10c374f();
        // update local storage
        $0f1d4402dffacf5b$export$89a31c021be7d491();
        // clear state loading
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.xenoLoading = false;
        return;
    } catch (err) {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.xenoLoading = false;
        throw err;
    }
};
const $0f1d4402dffacf5b$var$processXenoData = function(data) {
    const bird = $0f1d4402dffacf5b$export$615a5fdd1e2537fe($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId)[0];
    // filter data into separate call types
    let calls, songs, alarm;
    calls = $0f1d4402dffacf5b$var$filterAudioResults(data, "call", false);
    songs = $0f1d4402dffacf5b$var$filterAudioResults(data, "song");
    alarm = $0f1d4402dffacf5b$var$filterAudioResults(data, "alarm", true);
    const concat = calls.concat(songs).concat(alarm);
    const numberResults = concat.length;
    // If no results from filtering, reduce filter criteria to include recordings with other species
    if (calls == "" && songs == "" && alarm == "") {
        calls = $0f1d4402dffacf5b$var$filterAudioResults(data, "call", false, false);
        songs = $0f1d4402dffacf5b$var$filterAudioResults(data, "song", false, false);
        alarm = $0f1d4402dffacf5b$var$filterAudioResults(data, "alarm", true, false);
    }
    // Create recording object for each result and add to the state bird object recordings array
    calls.forEach((call)=>{
        const exists = bird.recordings.call.some((rec)=>rec.id === call.id);
        if (!exists) bird.recordings.call.push($0f1d4402dffacf5b$var$createRecordingObject(call));
    });
    songs.forEach((song)=>{
        const exists = bird.recordings.song.some((rec)=>rec.id === song.id);
        if (!exists) bird.recordings.song.push($0f1d4402dffacf5b$var$createRecordingObject(song));
    });
    alarm.forEach((alarm)=>{
        const exists = bird.recordings.alarm.some((rec)=>rec.id === alarm.id);
        if (!exists) bird.recordings.alarm.push($0f1d4402dffacf5b$var$createRecordingObject(alarm));
    });
    return numberResults;
};
// call xeno API
const $0f1d4402dffacf5b$var$callXenoAPI = async function(url) {
    const res = await Promise.all([
        (0, $bd02c871d9c5ba8e$export$d047a7c56db64af4)(url),
        $0f1d4402dffacf5b$var$apiTimeout()
    ]);
    const data = await res[0].json();
    return data;
};
// filter API results - Xeno Canto
const $0f1d4402dffacf5b$var$filterAudioResults = function(data, type, includes = false, filterSpecies = true) {
    let filteredType;
    if (includes) filteredType = data.recordings.filter((el)=>el.type.includes(type));
    if (!includes) filteredType = data.recordings.filter((el)=>el.type === type);
    // filter for mp3. iphone does not support wav
    const filteredFileType = filteredType.filter((el)=>el["file-name"].slice(el["file-name"].lastIndexOf(".") + 1) === "mp3");
    // filter out recordings with multiple species
    let filteredSpecies = filteredFileType;
    if (filterSpecies === true) filteredSpecies = filteredFileType.filter((el)=>!el.also.length);
    return filteredSpecies;
};
// API Timeout function - no more than 1 request per second for Xeno Canto
const $0f1d4402dffacf5b$var$apiTimeout = function() {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.xenoApiDisabled = true;
    return new Promise((resolve)=>{
        setTimeout(function() {
            resolve($0f1d4402dffacf5b$export$ca000e230c0caa3e.xenoApiDisabled = false);
        }, (0, $ba30e20475feac5a$export$f8bd50a7889a570e));
    });
};
const $0f1d4402dffacf5b$export$e9f0a571a9559e03 = function() {
    // console.log(state.search);
    const page = $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeMenu;
    const liked = $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.likedAudio;
    let country = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.loadedCountry;
    if (country === "Various" || country === "Worldwide") country = "";
    let region = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.loadedRegion;
    // console.log(region);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings = {
        call: [],
        song: [],
        alarm: []
    };
    const bird = $0f1d4402dffacf5b$export$615a5fdd1e2537fe($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId)[0];
    const recordings = bird.recordings;
    const calls = recordings.call;
    const songs = recordings.song;
    const alarms = recordings.alarm;
    let loadedCalls = $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.call;
    let loadedSongs = $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.song;
    let loadedAlarms = $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.alarm;
    if (liked === "on") {
        // console.log("liked audio only");
        const filterLikedCalls = calls.filter((rec)=>rec.liked === true);
        const filterLikedSongs = songs.filter((rec)=>rec.liked === true);
        const filterLikedAlarms = alarms.filter((rec)=>rec.liked === true);
        if (filterLikedCalls.length > 0) $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.call = filterLikedCalls;
        if (filterLikedSongs.length > 0) $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.song = filterLikedSongs;
        if (filterLikedAlarms.length > 0) $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.alarm = filterLikedAlarms;
        // console.log(state.loadedRecordings);
        return;
    }
    if (region === "Worldwide" || page === "favourites") {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.call = calls;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.song = songs;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.alarm = alarms;
        // console.log(state.loadedRecordings);
        return;
    }
    if (country !== "") {
        const filterCountryCalls = calls.filter((rec)=>rec.country === country);
        const filterCountrySongs = songs.filter((rec)=>rec.country === country);
        const filterCountryAlarms = alarms.filter((rec)=>rec.country === country);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.call = filterCountryCalls;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.song = filterCountrySongs;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.alarm = filterCountryAlarms;
        region = $0f1d4402dffacf5b$var$getRegion(country);
    }
    loadedCalls = $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.call;
    loadedSongs = $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.song;
    loadedAlarms = $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings.alarm;
    const totalLoaded = loadedCalls.length + loadedSongs.length + loadedAlarms.length;
    if (region !== "" || totalLoaded < 5) {
        // console.log(region);
        const filterRegionCalls = calls.filter((rec)=>rec.area === region);
        const filterRegionSongs = songs.filter((rec)=>rec.area === region);
        const filterRegionAlarms = alarms.filter((rec)=>rec.area === region);
        filterRegionCalls.forEach((call)=>{
            if (loadedCalls.some((rec)=>rec.id === call.id) === true) return;
            else loadedCalls.push(call);
        });
        filterRegionSongs.forEach((song)=>{
            if (loadedSongs.some((rec)=>rec.id === song.id) === true) return;
            else loadedSongs.push(song);
        });
        filterRegionAlarms.forEach((alarm)=>{
            if (loadedAlarms.some((rec)=>rec.id === alarm.id) === true) return;
            else loadedAlarms.push(alarm);
        });
    }
// console.log(state.loadedRecordings);
};
const $0f1d4402dffacf5b$export$42a415fa23cad438 = function(birdId) {
    const bird = $0f1d4402dffacf5b$export$615a5fdd1e2537fe(birdId);
    // const recordings = bird[0].recordings;
    const recordings = $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings;
    if (bird) {
        if (recordings.call.length > 0) return recordings.call[0];
        if (recordings.song.length > 0) return recordings.song[0];
        if (recordings.alarm.length > 0) return recordings.alarm[0];
    }
    return;
};
const $0f1d4402dffacf5b$export$799125d37819de4a = function() {
    if (!$0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId) return;
    const type = $0f1d4402dffacf5b$export$ca000e230c0caa3e.availableAudioTypes[$0f1d4402dffacf5b$export$ca000e230c0caa3e.selectAudioTypeIndex];
    const track = $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectAudioTrackIndex;
    const recordingId = $0f1d4402dffacf5b$export$ca000e230c0caa3e.loadedRecordings[type][track].id;
    const bird = $0f1d4402dffacf5b$export$615a5fdd1e2537fe($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId);
    const recording = bird[0].recordings[type].filter((rec)=>rec.id === recordingId)[0];
    if (recording) return recording;
    return;
};
const $0f1d4402dffacf5b$export$8824299e6979daba = function() {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeAudioTrackIndex = $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectAudioTrackIndex;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeAudioTypeIndex = $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectAudioTypeIndex;
};
const $0f1d4402dffacf5b$export$6fc24917af7d4aaa = function(id) {
    const bird = $0f1d4402dffacf5b$export$615a5fdd1e2537fe(id)[0];
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.favourites.includes(id)) {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.favourites.splice($0f1d4402dffacf5b$export$ca000e230c0caa3e.favourites.indexOf(id), 1);
        bird.favourite = false;
    } else {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.favourites.push(id);
        bird.favourite = true;
    }
    $0f1d4402dffacf5b$export$89a31c021be7d491();
    $0f1d4402dffacf5b$export$ca87f76fb6722578();
};
const $0f1d4402dffacf5b$export$c64e21c9e37cd760 = function() {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.favourites.forEach((fav)=>{
        const bird = $0f1d4402dffacf5b$export$615a5fdd1e2537fe(fav)[0];
        if (bird) bird.favourite = true;
    });
};
const $0f1d4402dffacf5b$export$96b06180618099a6 = function() {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.favourites = [];
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.forEach((bird)=>{
        if (bird.favourite) $0f1d4402dffacf5b$export$ca000e230c0caa3e.favourites.push(bird);
    });
};
const $0f1d4402dffacf5b$export$89a31c021be7d491 = function() {
    localStorage.setItem("birds", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.birds));
};
const $0f1d4402dffacf5b$export$ca87f76fb6722578 = function() {
    localStorage.setItem("favourites", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.favourites));
};
const $0f1d4402dffacf5b$export$3576fd8b5ce57a75 = function() {
    localStorage.setItem("likedTracks", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.likedTracks));
};
const $0f1d4402dffacf5b$export$912d92468a82a1ac = function() {
    localStorage.setItem("settings", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.settings));
};
const $0f1d4402dffacf5b$export$45ee5abe08a27174 = function() {
    localStorage.setItem("version", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.version));
};
const $0f1d4402dffacf5b$export$373af51b3e7e3bb8 = function(colour, contrast, brightness) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.themeRangeColour = colour;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.themeRangeContrast = contrast;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.themeRangeBrightness = brightness;
    $0f1d4402dffacf5b$export$912d92468a82a1ac();
};
const $0f1d4402dffacf5b$export$5ed1960bc888cd48 = function() {
    const value = $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.likedAudio;
    // console.log(value);
    if (value === "off") $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.likedAudio = "on";
    if (value === "on" || !value) $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.likedAudio = "off";
    $0f1d4402dffacf5b$export$912d92468a82a1ac();
// console.log(state.settings.likedAudio);
};
const $0f1d4402dffacf5b$export$aa3f99f4819f774f = function() {
    const value = $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDarkMode;
    // console.log(value);
    if (value === "off") $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDarkMode = "on";
    if (value === "on") $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDarkMode = "off";
    $0f1d4402dffacf5b$export$912d92468a82a1ac();
};
const $0f1d4402dffacf5b$export$7ab3a2e0ec2a6b17 = function() {
    const value = $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDisableImages;
    if (value === "off") $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDisableImages = "on";
    if (value === "on") $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDisableImages = "off";
    $0f1d4402dffacf5b$export$912d92468a82a1ac();
};
// settings - update state accessible colours
// export const toggleSettingAccessibilityColours = function () {
//   const value = state.settings.settingAccessibilityColours;
//   if (value === "off") state.settings.settingAccessibilityColours = "on";
//   if (value === "on") state.settings.settingAccessibilityColours = "off";
//   persistSettings();
// };
////////////////////////////////////////////////////////////////////////
// Clear storage
////////////////////////////////////////////////////////////////////////
// const clearStorage = function () {
//   localStorage.removeItem("birds");
//   localStorage.removeItem("version");
// };
// clearStorage();
////////////////////////////////////////////////////////////////////////
// INIT
////////////////////////////////////////////////////////////////////////
// update settings from storage (allows for updates to state form previous versions)
//
const $0f1d4402dffacf5b$var$storageSettings = function(storage) {
    const storedSettings = JSON.parse(storage);
    const storageKeys = Object.keys(storedSettings);
    const stateKeys = Object.keys($0f1d4402dffacf5b$export$ca000e230c0caa3e.settings);
    storageKeys.forEach((key)=>{
        if (stateKeys.includes(key)) $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings[key] = storedSettings[key];
    });
};
// Update the state from local storage
const $0f1d4402dffacf5b$var$init = function() {
    const favourites = localStorage.getItem("favourites");
    const likedTracks = localStorage.getItem("likedTracks");
    const settings = localStorage.getItem("settings");
    const version = localStorage.getItem("version");
    if (settings) $0f1d4402dffacf5b$var$storageSettings(settings);
    if (favourites) $0f1d4402dffacf5b$export$ca000e230c0caa3e.favourites = JSON.parse(favourites);
    if (likedTracks) $0f1d4402dffacf5b$export$ca000e230c0caa3e.likedTracks = JSON.parse(likedTracks);
    if (version) $0f1d4402dffacf5b$export$ca000e230c0caa3e.version = JSON.parse(version);
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.version === (0, $ba30e20475feac5a$export$a4ad2735b021c132)) {
        const storageBirds = localStorage.getItem("birds");
        if (storageBirds) $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds = JSON.parse(storageBirds);
    }
    // update version
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.version !== (0, $ba30e20475feac5a$export$a4ad2735b021c132)) {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.version = (0, $ba30e20475feac5a$export$a4ad2735b021c132);
        $0f1d4402dffacf5b$export$45ee5abe08a27174();
    }
};
$0f1d4402dffacf5b$var$init();


class $3a07c34e115c11c9$export$2e2bcd8739ae039 {
    render(data) {
        if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
        this.data = data;
        const markup = this._generateMarkup(this.data);
        this.clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    hide() {
        this._parentElement.classList.add("hidden");
    }
    show() {
        this._parentElement.classList.remove("hidden");
    }
    clear() {
        this._parentElement.innerHTML = "";
    }
    getWindowOrientation() {
        if (window.innerHeight >= window.innerWidth) return "portrait-primary";
        else return "landscape-primary";
    // return window.screen.orientation.type;
    }
    update(data) {
        this.data = data;
        const newMarkup = this._generateMarkup(data);
        const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const curElements = Array.from(this._parentElement.querySelectorAll("*"));
        newElements.forEach((newEl, i)=>{
            const curEl = curElements[i];
            // console.log(curEl, newEl.isEqualNode(curEl));
            // console.log(newEl);
            // Updates changed TEXT
            if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim() !== "") // console.log("🛑", newEl.firstChild.nodeValue.trim());
            curEl.textContent = newEl.textContent;
            // Update changed ATTRIBUTES
            if (!newEl.isEqualNode(curEl)) // console.log(Array.from(newEl.attributes));
            Array.from(newEl.attributes).forEach((attr)=>curEl.setAttribute(attr.name, attr.value));
        });
    }
    renderError(message = this._errorMessage) {
        const markup = `
    <div class="error__container">
    <p class="error__message">${message}</p>
    </div>`;
        this.clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderMessage(message = this._message) {
        const markup = `<p>${message}</p>`;
        this.clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
}


class $43d65efb1d7b78a3$var$menuView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".nav");
    _container = document.querySelector(".birds__container");
    btnMenu = document.querySelector(".nav__btn");
    menu = document.querySelector(".nav__menu");
    list = document.querySelector(".nav__list");
    title = document.querySelector(".section__title");
    orientationSettings() {
        const orientation = this.getWindowOrientation();
        if (orientation === "landscape-primary") this.title.classList.add("hidden");
        if (orientation !== "landscape-primary") this.title.classList.remove("hidden");
    }
    // Handler for hash-change and page load for nav items
    addHandlerNavigation(handler) {
        [
            "hashchange",
            "load"
        ].forEach((ev)=>window.addEventListener(ev, handler));
    }
    // animate nav item
    animateNavItem(navItem) {
        const item = document.getElementById(navItem);
        if (!item) return;
        item.style.animation = "menuSelect 0.25s 1";
        setTimeout(()=>{
            item.style.animation = "";
        }, 250);
    }
    clearStyleAnimation() {
        this._parentElement.style.animation = "none";
    }
    addHandlerMenuButton(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".nav__btn__container");
            if (!btn) return;
            handler();
        });
    }
    navClose() {
        this.btnMenu.classList.remove("nav__btn__up");
        this.btnMenu.classList.add("nav__btn__down");
        this.menu.style.height = 0;
    }
    navOpen() {
        this.btnMenu.classList.add("nav__btn__up");
        this.btnMenu.classList.remove("nav__btn__down");
        this.menu.style.height = `${this.list.offsetHeight}px`;
    }
    renderRotationBtn(state) {
        if (state === "open") this.navClose();
        if (state === "closed") this.navOpen();
    }
    renderRotation(state) {
        if (state === "open") {
            const orientation = this.getWindowOrientation();
            if (orientation !== "landscape-primary") this.navClose();
        }
        if (state === "closed") this.navOpen();
    }
}
var $43d65efb1d7b78a3$export$2e2bcd8739ae039 = new $43d65efb1d7b78a3$var$menuView();



var $7456ca4dd9006edb$exports = {};
$7456ca4dd9006edb$exports = new URL("icons.e8b86b23.svg", import.meta.url).toString();


var $d2e85b2e54204fca$exports = {};
$d2e85b2e54204fca$exports = new URL("no_image.62092dc0.png", import.meta.url).toString();


class $3cc7bc34fb92989e$var$birdsView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".birds__list");
    _errorMessage = "No birds found \u2639";
    _message = "";
    _container = document.querySelector(".birds__container");
    _title = document.querySelector(".section__title-description");
    _favouritesInstruction = document.querySelector(".worm__instruction");
    _footer = document.querySelector(".footer");
    // _country = document.getElementById('country')
    setTitle(title) {
        this._title.textContent = title;
    }
    setSearch() {
        window.location.hash = "search";
        this.setTitle("Search Results");
    }
    // setContainerBottomMargin(val) {
    //   this._container.style.marginBottom = `${val}px`;
    // }
    setFooterMargin(val) {
        const orient = this.getWindowOrientation();
        if (orient === "portrait-primary") this._footer.style.marginBottom = `${val}px`;
        if (orient === "landscape-primary") this._footer.style.marginBottom = 0;
    }
    scrollUp() {
        this._container.scrollTop = 0;
    }
    animateHeight = function() {
        const birds = document.querySelectorAll(".bird");
        if (!birds) return;
        birds.forEach((bird)=>{
            // return;
            if (window.innerHeight >= window.innerWidth) bird.style.maxHeight = "15rem";
            if (window.innerHeight < window.innerWidth) bird.style.maxHeight = "20rem";
        });
    };
    setActiveBgColour(id) {
        if (id) {
            const bird = document.getElementById(id);
            if (bird) bird.style.backgroundColor = "var(--colour-bird)";
        }
    }
    resetBgColour(id) {
        const element = document.getElementById(id);
        if (element) element.style.backgroundColor = "var(--colour-background2)";
    }
    _addHandlerClickAnimation(bird) {
        [
            "touchstart",
            "touchend",
            "mousedown",
            "mouseup"
        ].forEach((ev)=>{
            bird.addEventListener(ev, (e)=>{
                const birdImage = e.target.closest(".bird__image__container");
                if (birdImage) return;
                const worm = e.target.closest(".worm");
                if (worm) return;
                this._toggleBirdDepress(bird.id);
            }, {
                passive: true
            });
        });
    }
    _toggleBirdDepress(birdId) {
        document.getElementById(birdId).classList.toggle("border__none");
    }
    showSoundwave(birdId) {
        // document.getElementById(`soundwave-${birdId}`).classList.remove("hidden");
        // document.getElementById(`soundwave-${birdId}`).style.height = "64px";
        document.getElementById(`recordings-${birdId}`).classList.add("hidden");
    }
    hideSoundwave(birdId) {
        document.getElementById(`soundwave-${birdId}`).classList.add("hidden");
        document.getElementById(`soundwave-${birdId}`).style.height = "0";
        document.getElementById(`recordings-${birdId}`).classList.remove("hidden");
    }
    hideAllSoundwaves() {
        document.querySelectorAll(".soundwave_container").forEach((wave)=>{
            wave.classList.add("hidden");
            wave.style.height = "0";
        });
        document.querySelectorAll(".bird__recordings").forEach((el)=>{
            el.classList.remove("hidden");
        });
    }
    toggleWorm(birdId, favourites) {
        // console.log(birdId);
        // check if already saved to favourites
        const isFavourite = favourites.some((el)=>el === birdId);
        const worm = document.getElementById(`worm-${birdId}`);
        worm.querySelector(".worm__svg").setAttribute("href", `${(0, (/*@__PURE__*/$parcel$interopDefault($7456ca4dd9006edb$exports)))}#icon-worm-${isFavourite ? "white" : "colour"}`);
    }
    addHandlerBird(handler) {
        const birds = document.querySelectorAll(".bird");
        if (!birds) return;
        // choose outcome
        birds.forEach(function(bird) {
            bird.addEventListener("click", function(e) {
                // add favourite
                const worm = e.target.closest(".worm");
                if (worm) {
                    handler(bird.id, "favourite");
                    return;
                }
                // image info
                const image = e.target.closest(".bird__image__container");
                if (image) {
                    handler(bird.id, "image");
                    return;
                }
                // if none of the others, add audio
                handler(bird.id, "audio");
            });
        });
        // click animation
        birds.forEach(this._addHandlerClickAnimation.bind(this));
    }
    hideBird(id) {
        const bird = document.getElementById(id);
        bird.style.maxHeight = 0;
        bird.style.border = 0;
        bird.style.marginBottom = 0;
        bird.style.padding = 0;
    }
    hideFavouritesInstruction() {
        this._favouritesInstruction.classList.add("hidden");
    }
    showFavouritesInstruction() {
        this._favouritesInstruction.classList.remove("hidden");
    }
    _generateMarkup() {
        let count = 0;
        return this.data.map((el)=>{
            count++;
            return this._generateMarkupBird(el, count);
        }).join("");
    }
    _generateSpinner() {
        this.clear();
        const markup = `<div class="spinner spinner__section">
                      <svg class="spinner_svg">
                        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($7456ca4dd9006edb$exports)))}#icon-spinner"></use>
                      </svg>
                    </div>`;
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    _generateMarkupBird(data, count) {
        // console.log(data);
        // console.log(data);
        return `<li class="bird" id="${data.id}">
            <div class="bird__image__container" id="bird-image-container-${data.id}">
              <div class="spinner">
                <svg class="spinner_svg">
                 <use href="${0, (/*@__PURE__*/$parcel$interopDefault($7456ca4dd9006edb$exports))}#icon-spinner"></use>
                </svg>
              </div>
              
              <img
                class="bird__image hidden"
                data-src="${data.image.thumb ? data.image.thumb : (0, (/*@__PURE__*/$parcel$interopDefault($d2e85b2e54204fca$exports)))}" 
                alt="bird image"
                id="${count}"
              />
              <svg class="info__icon">
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($7456ca4dd9006edb$exports))}#icon-info"></use>
              </svg>
            </div>

            <div class="bird__info__container">
              <div class="bird__title_container">
                <div class="bird__info__title">
                <h2>${data.name}</h2>
                <p class="scientific__name">${data.scientific}</p>
              </div>
                <div class="worm__container">
                  <svg class="worm" id="worm-${data.id}">
                    <use
                      class="worm__svg"
                      href="${0, (/*@__PURE__*/$parcel$interopDefault($7456ca4dd9006edb$exports))}#icon-worm-${data.favourite ? "colour" : "white"}"
                    ></use>
                  </svg>
                </div>
              </div>

              <div class="bird__details__container">
               <p><b>Region:</b> ${data.location.commonRegionCodes.join(", ")}</p>
              </div>

              <div class="bird__recordings__container">  
                <div class="bird__recordings" id="recordings-${data.id}">
                  <p class="audio__text">CLICK TO PLAY</p>
                  <div class="audio__image__container">
                    <svg class="audio__image" id="audio-${data.id}">
                      <use
                        class="audio__image__svg"
                        href="${0, (/*@__PURE__*/$parcel$interopDefault($7456ca4dd9006edb$exports))}#icon-audio-play2"
                      ></use>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </li>
    `;
    }
}
var $3cc7bc34fb92989e$export$2e2bcd8739ae039 = new $3cc7bc34fb92989e$var$birdsView();



class $e3a3f6f0893f424b$var$searchResultsView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".search-results__list");
    _search = document.querySelector(".search");
    _searchField = document.querySelector(".search__field");
    _searchResults = document.querySelector(".search-results");
    _overlay = document.querySelector(".overlay");
    hideSearch() {
        this._overlay.classList.add("hidden");
        this._searchResults.classList.add("hidden");
    }
    _showSearch() {
        this._overlay.classList.remove("hidden");
        this._searchResults.classList.remove("hidden");
    }
    clearSearch() {
        this._searchField.value = "";
    }
    addHandlerOverlay(handler) {
        this._overlay.addEventListener("click", function(e) {
            handler();
        });
    }
    addHandlerSearchResults(handler) {
        this._searchField.addEventListener("keyup", function(e) {
            handler();
        });
    }
    addHandlerSearchItem(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const item = e.target.closest(".search-results__item");
            // console.log(item);
            if (!item) return;
            handler(item.dataset.id);
        });
    }
    _generateMarkup(data) {
        const input = this._searchField.value.toLowerCase().replaceAll(" ", "_");
        // if not input then hide the seatchlist
        if (!input) {
            this.hideSearch();
            return;
        }
        // unhide the results list and the overlay
        this._showSearch();
        //
        const results = data.filter((el)=>el.id.includes(input));
        if (!results) {
            this.hideSearch();
            return;
        }
        if (results) {
            const markup = results.map((el)=>this._generateMarkupResult(el)).join("");
            return markup;
        }
    }
    _generateMarkupResult(data) {
        return `<li class="search-results__item" data-id="${data.id}">${data.name}</li>`;
    }
}
var $e3a3f6f0893f424b$export$2e2bcd8739ae039 = new $e3a3f6f0893f424b$var$searchResultsView();



class $813cf99795e9ec97$var$searchView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".search");
    _errorMessage = "No birds found";
    _flag = document.getElementById("flag");
    setFilterEmojiFlag(countryCode = "") {
        if (!countryCode) {
            this._flag.textContent = "";
            return;
        }
        const codePoints = countryCode.toUpperCase().split("").map((char)=>127397 + char.charCodeAt());
        // console.log(codePoints);
        // console.log(...codePoints);
        this._flag.textContent = String.fromCodePoint(...codePoints);
    }
    setFilterEmojiGlobe(regionCode = "") {
        let codePoint;
        if (regionCode === "NA" || regionCode === "MA" || regionCode === "SA") codePoint = "0x1F30E";
        if (regionCode === "PAL" || regionCode === "AF" || regionCode === "ALL") codePoint = "0x1F30D";
        if (regionCode === "OR" || regionCode === "AU") codePoint = "0x1F30F";
        if (regionCode === "AN") codePoint = "0x1F9CA";
        this._flag.textContent = String.fromCodePoint(codePoint);
    }
    getQuery() {
        const query = this._parentElement.querySelector(".search__field").value;
        this.clearSearch();
        return query;
    }
    addHandlerSearch(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            // console.log("submit");
            e.preventDefault();
            handler();
        });
    }
    clearSearch() {
        this._parentElement.querySelector(".search__field").value = "";
    }
}
var $813cf99795e9ec97$export$2e2bcd8739ae039 = new $813cf99795e9ec97$var$searchView();





class $608a634cd55c40cc$var$birdImageView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelectorAll(".bird__image__container");
    _errorMessage = "No image found";
    _message = "";
    // Lazy loader
    addHandlerImageLoad(handler) {
        const container = document.querySelector(".birds__list");
        const images = document.querySelectorAll(".bird__image");
        let minId = null;
        let maxId = null;
        let debounceTimeout = null;
        // changes to be applied
        const applyChanges = function() {
            const items = document.querySelectorAll(".bird__image");
            // perform action on elements with Id between min and max
            items.forEach((el)=>{
                const id = parseInt(el.id);
                if (el.src) return;
                if (id >= minId && id <= maxId) {
                    const imageId = el.parentElement.id;
                    const birdId = el.parentElement.parentElement.id;
                    handler(birdId, imageId);
                }
            });
            //
            minId = null;
            maxId = null;
        };
        // Check id's of images passing through intersection
        const reportIntersection = function(entries, observer) {
            clearTimeout(debounceTimeout);
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const entryId = parseInt(entry.target.id);
                    if (minId === null || maxId === null) {
                        minId = entryId;
                        maxId = entryId;
                    } else {
                        minId = Math.min(minId, entryId);
                        maxId = Math.max(maxId, entryId);
                    }
                }
            });
            debounceTimeout = setTimeout(applyChanges, 500);
        };
        const imgObserver = new IntersectionObserver(reportIntersection, container);
        images.forEach((img)=>imgObserver.observe(img));
    }
    renderImage = function(data, id, disabled) {
        // console.log(data, id);
        // document.getElementById(id).innerHTML = this._generateMarkup(data);
        // console.log(data);
        // console.log(disabled);
        // const thumb = data[0].image.thumb;
        // console.log(thumb);
        // let source;
        // if (disabled === "on") {
        //   source = placeholder;
        // } else if (thumb) {
        //   source = thumb;
        // } else {
        //   source = placeholder;
        // }
        // console.log(data[0].image);
        // console.log(data[0].image.thumb);
        const source = data[0].image.thumb !== "" && disabled === "off" ? data[0].image.thumb : (0, (/*@__PURE__*/$parcel$interopDefault($d2e85b2e54204fca$exports)));
        // console.log(source);
        const image = document.getElementById(id).querySelector(".bird__image");
        const spinner = document.getElementById(id).querySelector(".spinner");
        image.src = source;
        image.addEventListener("load", ()=>{
            spinner.classList.add("hidden");
            image.classList.remove("hidden");
        });
    };
}
var $608a634cd55c40cc$export$2e2bcd8739ae039 = new $608a634cd55c40cc$var$birdImageView();



class $eb9a509ced8bdde6$var$audioView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".audio__container");
    _audioSelectors = document.querySelector(".audio__selector__container");
    overlay = document.querySelector(".audio__container__overlay");
    soundwave = document.getElementById("soundwave");
    wave = document.querySelectorAll(".wave");
    selectBtn = document.querySelector(".btn__change__track");
    infoBtn = document.querySelector(".info__icon__audio");
    likeBtn = document.querySelector(".heart__icon");
    likeBtnSvg = document.querySelector(".heart__icon__fill");
    addHandlerSelectBtn(handler) {
        this.selectBtn.addEventListener("click", handler);
    }
    addHandlerinfoBtn(handler) {
        this.infoBtn.addEventListener("click", handler);
    }
    addHandlerLikeBtn(handler) {
        this.likeBtn.addEventListener("click", handler);
    }
    likeBtnColour(colour) {
        this.likeBtnSvg.style.fill = colour;
    }
    hideOverlay() {
        this.overlay.classList.add("hidden");
    }
    showOverlay() {
        this.overlay.classList.remove("hidden");
        const parentHeight = this.getContainerHeight();
        console.log(`${parentHeight}px`);
        this.overlay.style.height = `${parentHeight}px`;
    }
    getAudioContainerHeight() {
        return this._parentElement.offsetHeight;
    }
    hideControls() {
        this._parentElement.querySelector(".audio__selector__container").classList.remove("hidden");
        document.querySelector(".loading__colour__container").classList.remove("hidden");
        this._parentElement.querySelector(".audio__playback__container").classList.add("hidden");
        this._parentElement.querySelector(".audio__selectors").classList.add("hidden");
    }
    showControls() {
        this._parentElement.querySelector(".audio__selector__container").classList.remove("hidden");
        document.querySelector(".loading__colour__container").classList.add("hidden");
        this._parentElement.querySelector(".audio__playback__container").classList.remove("hidden");
        this._parentElement.querySelector(".audio__selectors").classList.remove("hidden");
        this.hideSelectButton();
        this.showSoundwave();
    }
    hideSelectorContainer() {
        this._audioSelectors.classList.add("hidden");
    }
    showSelectorContainer() {
        this._audioSelectors.classList.remove("hidden");
    }
    hideSoundwave() {
        document.getElementById("soundwave").classList.add("hidden");
        document.getElementById("soundwave").style.height = "0";
    }
    showSoundwave() {
        document.getElementById("soundwave").classList.remove("hidden");
        document.getElementById("soundwave").style.height = "36px";
    }
    pauseSoundwave() {
        this.wave.forEach((wave)=>wave.classList.add("stop_animation"));
    }
    playSoundwave() {
        this.wave.forEach((wave)=>wave.classList.remove("stop_animation"));
    }
    showSelectButton() {
        document.querySelector(".btn__change__track").classList.remove("hidden");
    }
    hideSelectButton() {
        document.querySelector(".btn__change__track").classList.add("hidden");
    }
}
var $eb9a509ced8bdde6$export$2e2bcd8739ae039 = new $eb9a509ced8bdde6$var$audioView();




class $918422351536181a$var$birdInfoView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".bird__information__container");
    image = document.querySelector(".bird__information__image");
    spinner = document.querySelector(".spinner__overlay");
    overlayBlur = document.querySelector(".overlay-blur");
    constructor(){
        super();
        this._addHandlerCloseWindow();
    }
    showBirdInfo() {
        this._parentElement.classList.remove("hidden");
        this.overlayBlur.classList.remove("hidden");
    }
    hideBirdInfo() {
        this._parentElement.classList.add("hidden");
        this.overlayBlur.classList.add("hidden");
    }
    _addHandlerCloseWindow() {
        this._parentElement.querySelector(".close-info__btn").addEventListener("click", this.hideBirdInfo.bind(this));
    }
    setImageSource(src, disabled) {
        this.spinner.classList.remove("hidden");
        this.image.classList.add("hidden");
        if (disabled === "on") {
            this.image.src = (0, (/*@__PURE__*/$parcel$interopDefault($d2e85b2e54204fca$exports)));
            return;
        }
        this.image.src = src;
        this.renderImage();
    }
    renderImage = function() {
        this.image.addEventListener("load", ()=>{
            document.querySelector(".bird__information__image").classList.remove("hidden");
            document.querySelector(".spinner__overlay").classList.add("hidden");
        });
    };
}
var $918422351536181a$export$2e2bcd8739ae039 = new $918422351536181a$var$birdInfoView();




class $9c6cd7cf954bccba$var$audioTrackView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".audio__selector__track-track");
    _errorMessage = "";
    btnNext = document.querySelector(".btn__track-right");
    btnPrev = document.querySelector(".btn__track-left");
    addHandlerNextTrack(handler) {
        this.btnNext.addEventListener("click", this.nextTrack.bind(this, handler));
    }
    addHandlerPrevTrack(handler) {
        this.btnPrev.addEventListener("click", this.prevTrack.bind(this, handler));
    }
    nextTrack(handler) {
        const curTrack = Number(document.querySelector(".audio__track").textContent);
        const available = Number(document.querySelector(".audio__available__tracks").textContent);
        if (curTrack < available) handler(`${curTrack}`);
    }
    prevTrack(handler) {
        const curTrack = Number(document.querySelector(".audio__track").textContent);
        if (curTrack > 1) handler(`${curTrack - 2}`);
    }
    _generateMarkup() {
        return `<p class="audio__track">${Number(this.data.selectAudioTrackIndex) + 1}</p>
    <p>/</p>
    <p class="audio__available__tracks">${this.data.availableAudioTracks}</p>`;
    }
}
var $9c6cd7cf954bccba$export$2e2bcd8739ae039 = new $9c6cd7cf954bccba$var$audioTrackView();




class $0c79bc6496e30432$var$audioTypeView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".audio__selector__type-type");
    _errorMessage = "";
    btnNext = document.querySelector(".btn__type-right");
    btnPrev = document.querySelector(".btn__type-left");
    curSlide = 0;
    portrait = window.matchMedia("(orientation: portrait)");
    addHandlerOrientation(handler) {
        this.portrait.addEventListener("change", handler);
    }
    setCurrentSlide(slide) {
        this.curSlide = slide;
    }
    addHandlerNextType(handler) {
        this.btnNext.addEventListener("click", this.nextSlide.bind(this, handler));
    }
    addHandlerPrevType(handler) {
        this.btnPrev.addEventListener("click", this.prevSlide.bind(this, handler));
    }
    goToSlide(slide) {
        const slides = document.querySelectorAll(".audio__type");
        slides.forEach((s)=>s.style.transform = `translateX(${-100 * slide}%)`);
    }
    // Next slide
    nextSlide(handler) {
        const slide = this.curSlide;
        const slides = document.querySelectorAll(".audio__type");
        const maxSlide = slides.length;
        if (this.curSlide !== maxSlide - 1) {
            this.setCurrentSlide(slide + 1);
            this.goToSlide(this.curSlide);
            handler(this.curSlide);
        }
    }
    prevSlide(handler) {
        const slide = this.curSlide;
        if (this.curSlide !== 0) {
            this.setCurrentSlide(slide - 1);
            this.goToSlide(this.curSlide);
            handler(this.curSlide);
        }
    }
    setContainerWidth(data) {
        if (!data) return;
        const parentWidth = this._parentElement.parentElement.offsetWidth;
        const calcWidth = parentWidth * data.length;
        this._parentElement.style.width = `${calcWidth}px`;
        this._parentElement.style.justifyContent = "flex-start";
    }
    _generateMarkup() {
        this.setContainerWidth(this.data);
        return this.data.map((type)=>{
            return `<p class="audio__type">${type}</p>`;
        }).join("");
    }
}
var $0c79bc6496e30432$export$2e2bcd8739ae039 = new $0c79bc6496e30432$var$audioTypeView();



class $530ac4ef5a98d8b4$var$audioControlsView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".audio__playback__container");
    _errorMessage = "Sorry! No recordings available";
    pauseAudio() {
        const player = document.querySelector(".audio__controls");
        if (player) player.pause();
    }
    addHandlerAudioEnded(handler) {
        const player = document.querySelector(".audio__controls");
        [
            "ended",
            "pause"
        ].forEach((event)=>{
            player.addEventListener(event, function() {
                handler();
            });
        });
    }
    addHandlerAudioPlay(handler) {
        const player = document.querySelector(".audio__controls");
        player.addEventListener("play", function() {
            handler();
        });
    }
    _generateMarkup(data) {
        return `
            <audio class="audio__controls" controls autoplay>
                <source
                src="${data.file}"
                type="audio/wav"
                />
            </audio>
      `;
    }
}
var $530ac4ef5a98d8b4$export$2e2bcd8739ae039 = new $530ac4ef5a98d8b4$var$audioControlsView();



var $202bc06cda2df20a$exports = {};
$202bc06cda2df20a$exports = new URL("logo.b6f3f9c4.png", import.meta.url).toString();


var $4843a30ae00e1176$exports = {};
$4843a30ae00e1176$exports = new URL("logo-off-white.cdd8f6b5.png", import.meta.url).toString();


class $4c22adf96f0377b2$var$Settings extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".settings__container");
    title = document.querySelector(".themes__title__colour");
    sliderColour = document.getElementById("themeColour");
    sliderContrast = document.getElementById("themeContrast");
    sliderBrightness = document.getElementById("themeBrightness");
    themeBtns = document.querySelectorAll(".btn__season");
    //
    //
    switchLikedAudio = document.getElementById("setting_liked_audio");
    switchDisableImages = document.getElementById("setting_disable_images");
    switchDarkMode = document.getElementById("setting_dark-mode");
    logo = document.querySelector(".logo");
    addHandlerSliderColour(handler) {
        this.sliderColour.addEventListener("input", handler);
    }
    addHandlerSliderContrast(handler) {
        this.sliderContrast.addEventListener("input", handler);
    }
    addHandlerSliderBrightness(handler) {
        this.sliderBrightness.addEventListener("input", handler);
    }
    addHandlerSettingLikedAudio(handler) {
        this.switchLikedAudio.addEventListener("input", handler);
    }
    addHandlerSettingDarkMode(handler) {
        this.switchDarkMode.addEventListener("input", handler);
    }
    addHandlerSettingDisableImages(handler) {
        this.switchDisableImages.addEventListener("input", handler);
    }
    addHandlerSettingAccessibilityColours(handler) {
        this.switchAccessibilityColours.addEventListener("input", handler);
    }
    addHandlerThemeBtns(handler) {
        this.themeBtns.forEach((btn)=>btn.addEventListener("click", function(e) {
                const target = e.target.closest(".btn__season");
                const theme = target.dataset.season;
                handler(theme);
            }));
    }
    setThemeBtnBackgrounds(theme) {
        this.themeBtns.forEach((btn)=>{
            const svg = btn.querySelector(".svg__container__themes");
            if (btn.dataset.season === theme) svg.style.fill = "var(--colour-highlight)";
            else svg.style.fill = "";
        });
    }
    // setAccessibilityColours(val) {
    //   // console.log(`toggle - ${val}`)
    //   if (val === "off") {
    //     this.switchAccessibilityColours.value = "off";
    //     this.sliderColour.disabled = false;
    //     this.sliderContrast.disabled = false;
    //     this.sliderBrightness.disabled = false;
    //     this.setColourValue();
    //   }
    //   if (val === "on") {
    //     this.switchAccessibilityColours.value = "on";
    //     this.sliderColour.disabled = true;
    //     this.sliderContrast.disabled = true;
    //     this.sliderBrightness.disabled = true;
    //     this.setAccessibleColours();
    //   }
    // }
    // setAccessibleColours() {
    //   const highlight = `hsl(0, 0%, 100%)`;
    //   const bird = `hsl(0, 0%, 60%)`;
    //   const background = `hsl(0, 0%, 85%)`;
    //   this._setColourProperties(background, highlight, bird);
    // }
    setDisableImagesValue(val) {
        this.switchDisableImages.value = val;
    }
    getColourValue() {
        return this.sliderColour.value;
    }
    getContrastValue() {
        return this.sliderContrast.value;
    }
    getBrightnessValue() {
        return this.sliderBrightness.value;
    }
    setTheme(theme) {
        this._setColourProperties(theme.background, theme.highlight, theme.bird, theme.title);
    }
    _setColourProperties(background = "", highlight = "", bird = "", title = "") {
        if (background) document.documentElement.style.setProperty("--colour-background", background);
        if (highlight) document.documentElement.style.setProperty("--colour-highlight", highlight);
        if (bird) document.documentElement.style.setProperty("--colour-bird", bird);
        if (title) document.documentElement.style.setProperty("--colour-background-title", title);
    }
    darkMode(state = "") {
        let dark;
        dark = this.switchDarkMode.checked;
        if (state === "off") {
            dark = false;
            this.switchDarkMode.checked = false;
        }
        let background2, fontColor, border, borderColour, bodyColor, disableSliders, svgFill, bgSearchResults, logoSrc;
        if (dark) {
            // background2 = "#131313";
            background2 = "rgb(25, 25, 25)";
            fontColor = "#FFFFFF";
            border = "none";
            borderColour = "#181818";
            bodyColor = "#FFFFFF";
            disableSliders = true;
            svgFill = "white";
            bgSearchResults = "#131313";
            logoSrc = (0, (/*@__PURE__*/$parcel$interopDefault($4843a30ae00e1176$exports)));
        }
        if (!dark) {
            background2 = "#FFFFFF";
            fontColor = "black";
            border = "solid";
            borderColour = "black";
            bodyColor = "black";
            disableSliders = false;
            svgFill = "black";
            bgSearchResults = "whitesmoke";
            logoSrc = (0, (/*@__PURE__*/$parcel$interopDefault($202bc06cda2df20a$exports)));
        }
        this.setColourValue();
        document.body.style.setProperty("color", bodyColor);
        document.documentElement.style.setProperty("--colour-background2", background2);
        document.documentElement.style.setProperty("--colour-background-search-results", bgSearchResults);
        // document.documentElement.style.setProperty("--colour-background-modal", background2);
        document.documentElement.style.setProperty("--font-color", fontColor);
        document.documentElement.style.setProperty("--bird-border-style", border);
        document.documentElement.style.setProperty("--colour-bird-border", borderColour);
        document.querySelectorAll(".svg-icon-amend-fill").forEach((icon)=>{
            // console.log(icon)
            icon.style.fill = svgFill;
        });
        this.logo.src = logoSrc;
        this.sliderContrast.disabled = disableSliders;
        this.sliderBrightness.disabled = disableSliders;
    }
    setColourValue() {
        const colour = this.getColourValue();
        if (this.switchDarkMode.checked) {
            const highlight = `hsl(${colour}, 100%, 35%)`;
            const title = `hsla(${colour}, 100%, 50%, 0.25)`;
            this._setColourProperties("#060606", highlight, highlight, title);
            return;
        }
        const contrast = this.getContrastValue();
        const brightness = this.getBrightnessValue();
        const bird = `hsl(${colour}, 90%, 60%)`;
        const highlight = `hsl(${colour}, 100%, 50%)`;
        const background = `hsl(${colour}, ${contrast}%, ${brightness}%)`;
        const title = `hsla(${colour}, 100%, 50%, 0.25)`;
        this._setColourProperties(background, highlight, bird, title);
    }
    storageSettings(data) {
        // set colours
        // console.log(data)
        const colour = data.themeRangeColour;
        const contrast = data.themeRangeContrast;
        const brightness = data.themeRangeBrightness;
        const highlight = `hsl(${colour}, 100%, 50%)`;
        const bird = `hsl(${colour}, 90%, 60%)`;
        const background = `hsl(${colour}, ${contrast}%, ${brightness}%)`;
        const title = `hsla(${colour}, 100%, 50%, 0.25)`;
        this._setColourProperties(background, highlight, bird, title);
        this.sliderColour.value = colour;
        this.sliderContrast.value = contrast;
        this.sliderBrightness.value = brightness;
        // set disabled images
        const disabledImages = data.settingDisableImages;
        if (disabledImages === "on") this.switchDisableImages.checked = true;
        const likedAudio = data.likedAudio;
        if (likedAudio === "on") this.switchLikedAudio.checked = true;
        // const accessibilityColours = data.settingAccessibilityColours;
        // // console.log(accessibilityColours)
        // if (accessibilityColours === "on") {
        //   this.switchAccessibilityColours.checked = true;
        //   this.setAccessibilityColours(accessibilityColours);
        // }
        const darkMode = data.settingDarkMode;
        if (darkMode === "on") {
            this.switchDarkMode.checked = true;
            this.darkMode();
        }
    }
}
var $4c22adf96f0377b2$export$2e2bcd8739ae039 = new $4c22adf96f0377b2$var$Settings();



class $72e7fd3229d050fe$var$contactView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".contact");
    show() {
        this._parentElement.classList.remove("hidden");
    }
    hide() {
        this._parentElement.classList.add("hidden");
    }
}
var $72e7fd3229d050fe$export$2e2bcd8739ae039 = new $72e7fd3229d050fe$var$contactView();



class $aea9cfe515a968fe$var$homeView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".welcome");
}
var $aea9cfe515a968fe$export$2e2bcd8739ae039 = new $aea9cfe515a968fe$var$homeView();



class $1ccb006f06379bb4$var$ModalAttributionAudioView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".bird__information__audio__attribution");
    _generateMarkup(data) {
        if (!data.activeBirdId) return "";
        const recordings = data.birds.filter((birds)=>birds.id === data.activeBirdId)[0].recordings;
        const recordingId = data.loadedRecordings[data.availableAudioTypes[data.activeAudioTypeIndex]][data.activeAudioTrackIndex].id;
        const activeRecording = recordings[data.availableAudioTypes[data.activeAudioTypeIndex]].filter((rec)=>rec.id === recordingId)[0];
        // console.log(data.activeAudioTypeIndex)
        // console.log(data.activeAudioTrackIndex)
        // console.log(activeRecording)
        const url = activeRecording.url;
        // console.log(url)
        return `<div class="audio__embed">
      <p>The audio currently playing can be found below. Contact the copyright owner if you wish to use this audio.</p>
      <iframe src='https:${url}/embed?simple=1' scrolling='no' frameborder='0' width='340' height='115'></iframe>
      </div>`;
    }
}
var $1ccb006f06379bb4$export$2e2bcd8739ae039 = new $1ccb006f06379bb4$var$ModalAttributionAudioView();



class $3360a7b22f22e098$var$ModalAttributionImageView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".bird__information__image__attribution");
    image = document.querySelector(".bird__information__image");
    _generateMarkup(bird) {
        return `
        <div class="image__attribution">
            <div class="bird__information__attribution-owner">${bird.image.attribution.artist.replaceAll(/\\/g, "")} ${bird.image.attribution.credit ? bird.image.attribution.credit.replaceAll(/\\/g, "") : ""}</div>
            <div class="bird__information__attribution-licence">
                <a href="${bird.image.attribution.licenseUrl}">${bird.image.attribution.license}</a>
            </div>
        </div>
    `;
    }
}
var $3360a7b22f22e098$export$2e2bcd8739ae039 = new $3360a7b22f22e098$var$ModalAttributionImageView();



class $9cbd59e4757fb1be$var$audioScrollerView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".audio__track__details");
    _errorMessage = "";
    setAnimationVariables() {
        const scroller = document.querySelector(".audio__track__details__scroller__text");
        const scrollerWidth = scroller.scrollWidth;
        const scrollerWidthOffset = scroller.offsetWidth;
        const translateXperc = `${-(scrollerWidth - scrollerWidthOffset)}px`;
        document.documentElement.style.setProperty("--scroll-animation-translateX", translateXperc);
    }
    _generateMarkup() {
        return `
        <p class="audio__track__details__bird">\u{1F426} <span class="track__details__highlight">${this.data.en}</span> &nbsp</p>
        <div class="audio__track__details__scroller"><p class="audio__track__details__scroller__text">Country recorded: <span class="track__details__highlight">${this.data.country}</span> - Location: ${this.data.location ? this.data.location : "?"} \u{1F464} Recorded by: ${this.data.recordist} - <a class="audio__track__details-link track__details__highlight" href="https://${this.data.url}" target=\u{201D}_blank\u{201D}>LINK TO SOURCE</a></p></div>
      `;
    }
}
var $9cbd59e4757fb1be$export$2e2bcd8739ae039 = new $9cbd59e4757fb1be$var$audioScrollerView();




class $3a9017af0c7440d5$var$searchFilterView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".search__filter");
    _overlay = document.querySelector(".overlay");
    _filterBtn = document.querySelector(".filter__btn");
    _filterList = document.querySelector(".filter__list");
    _filterTitleBirds = document.querySelector(".filter__title__birdsection");
    _filterTitleDesc = document.querySelector(".filter__title-description");
    setFilterTitle(title) {
        this._filterTitleDesc.textContent = title;
    }
    hideFilterTitle() {
        this._filterTitleBirds.classList.add("hidden");
    }
    showFilterTitle() {
        this._filterTitleBirds.classList.remove("hidden");
    }
    addHandlerOverlay(handler) {
        this._overlay.addEventListener("click", function(e) {
            handler();
        });
    }
    addHandlerFilterBtn(handler) {
        this._filterBtn.addEventListener("click", function(e) {
            e.preventDefault();
            handler();
        });
    }
    hideFilterList() {
        this._overlay.classList.add("hidden");
        this._filterList.classList.add("hidden");
    }
    showFilterList() {
        this._overlay.classList.remove("hidden");
        this._filterList.classList.remove("hidden");
    }
    addHandlerFilterList(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const item = e.target.closest(".filter__item");
            if (!item) return;
            const value = item.dataset.value;
            const title = item.textContent;
            handler(value, title);
        });
    }
}
var $3a9017af0c7440d5$export$2e2bcd8739ae039 = new $3a9017af0c7440d5$var$searchFilterView();




//////////////////////////////////////////////////////////
// Render the Birds View (helper function)
//////////////////////////////////////////////////////////
const $f50bd1f2915ed0f2$var$renderBirdView = function(data) {
    // Hide the other sections
    (0, $72e7fd3229d050fe$export$2e2bcd8739ae039).hide();
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).hide();
    (0, $aea9cfe515a968fe$export$2e2bcd8739ae039).hide();
    // Show content
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).show();
    // if (model.state.activeMenu !== "favourites") {
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).showFavouritesInstruction();
    // } else {
    //   birdsView.hideFavouritesInstruction();
    // }
    // Render html
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).render(data);
    // Set background colour for active bird
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setActiveBgColour($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId);
    // Add event handlers
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).addHandlerBird($f50bd1f2915ed0f2$var$controlButtonBird);
    // Clear search
    (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).clearSearch();
    // Animate - Expand the bird sections
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).animateHeight();
    // Add image handler last
    setTimeout(()=>{
        (0, $608a634cd55c40cc$export$2e2bcd8739ae039).addHandlerImageLoad($f50bd1f2915ed0f2$var$controlImageLoad);
    }, 300);
};
////////////////////////////////////////////////////////
// LAZY LOADER HANDLER
////////////////////////////////////////////////////////
const $f50bd1f2915ed0f2$var$controlImageLoad = function(birdId, imageId) {
    const birdObject = $0f1d4402dffacf5b$export$615a5fdd1e2537fe(birdId);
    (0, $608a634cd55c40cc$export$2e2bcd8739ae039).renderImage(birdObject, imageId, $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDisableImages);
};
///////////////////////////////////////////////////////
// SEARCH FILTER
///////////////////////////////////////////////////////
const $f50bd1f2915ed0f2$var$controlSearchFilterBtn = function() {
    // console.log("filter");
    (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).showFilterList();
};
const $f50bd1f2915ed0f2$var$controlSearchFilterItem = async function(value, title) {
    // Set filter criteria in state
    $0f1d4402dffacf5b$export$f0692e1c55bfc4f1(value); // *--persist--*
    // set filter results in state
    $0f1d4402dffacf5b$export$e3340ddcfe22553f();
    // Update filter flag/text description
    const searchObject = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search;
    if (searchObject.countryCode2) (0, $813cf99795e9ec97$export$2e2bcd8739ae039).setFilterEmojiFlag(searchObject.countryCode2);
    if (searchObject.regionCode) (0, $813cf99795e9ec97$export$2e2bcd8739ae039).setFilterEmojiGlobe(searchObject.regionCode);
    // hide the filter list
    (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).hideFilterList();
    // set filter title
    (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).setFilterTitle(title);
    // load common birds for the search filter if the page is already common birds
    const id = window.location.hash.slice(1);
    if (id === "common-birds") $f50bd1f2915ed0f2$var$controlButtonPageCommonBirds();
    // Render loading spinner
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).hideFavouritesInstruction();
    $f50bd1f2915ed0f2$var$showCommonBirdsView();
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039)._generateSpinner();
};
///////////////////////////////////////////////////////
// SEARCH
///////////////////////////////////////////////////////
// render the search results list
const $f50bd1f2915ed0f2$var$controlSearchResults = function() {
    // console.log(model.state.search.regionCode);
    // console.log(model.state.search.region);
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.search.regionCode === "ALL") {
        (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).render((0, $c72b185320e6bb41$export$7028c44a8021654a));
        return;
    }
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.search.country === "Worldwide" || $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.country === "Various") {
        (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).render((0, $c72b185320e6bb41$export$7028c44a8021654a).filter((el)=>el.commonRegionCodes.includes($0f1d4402dffacf5b$export$ca000e230c0caa3e.search.regionCode)));
        return;
    }
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.search.country !== "") {
        // console.log(model.state.search.country);
        (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).render((0, $c72b185320e6bb41$export$7028c44a8021654a).filter((el)=>el.commonCountryNames.includes($0f1d4402dffacf5b$export$ca000e230c0caa3e.search.country)));
        return;
    }
};
// render birds view from search query
const $f50bd1f2915ed0f2$var$controlSearchField = async function() {
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setSearch();
    // get the search query from the search field
    const query = (0, $813cf99795e9ec97$export$2e2bcd8739ae039).getQuery();
    // console.log(query);
    // return if no query
    if (!query) return;
    // return array of search results
    const results = $0f1d4402dffacf5b$export$c3c488c05aeea533(query);
    // Set search results in state
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results = results;
    // console.log(model.state.results);
    // Create bird objects
    $0f1d4402dffacf5b$export$c9818fd4c480edd5(results);
    // console.log(model.state.birds);
    const resultsObjects = $0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.filter((bird)=>results.some((res)=>res.name === bird.name));
    // results.map(
    //   (res) => model.state.birds.filter((bird) => bird.name === res.name)[0]
    // );
    // load Wiki API images
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDisableImages === "off") await $0f1d4402dffacf5b$export$8b1633c0f9396e07();
    // hide search results view
    (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).hideSearch();
    // render birds View with search results
    // console.log(resultsObjects);
    $f50bd1f2915ed0f2$var$renderBirdView(resultsObjects);
    // Hide filter title
    (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).hideFilterTitle();
    // Clear the active menu
    $0f1d4402dffacf5b$export$b5153b0da6732e5f("");
};
// Show Common Birds View
const $f50bd1f2915ed0f2$var$showCommonBirdsView = function() {
    (0, $72e7fd3229d050fe$export$2e2bcd8739ae039).hide();
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).hide();
    (0, $aea9cfe515a968fe$export$2e2bcd8739ae039).hide();
    // Show content
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).show();
};
// render birds view from results view clicked item
const $f50bd1f2915ed0f2$var$controlSearchItem = async function(id) {
    (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).hideSearch();
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setSearch();
    const birdSearch = $0f1d4402dffacf5b$export$23555acef75f97cd(id);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results = birdSearch;
    $0f1d4402dffacf5b$export$c9818fd4c480edd5(birdSearch);
    // load Wiki API images
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDisableImages === "off") await $0f1d4402dffacf5b$export$8b1633c0f9396e07();
    const bird = $0f1d4402dffacf5b$export$615a5fdd1e2537fe(id);
    // console.log(bird);
    $f50bd1f2915ed0f2$var$renderBirdView(bird);
    // Hide filter title
    (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).hideFilterTitle();
};
//////////////////////////////////////
// overlay handler - close search
const $f50bd1f2915ed0f2$var$controlOverlay = function() {
    (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).hideSearch();
    (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).hideFilterList();
};
//////////////////////////////////////////////////////////////////
// NAVIGATION MENU
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////
// Nav menu - button handler
const $f50bd1f2915ed0f2$var$controlButtonMenu = function() {
    // rotate menu icon direction
    (0, $43d65efb1d7b78a3$export$2e2bcd8739ae039).renderRotationBtn($0f1d4402dffacf5b$export$ca000e230c0caa3e.menu);
    (0, $43d65efb1d7b78a3$export$2e2bcd8739ae039).clearStyleAnimation();
    // toggle MENU open or closed state
    $0f1d4402dffacf5b$export$c60294ec74f48826();
    // birdsView.setContainerBottomMargin(audioView.getAudioContainerHeight());
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setFooterMargin((0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).getAudioContainerHeight());
};
//////////////////////////////////////////////
// Home Button
const $f50bd1f2915ed0f2$var$controlButtonPageHome = function() {
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).hideFavouritesInstruction();
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).hide();
    (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).hideFilterTitle();
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).hide();
    (0, $72e7fd3229d050fe$export$2e2bcd8739ae039).hide();
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setTitle("Home");
    (0, $aea9cfe515a968fe$export$2e2bcd8739ae039).show();
    $0f1d4402dffacf5b$export$b5153b0da6732e5f("home");
};
/////////////////////////////////////////////////////////
// Menu - Common birds View handler
const $f50bd1f2915ed0f2$var$controlButtonPageCommonBirds = async function() {
    try {
        // console.log("CPCB");
        $0f1d4402dffacf5b$export$e3340ddcfe22553f();
        // create all bird objects
        $0f1d4402dffacf5b$export$52aab5b30cfda272();
        // console.log("call images api");
        // load Wiki API images
        if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDisableImages === "off") await $0f1d4402dffacf5b$export$8b1633c0f9396e07();
        // console.log("finish images api");
        // Update the active menu
        $0f1d4402dffacf5b$export$b5153b0da6732e5f("common birds");
        // Render birds view
        // console.log(model.getFilteredBirdObjects());
        $f50bd1f2915ed0f2$var$renderBirdView($0f1d4402dffacf5b$export$284d082295e21ee8());
        (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).showFilterTitle();
        //
        (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setTitle("Common Birds");
    } catch (err) {
        console.error(err);
    }
};
//////////////////////////////////////////////
// Menu - Favourites View Handler
const $f50bd1f2915ed0f2$var$controlButtonPageFavourites = async function() {
    // Hide menu
    // menuView.renderRotation(model.state.menu);
    // controlButtonMenu()
    // console.log("favourites");
    //
    // update state favourites
    // model.populateFavouritesArray();
    $0f1d4402dffacf5b$export$c64e21c9e37cd760();
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDisableImages === "off") await $0f1d4402dffacf5b$export$8b1633c0f9396e07();
    // update the active menu
    $0f1d4402dffacf5b$export$b5153b0da6732e5f("favourites");
    // render favourites
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setTitle("Favourites");
    $f50bd1f2915ed0f2$var$renderBirdView($0f1d4402dffacf5b$export$ca000e230c0caa3e.birds.filter((bird)=>$0f1d4402dffacf5b$export$ca000e230c0caa3e.favourites.includes(bird.id)));
    (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).hideFilterTitle();
// model.setSearchParamsWorldwide();
};
//////////////////////////////////////////////
// Menu - Settings
const $f50bd1f2915ed0f2$var$controlButtonPageSettings = function() {
    // hide menu
    // menuView.renderRotation(model.state.menu);
    //
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).hideFavouritesInstruction();
    (0, $aea9cfe515a968fe$export$2e2bcd8739ae039).hide();
    (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).hideFilterTitle();
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).hide();
    (0, $72e7fd3229d050fe$export$2e2bcd8739ae039).hide();
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setTitle("Settings");
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).show();
    $0f1d4402dffacf5b$export$b5153b0da6732e5f("settings");
};
//////////////////////////////////////////////
// Menu - Contact
const $f50bd1f2915ed0f2$var$controlButtonPageContact = function() {
    // hide menu
    // menuView.renderRotation(model.state.menu);
    //
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).hideFavouritesInstruction();
    (0, $aea9cfe515a968fe$export$2e2bcd8739ae039).hide();
    (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).hideFilterTitle();
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).hide();
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).hide();
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setTitle("Contact");
    (0, $72e7fd3229d050fe$export$2e2bcd8739ae039).show();
    $0f1d4402dffacf5b$export$b5153b0da6732e5f("contact");
};
////////////////////////////////////////////////////
// Nav menu load page
//
const $f50bd1f2915ed0f2$var$controlPageLoad = async function() {
    //
    const id = window.location.hash.slice(1);
    (0, $43d65efb1d7b78a3$export$2e2bcd8739ae039).animateNavItem(`nav-${id}`);
    //
    setTimeout(()=>{
        // console.log("timeout function");
        (0, $43d65efb1d7b78a3$export$2e2bcd8739ae039).renderRotation("open");
        const orientation = (0, $43d65efb1d7b78a3$export$2e2bcd8739ae039).getWindowOrientation();
        if (orientation !== "landscape-primary") $0f1d4402dffacf5b$export$ca000e230c0caa3e.menu = "closed";
    }, 250);
    //
    setTimeout(()=>{
        if (id === "home") $f50bd1f2915ed0f2$var$controlButtonPageHome();
        if (id === "common-birds") $f50bd1f2915ed0f2$var$controlButtonPageCommonBirds();
        if (id === "favourites") $f50bd1f2915ed0f2$var$controlButtonPageFavourites();
        if (id === "settings") $f50bd1f2915ed0f2$var$controlButtonPageSettings();
        if (id === "contact") $f50bd1f2915ed0f2$var$controlButtonPageContact();
        // scroll to the top of the content container
        (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).scrollUp();
    }, 250);
//
};
/////////////////////////////////////////////////////////////////////////////////////////////
// BIRDS VIEW
/////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////
// Birdsview - Bird Handler. This handler is assigned to every 'bird' item in the bird view list
// params:
// birdId = bird id,
// type = action type/where clicked (favourite, audio, image)
//
const $f50bd1f2915ed0f2$var$controlButtonBird = async function(birdId = "", type = "") {
    try {
        /////////////////////////////////////////
        // worm - favourite
        /////////////////////////////////////////
        if (type === "favourite") {
            // toggle worm colour & state favourites
            if (birdId) {
                (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).toggleWorm(birdId, $0f1d4402dffacf5b$export$ca000e230c0caa3e.favourites);
                $0f1d4402dffacf5b$export$6fc24917af7d4aaa(birdId);
            }
            // If the active menu is favourites, hide the bird from the birds view
            if (birdId && $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeMenu === "favourites") (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).hideBird(birdId);
        }
        //////////////////////////////////////
        // image - info modal
        //////////////////////////////////////
        if (type === "image") {
            // Load the image metadata
            if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDisableImages === "off") await $0f1d4402dffacf5b$export$af0c6ae8e472b57c(birdId);
            const bird = $0f1d4402dffacf5b$export$615a5fdd1e2537fe(birdId);
            // generate attribution markup
            (0, $3360a7b22f22e098$export$2e2bcd8739ae039).render(bird[0]);
            (0, $1ccb006f06379bb4$export$2e2bcd8739ae039).clear();
            // set image source
            (0, $918422351536181a$export$2e2bcd8739ae039).setImageSource(bird[0].image.src, $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDisableImages);
            // show modal
            (0, $918422351536181a$export$2e2bcd8739ae039).showBirdInfo();
        }
        /////////////////////////////////////
        // audio - click to play
        /////////////////////////////////////
        if (type === "audio") {
            // if audio currently loading, return
            if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.xenoLoading) return;
            const bird = $0f1d4402dffacf5b$export$615a5fdd1e2537fe(birdId);
            if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId === bird.id) return;
            // pause audio
            (0, $530ac4ef5a98d8b4$export$2e2bcd8739ae039).pauseAudio();
            // reset audio loaded state param
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.xenoLoaded = false;
            // if there is an active bird then clear the active background colour
            if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId) (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).resetBgColour($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId);
            // set new active bird
            $0f1d4402dffacf5b$export$498616224de3edb7(birdId);
            (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setActiveBgColour(birdId);
            // hide audio controls
            (0, $9cbd59e4757fb1be$export$2e2bcd8739ae039).hide();
            (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).hideControls();
            (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).hideSoundwave();
            (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).hideOverlay();
            (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).likeBtnColour("grey");
            // call xeno canto api
            await $0f1d4402dffacf5b$export$284c42d23d05773e(birdId);
            // show audio controls
            (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).showControls();
            // get first available audio data from the state
            const audio = $0f1d4402dffacf5b$export$42a415fa23cad438(birdId);
            // add audio data to the audio player
            if (audio) {
                $0f1d4402dffacf5b$export$ca000e230c0caa3e.xenoLoaded = true;
                (0, $530ac4ef5a98d8b4$export$2e2bcd8739ae039).render(audio);
            }
            if (!audio) {
                (0, $530ac4ef5a98d8b4$export$2e2bcd8739ae039).renderError();
                (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).hideSelectorContainer();
                return;
            }
            // console.log(audio);
            (0, $9cbd59e4757fb1be$export$2e2bcd8739ae039).render(audio);
            (0, $9cbd59e4757fb1be$export$2e2bcd8739ae039).show();
            (0, $9cbd59e4757fb1be$export$2e2bcd8739ae039).setAnimationVariables();
            // console.log(model.getBird(birdId));
            // rest state audio selectors
            $0f1d4402dffacf5b$export$c546da718ba66399();
            // Render audio selectors
            (0, $0c79bc6496e30432$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.availableAudioTypes);
            (0, $0c79bc6496e30432$export$2e2bcd8739ae039).setCurrentSlide(0);
            (0, $9c6cd7cf954bccba$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
            // set audio event handlers
            (0, $530ac4ef5a98d8b4$export$2e2bcd8739ae039).addHandlerAudioEnded($f50bd1f2915ed0f2$var$controlAudioEnded);
            (0, $530ac4ef5a98d8b4$export$2e2bcd8739ae039).addHandlerAudioPlay($f50bd1f2915ed0f2$var$controlAudioPlay);
            // like button colour
            $f50bd1f2915ed0f2$var$controlLikeButtonColour();
            // set container margin
            // birdsView.setContainerBottomMargin(audioView.getAudioContainerHeight());
            (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setFooterMargin((0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).getAudioContainerHeight());
        }
    } catch (err) {
        throw err;
    }
};
const $f50bd1f2915ed0f2$var$controlAudioEnded = function() {
    (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).pauseSoundwave();
};
const $f50bd1f2915ed0f2$var$controlAudioPlay = function() {
    (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).playSoundwave();
};
//////////////////////////////////////////////////////////
// BIRD - AUDIO INFO VIEW MODAL
///////////////////////////////////////////////////////////
const $f50bd1f2915ed0f2$var$controlAudioInfoBtn = async function() {
    // if no active bird or loaded audio, return
    if (!$0f1d4402dffacf5b$export$ca000e230c0caa3e.xenoLoaded) return;
    if (!$0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId) return;
    // load images
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDisableImages === "off") await $0f1d4402dffacf5b$export$af0c6ae8e472b57c($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId);
    // get bird object
    const bird = $0f1d4402dffacf5b$export$615a5fdd1e2537fe($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId);
    // generate attribution markup
    (0, $3360a7b22f22e098$export$2e2bcd8739ae039).render(bird[0]);
    (0, $1ccb006f06379bb4$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
    // set image source
    (0, $918422351536181a$export$2e2bcd8739ae039).setImageSource(bird[0].image.src, $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDisableImages);
    // show modal
    (0, $918422351536181a$export$2e2bcd8739ae039).showBirdInfo();
};
//////////////////////////////////////////////////////////
// AUDIO LIKE BUTTON
///////////////////////////////////////////////////////////
const $f50bd1f2915ed0f2$var$controlAudioLikeBtn = function() {
    const activeBird = $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId;
    if (!activeBird) return;
    $0f1d4402dffacf5b$export$26b30b22eb258808();
    $f50bd1f2915ed0f2$var$controlLikeButtonColour();
};
const $f50bd1f2915ed0f2$var$controlLikeButtonColour = function() {
    const recording = $0f1d4402dffacf5b$export$31fcea2bd3618144();
    // console.log(recording);
    const liked = recording.liked;
    // console.log(liked);
    if (liked) (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).likeBtnColour("red");
    if (!liked) (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).likeBtnColour("grey");
};
///////////////////////////////////////////////////////////
// AUDIO VIEW
///////////////////////////////////////////////////////////
// Render selected Audio
const $f50bd1f2915ed0f2$var$controlAudioViewSelectBtn = function() {
    // get selected data
    const audio = $0f1d4402dffacf5b$export$799125d37819de4a();
    // render in audio controls view
    if (audio) {
        (0, $9cbd59e4757fb1be$export$2e2bcd8739ae039).hide();
        (0, $530ac4ef5a98d8b4$export$2e2bcd8739ae039).render(audio);
        (0, $9cbd59e4757fb1be$export$2e2bcd8739ae039).render(audio);
        (0, $9cbd59e4757fb1be$export$2e2bcd8739ae039).show();
        (0, $9cbd59e4757fb1be$export$2e2bcd8739ae039).setAnimationVariables();
        (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).hideSelectButton();
        (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).showSoundwave();
        $0f1d4402dffacf5b$export$8824299e6979daba();
    }
    $f50bd1f2915ed0f2$var$controlLikeButtonColour();
    // set audio event handlers
    (0, $530ac4ef5a98d8b4$export$2e2bcd8739ae039).addHandlerAudioEnded($f50bd1f2915ed0f2$var$controlAudioEnded);
    (0, $530ac4ef5a98d8b4$export$2e2bcd8739ae039).addHandlerAudioPlay($f50bd1f2915ed0f2$var$controlAudioPlay);
};
// handler for Audio Type
const $f50bd1f2915ed0f2$var$controlTypeSelector = function(index) {
    $0f1d4402dffacf5b$export$3cb8948afa7dd2b(index);
    $0f1d4402dffacf5b$export$ff826b15a132fd07();
    (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).hideSoundwave();
    (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).showSelectButton();
    (0, $9c6cd7cf954bccba$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e);
};
// handler for Audio Track
const $f50bd1f2915ed0f2$var$controlTrackSelector = function(index) {
    $0f1d4402dffacf5b$export$27423439b6d37782(index);
    (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).hideSoundwave();
    (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).showSelectButton();
    (0, $9c6cd7cf954bccba$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e);
};
//////////////////////////////////////////////////////////////
// WINDOW ORIENTATION CSS
//////////////////////////////////////////////////////////////
// handler for setting the type selector width
const $f50bd1f2915ed0f2$var$controlOrientation = function() {
    (0, $0c79bc6496e30432$export$2e2bcd8739ae039).setContainerWidth($0f1d4402dffacf5b$export$ca000e230c0caa3e.availableAudioTypes);
    // birdsView.setContainerBottomMargin(audioView.getAudioContainerHeight());
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setFooterMargin((0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).getAudioContainerHeight());
    (0, $43d65efb1d7b78a3$export$2e2bcd8739ae039).orientationSettings();
};
//////////////////////////////////////////////////////////////
// SETTINGS VIEW
//////////////////////////////////////////////////////////////
// Page load - set stored colour settings
const $f50bd1f2915ed0f2$var$controlThemeState = function() {
    const colour = (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).getColourValue();
    const contrast = (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).getContrastValue();
    const brightness = (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).getBrightnessValue();
    $0f1d4402dffacf5b$export$373af51b3e7e3bb8(colour, contrast, brightness);
};
// Colours handler
const $f50bd1f2915ed0f2$var$controlThemeColour = function() {
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).setColourValue();
    $f50bd1f2915ed0f2$var$controlThemeState();
};
// REFACTOR....................................................................
// liked audio Handler
const $f50bd1f2915ed0f2$var$controlSettingLikedAudio = function() {
    // set setting state
    $0f1d4402dffacf5b$export$5ed1960bc888cd48();
    const birdId = $0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId;
    // if active bird
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.activeBirdId !== "" && $0f1d4402dffacf5b$export$ca000e230c0caa3e.xenoLoading === false) {
        // set recording object in the model
        $0f1d4402dffacf5b$export$e9f0a571a9559e03();
        //
        //
        // re-render tracks
        // get first available audio data from the state
        const audio = $0f1d4402dffacf5b$export$42a415fa23cad438(birdId);
        // add audio data to the audio player
        if (audio) (0, $530ac4ef5a98d8b4$export$2e2bcd8739ae039).render(audio);
        if (!audio) {
            (0, $530ac4ef5a98d8b4$export$2e2bcd8739ae039).renderError();
            (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).hideSelectorContainer();
            return;
        }
        (0, $9cbd59e4757fb1be$export$2e2bcd8739ae039).render(audio);
        (0, $9cbd59e4757fb1be$export$2e2bcd8739ae039).show();
        (0, $9cbd59e4757fb1be$export$2e2bcd8739ae039).setAnimationVariables();
        // console.log(model.getBird(birdId));
        // rest state audio selectors
        $0f1d4402dffacf5b$export$c546da718ba66399();
        // Render audio selectors
        (0, $0c79bc6496e30432$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.availableAudioTypes);
        (0, $0c79bc6496e30432$export$2e2bcd8739ae039).setCurrentSlide(0);
        (0, $9c6cd7cf954bccba$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
        (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).showSelectorContainer();
        (0, $0c79bc6496e30432$export$2e2bcd8739ae039).setContainerWidth($0f1d4402dffacf5b$export$ca000e230c0caa3e.availableAudioTypes);
        // set audio event handlers
        (0, $530ac4ef5a98d8b4$export$2e2bcd8739ae039).addHandlerAudioEnded($f50bd1f2915ed0f2$var$controlAudioEnded);
        (0, $530ac4ef5a98d8b4$export$2e2bcd8739ae039).addHandlerAudioPlay($f50bd1f2915ed0f2$var$controlAudioPlay);
        // like button colour
        $f50bd1f2915ed0f2$var$controlLikeButtonColour();
        // set container margin
        // birdsView.setContainerBottomMargin(audioView.getAudioContainerHeight());
        (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setFooterMargin((0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).getAudioContainerHeight());
    }
};
// dark mode Handler
const $f50bd1f2915ed0f2$var$controlSettingDarkMode = function() {
    $0f1d4402dffacf5b$export$aa3f99f4819f774f();
    const value = $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDarkMode;
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).darkMode(value);
};
// disable images handler
const $f50bd1f2915ed0f2$var$controlSettingDisableImages = function() {
    $0f1d4402dffacf5b$export$7ab3a2e0ec2a6b17();
    const value = $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDisableImages;
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).setDisableImagesValue(value);
};
const $f50bd1f2915ed0f2$var$controlSettingTheme = function(theme) {
    // console.log(theme);
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.settingDarkMode === "on") {
        $0f1d4402dffacf5b$export$aa3f99f4819f774f();
        (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).darkMode("off");
    }
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).setThemeBtnBackgrounds(theme);
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).setTheme((0, $ba30e20475feac5a$export$ce0e5beb5efeb79)[theme]);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.settings.theme = theme;
};
// accessible colours handler
// const controlSettingAccessibilityColours = function () {
//   model.toggleSettingAccessibilityColours();
//   const value = model.state.settings.settingAccessibilityColours;
//   settingsView.setAccessibilityColours(value);
// };
//////////////////////////////////////////////////////////////////
// INIT
//////////////////////////////////////////////////////////////////
const $f50bd1f2915ed0f2$var$init = function() {
    // model.searchFilter();
    const faves = (0, $c72b185320e6bb41$export$7028c44a8021654a).filter((bird)=>$0f1d4402dffacf5b$export$ca000e230c0caa3e.favourites.includes(bird.id));
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results = faves;
    $0f1d4402dffacf5b$export$52aab5b30cfda272();
    (0, $43d65efb1d7b78a3$export$2e2bcd8739ae039).addHandlerMenuButton($f50bd1f2915ed0f2$var$controlButtonMenu);
    (0, $43d65efb1d7b78a3$export$2e2bcd8739ae039).addHandlerNavigation($f50bd1f2915ed0f2$var$controlPageLoad);
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).addHandlerBird($f50bd1f2915ed0f2$var$controlButtonBird);
    (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).addHandlerSearchResults($f50bd1f2915ed0f2$var$controlSearchResults);
    (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).addHandlerOverlay($f50bd1f2915ed0f2$var$controlOverlay);
    (0, $e3a3f6f0893f424b$export$2e2bcd8739ae039).addHandlerSearchItem($f50bd1f2915ed0f2$var$controlSearchItem);
    (0, $813cf99795e9ec97$export$2e2bcd8739ae039).addHandlerSearch($f50bd1f2915ed0f2$var$controlSearchField);
    (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).addHandlerFilterBtn($f50bd1f2915ed0f2$var$controlSearchFilterBtn);
    (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).addHandlerFilterList($f50bd1f2915ed0f2$var$controlSearchFilterItem);
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).storageSettings($0f1d4402dffacf5b$export$ca000e230c0caa3e.settings);
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).addHandlerSliderColour($f50bd1f2915ed0f2$var$controlThemeColour);
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).addHandlerSliderContrast($f50bd1f2915ed0f2$var$controlThemeColour);
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).addHandlerSliderBrightness($f50bd1f2915ed0f2$var$controlThemeColour);
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).addHandlerSettingLikedAudio($f50bd1f2915ed0f2$var$controlSettingLikedAudio);
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).addHandlerSettingDarkMode($f50bd1f2915ed0f2$var$controlSettingDarkMode);
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).addHandlerSettingDisableImages($f50bd1f2915ed0f2$var$controlSettingDisableImages);
    (0, $4c22adf96f0377b2$export$2e2bcd8739ae039).addHandlerThemeBtns($f50bd1f2915ed0f2$var$controlSettingTheme);
    // settingsView.addHandlerSettingAccessibilityColours(
    //   controlSettingAccessibilityColours
    // );
    (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).addHandlerSelectBtn($f50bd1f2915ed0f2$var$controlAudioViewSelectBtn);
    (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).addHandlerinfoBtn($f50bd1f2915ed0f2$var$controlAudioInfoBtn);
    (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).addHandlerLikeBtn($f50bd1f2915ed0f2$var$controlAudioLikeBtn);
    (0, $0c79bc6496e30432$export$2e2bcd8739ae039).addHandlerNextType($f50bd1f2915ed0f2$var$controlTypeSelector);
    (0, $0c79bc6496e30432$export$2e2bcd8739ae039).addHandlerPrevType($f50bd1f2915ed0f2$var$controlTypeSelector);
    (0, $0c79bc6496e30432$export$2e2bcd8739ae039).addHandlerOrientation($f50bd1f2915ed0f2$var$controlOrientation);
    (0, $9c6cd7cf954bccba$export$2e2bcd8739ae039).addHandlerNextTrack($f50bd1f2915ed0f2$var$controlTrackSelector);
    (0, $9c6cd7cf954bccba$export$2e2bcd8739ae039).addHandlerPrevTrack($f50bd1f2915ed0f2$var$controlTrackSelector);
    (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).hideSoundwave();
    (0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).likeBtnColour("grey");
    // audioView.showOverlay();
    // orientation checkers
    (0, $43d65efb1d7b78a3$export$2e2bcd8739ae039).orientationSettings();
    (0, $3cc7bc34fb92989e$export$2e2bcd8739ae039).setFooterMargin((0, $eb9a509ced8bdde6$export$2e2bcd8739ae039).getAudioContainerHeight());
    // location
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.search.countryCode2) (0, $813cf99795e9ec97$export$2e2bcd8739ae039).setFilterEmojiFlag($0f1d4402dffacf5b$export$ca000e230c0caa3e.search.countryCode2);
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.search.regionCode) (0, $813cf99795e9ec97$export$2e2bcd8739ae039).setFilterEmojiGlobe($0f1d4402dffacf5b$export$ca000e230c0caa3e.search.regionCode);
    (0, $3a9017af0c7440d5$export$2e2bcd8739ae039).setFilterTitle($0f1d4402dffacf5b$export$ca000e230c0caa3e.search.country);
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.da7c3ac7.js.map
